
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired4d2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired4d2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cmoHh", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(" ");
        me.s1 = mash(" ");
        me.s2 = mash(" ");
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("euRi5", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("hDsEw", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("3J2Zm", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = "" + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("6Px8M", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + "\0";
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("lDm0S", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = "";
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == "object") copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == "function" && define // present with an AMD loader
);

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

function $91201f5d84ae2499$export$19de0130f5adf0ae(gl, url, smoothScaling = false) {
    return new Promise((resolve)=>{
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // Because images have to be downloaded over the internet
        // they might take a moment until they are ready.
        // Until then put a single pixel in the texture so we can
        // use it immediately. When the image has finished downloading
        // we'll update the texture with the contents of the image.
        const level = 0;
        const internalFormat = gl.RGBA;
        const width = 1;
        const height = 1;
        const border = 0;
        const srcFormat = gl.RGBA;
        const srcType = gl.UNSIGNED_BYTE;
        const pixel = new Uint8Array([
            0,
            0,
            255,
            255
        ]) // opaque blue
        ;
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, srcFormat, srcType, pixel);
        const image = new Image();
        image.onload = ()=>{
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, srcFormat, srcType, image);
            // WebGL1 has different requirements for power of 2 images
            // vs. non power of 2 images so check if the image is a
            // power of 2 in both dimensions.
            if ($91201f5d84ae2499$var$isPowerOf2(image.width) && $91201f5d84ae2499$var$isPowerOf2(image.height)) // Yes, it's a power of 2. Generate mips.
            gl.generateMipmap(gl.TEXTURE_2D);
            else {
                // No, it's not a power of 2. Turn off mips and set
                // wrapping to clamp to edge
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                if (smoothScaling) gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                else {
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
                    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
                }
            }
            resolve({
                handle: texture,
                width: image.width,
                height: image.height
            });
        };
        image.src = url;
    });
}
function $91201f5d84ae2499$var$isPowerOf2(value) {
    return (value & value - 1) === 0;
}


function $523e85573fbedc7e$var$createSingleAudioPlayer(path) {
    return new Promise((resolve)=>{
        const player = new Audio(path);
        player.addEventListener("canplaythrough", ()=>resolve(player), false);
    });
}
async function $523e85573fbedc7e$var$createAudioPlayer(path) {
    const players = [];
    for(let i = 0; i < 4; i++)players.push(await $523e85573fbedc7e$var$createSingleAudioPlayer(path));
    let currentIndex = 0;
    return function(volume = 1.0) {
        players[currentIndex].volume = volume;
        players[currentIndex].play();
        currentIndex++;
        if (currentIndex >= players.length) currentIndex = 0;
    };
}
async function $523e85573fbedc7e$export$6857af9612b3890d() {
    return {
        bootUp: await $523e85573fbedc7e$var$createAudioPlayer("audio/BBC Boot Sound.mp3")
    };
}


function $83408d210e1d239b$var$createRenderingModel(gl, positions, indices, normals, colors) {
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([]), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        objectIdColor: null,
        objectInfo: null,
        additionalObjectInfo: null,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: textureCoordBuffer,
        texture: null
    };
}
async function $83408d210e1d239b$export$5346a9a50160d261(gl, name) {
    const response = await fetch(`voxels/${name}.json`);
    const voxelFile = await response.json();
    return {
        width: voxelFile.width,
        height: voxelFile.height,
        depth: voxelFile.depth,
        voxelCount: voxelFile.voxelCount,
        chunkSize: voxelFile.chunkSize,
        renderingModels: voxelFile.chunks.map((c)=>$83408d210e1d239b$var$createRenderingModel(gl, c.positions, c.indices, c.normals, c.colors))
    };
}


async function $899aa7500e099a06$var$loadShaderSource(name) {
    const fragResponse = await fetch(`shaders/${name}.frag`);
    const vertResponse = await fetch(`shaders/${name}.vert`);
    return {
        frag: await fragResponse.text(),
        vert: await vertResponse.text()
    };
}
async function $899aa7500e099a06$export$d3d08d944062d7e(gl) {
    const shaderNames = [
        "uColor",
        "text",
        "simpleTexture",
        "crt",
        "ambercrt",
        "greencrt",
        "vcr",
        "motionblur",
        "directional",
        "objectPicking",
        "building",
        "water"
    ];
    const guiTextureNames = [
        "road",
        "bulldozer",
        "pause",
        "singlespeed",
        "doublespeed",
        "zones",
        "xmark",
        "lightResidentialZone",
        "denseResidentialZone",
        "lightCommercialZone",
        "denseCommercialZone",
        "lightIndustrialZone",
        "denseIndustrialZone",
        "lowerTerrain",
        "raiseTerrain",
        "dezone",
        "clearTerrain",
        "power",
        "powerLine",
        "coalPowerPlant",
        "gasPowerPlant",
        "nuclearPowerPlant",
        "solarPowerPlant",
        "windTurbine",
        "info",
        "layers",
        "whiteLayers",
        "whiteBuildings",
        "whiteElectric",
        "whiteZones"
    ];
    const textureNames = [
        "grass",
        "dirt",
        "font",
        "noise",
        "landscape"
    ];
    const buildingNames = [
        "smallHouse1",
        "coalPower",
        "sphere",
        "powerLineCrossRoads",
        "powerLineEastT",
        "powerLineEastWest",
        "powerLineNorthEast",
        "powerLineNorthSouth",
        "powerLineNorthT",
        "powerLineNorthWest",
        "powerLineSouthEast",
        "powerLineSouthT",
        "powerLineSouthWest",
        "powerLineWestT",
        "powerLineRoadEastWest",
        "powerLineRoadNorthSouth",
        "smallChemicalStorage"
    ];
    const loadedBuildings = await Promise.all(buildingNames.map((bn)=>(0, $83408d210e1d239b$export$5346a9a50160d261)(gl, bn)));
    const buildingsMap = new Map(loadedBuildings.map((vm, i)=>[
            buildingNames[i],
            vm
        ]));
    const loadedShaders = await Promise.all(shaderNames.map((sn)=>$899aa7500e099a06$var$loadShaderSource(sn)));
    const namedShaders = new Map(shaderNames.map((sn, index)=>[
            sn,
            loadedShaders[index]
        ]));
    const loadedTextures = await Promise.all(textureNames.map((tn)=>(0, $91201f5d84ae2499$export$19de0130f5adf0ae)(gl, `./${tn}.png`)));
    const textures = new Map(loadedTextures.map((t, i)=>[
            textureNames[i],
            t
        ]));
    let guiTextureObj = {};
    const guiTextures = await Promise.all(guiTextureNames.map((tn)=>(0, $91201f5d84ae2499$export$19de0130f5adf0ae)(gl, `./gui/${tn}.png`)));
    guiTextures.forEach((t, i)=>guiTextureObj[guiTextureNames[i]] = t);
    return {
        textures: {
            grass: textures.get("grass"),
            dirt: textures.get("dirt"),
            font: textures.get("font"),
            noise: textures.get("noise"),
            landscape: textures.get("landscape")
        },
        guiTextures: guiTextureObj,
        shaderSource: {
            uColor: namedShaders.get("uColor"),
            text: namedShaders.get("text"),
            simpleTexture: namedShaders.get("simpleTexture"),
            crt: namedShaders.get("crt"),
            amberCrt: namedShaders.get("ambercrt"),
            greenCrt: namedShaders.get("greencrt"),
            vcr: namedShaders.get("vcr"),
            motionBlur: namedShaders.get("motionblur"),
            directional: namedShaders.get("directional"),
            objectPicking: namedShaders.get("objectPicking"),
            building: namedShaders.get("building"),
            water: namedShaders.get("water")
        },
        soundEffects: await (0, $523e85573fbedc7e$export$6857af9612b3890d)(),
        voxelModels: {
            residential: {
                house: buildingsMap.get("smallHouse1")
            },
            power: {
                coal: buildingsMap.get("coalPower"),
                powerLineCrossRoads: buildingsMap.get("powerLineCrossRoads"),
                powerLineEastT: buildingsMap.get("powerLineEastT"),
                powerLineEastWest: buildingsMap.get("powerLineEastWest"),
                powerLineNorthEast: buildingsMap.get("powerLineNorthEast"),
                powerLineNorthSouth: buildingsMap.get("powerLineNorthSouth"),
                powerLineNorthT: buildingsMap.get("powerLineNorthT"),
                powerLineNorthWest: buildingsMap.get("powerLineNorthWest"),
                powerLineSouthEast: buildingsMap.get("powerLineSouthEast"),
                powerLineSouthT: buildingsMap.get("powerLineSouthT"),
                powerLineSouthWest: buildingsMap.get("powerLineSouthWest"),
                powerLineWestT: buildingsMap.get("powerLineWestT"),
                powerLineRoadNorthSouth: buildingsMap.get("powerLineRoadNorthSouth"),
                powerLineRoadEastWest: buildingsMap.get("powerLineRoadEastWest")
            },
            industrial: {
                smallChemicalStorage: buildingsMap.get("smallChemicalStorage")
            },
            misc: {
                sphere: buildingsMap.get("sphere")
            }
        }
    };
}


var $26675c4f95835ef1$exports = {};

$parcel$export($26675c4f95835ef1$exports, "create", () => $26675c4f95835ef1$export$185802fd694ee1f5);
$parcel$export($26675c4f95835ef1$exports, "clone", () => $26675c4f95835ef1$export$9cd59f9826255e47);
$parcel$export($26675c4f95835ef1$exports, "copy", () => $26675c4f95835ef1$export$784d13d8ee351f07);
$parcel$export($26675c4f95835ef1$exports, "fromValues", () => $26675c4f95835ef1$export$a82be99ed2a44a7d);
$parcel$export($26675c4f95835ef1$exports, "set", () => $26675c4f95835ef1$export$adaa4cf7ef1b65be);
$parcel$export($26675c4f95835ef1$exports, "identity", () => $26675c4f95835ef1$export$f0954fd7d5368655);
$parcel$export($26675c4f95835ef1$exports, "transpose", () => $26675c4f95835ef1$export$9cb09a71b7d66923);
$parcel$export($26675c4f95835ef1$exports, "invert", () => $26675c4f95835ef1$export$6897c284b6f9f4dc);
$parcel$export($26675c4f95835ef1$exports, "adjoint", () => $26675c4f95835ef1$export$33f3c024b4ae00a1);
$parcel$export($26675c4f95835ef1$exports, "determinant", () => $26675c4f95835ef1$export$a04698f914c55ed9);
$parcel$export($26675c4f95835ef1$exports, "multiply", () => $26675c4f95835ef1$export$2060d2db72cce88f);
$parcel$export($26675c4f95835ef1$exports, "translate", () => $26675c4f95835ef1$export$d73ee8ef04f5226a);
$parcel$export($26675c4f95835ef1$exports, "scale", () => $26675c4f95835ef1$export$dcdf75081b88279d);
$parcel$export($26675c4f95835ef1$exports, "rotate", () => $26675c4f95835ef1$export$bb628a54ab399bc9);
$parcel$export($26675c4f95835ef1$exports, "rotateX", () => $26675c4f95835ef1$export$a59c8716592e09af);
$parcel$export($26675c4f95835ef1$exports, "rotateY", () => $26675c4f95835ef1$export$cf71e4d4ca4d1cfd);
$parcel$export($26675c4f95835ef1$exports, "rotateZ", () => $26675c4f95835ef1$export$ea6eae3365de5b9c);
$parcel$export($26675c4f95835ef1$exports, "fromTranslation", () => $26675c4f95835ef1$export$bc9e79e74e9fddf6);
$parcel$export($26675c4f95835ef1$exports, "fromScaling", () => $26675c4f95835ef1$export$832ca188ffb1955d);
$parcel$export($26675c4f95835ef1$exports, "fromRotation", () => $26675c4f95835ef1$export$926fc125ff3c666c);
$parcel$export($26675c4f95835ef1$exports, "fromXRotation", () => $26675c4f95835ef1$export$dd47cc2f828c32ef);
$parcel$export($26675c4f95835ef1$exports, "fromYRotation", () => $26675c4f95835ef1$export$7dc997d67d2b7f33);
$parcel$export($26675c4f95835ef1$exports, "fromZRotation", () => $26675c4f95835ef1$export$ad5ddaedc8f405df);
$parcel$export($26675c4f95835ef1$exports, "fromRotationTranslation", () => $26675c4f95835ef1$export$9545ac307f2a256b);
$parcel$export($26675c4f95835ef1$exports, "fromQuat2", () => $26675c4f95835ef1$export$ff497f2be31cc6a);
$parcel$export($26675c4f95835ef1$exports, "getTranslation", () => $26675c4f95835ef1$export$202e99f82f7f0395);
$parcel$export($26675c4f95835ef1$exports, "getScaling", () => $26675c4f95835ef1$export$71dc54d92bd04b57);
$parcel$export($26675c4f95835ef1$exports, "getRotation", () => $26675c4f95835ef1$export$df3937d3b537df0a);
$parcel$export($26675c4f95835ef1$exports, "fromRotationTranslationScale", () => $26675c4f95835ef1$export$ddf9c55c9f2be172);
$parcel$export($26675c4f95835ef1$exports, "fromRotationTranslationScaleOrigin", () => $26675c4f95835ef1$export$1def1f860edc4b1f);
$parcel$export($26675c4f95835ef1$exports, "fromQuat", () => $26675c4f95835ef1$export$2ff2bbe382249af7);
$parcel$export($26675c4f95835ef1$exports, "frustum", () => $26675c4f95835ef1$export$89b5708c387cac6c);
$parcel$export($26675c4f95835ef1$exports, "perspectiveNO", () => $26675c4f95835ef1$export$4cf19729ec9a96b8);
$parcel$export($26675c4f95835ef1$exports, "perspective", () => $26675c4f95835ef1$export$541149539f3a4684);
$parcel$export($26675c4f95835ef1$exports, "perspectiveZO", () => $26675c4f95835ef1$export$294bba99a6af0c0c);
$parcel$export($26675c4f95835ef1$exports, "perspectiveFromFieldOfView", () => $26675c4f95835ef1$export$58ae211c788e338f);
$parcel$export($26675c4f95835ef1$exports, "orthoNO", () => $26675c4f95835ef1$export$c5f65ef3eb668f27);
$parcel$export($26675c4f95835ef1$exports, "ortho", () => $26675c4f95835ef1$export$4f2167e613cfc87b);
$parcel$export($26675c4f95835ef1$exports, "orthoZO", () => $26675c4f95835ef1$export$b1d31ea7b4d854e);
$parcel$export($26675c4f95835ef1$exports, "lookAt", () => $26675c4f95835ef1$export$d924e14fd6d9aa66);
$parcel$export($26675c4f95835ef1$exports, "targetTo", () => $26675c4f95835ef1$export$aa67782f4dc9e52c);
$parcel$export($26675c4f95835ef1$exports, "str", () => $26675c4f95835ef1$export$42d51816ce590c93);
$parcel$export($26675c4f95835ef1$exports, "frob", () => $26675c4f95835ef1$export$326827e8268e9cdb);
$parcel$export($26675c4f95835ef1$exports, "add", () => $26675c4f95835ef1$export$e16d8520af44a096);
$parcel$export($26675c4f95835ef1$exports, "subtract", () => $26675c4f95835ef1$export$4e2d2ead65e5f7e3);
$parcel$export($26675c4f95835ef1$exports, "multiplyScalar", () => $26675c4f95835ef1$export$c697bed75648cdb7);
$parcel$export($26675c4f95835ef1$exports, "multiplyScalarAndAdd", () => $26675c4f95835ef1$export$553579f63bdd7137);
$parcel$export($26675c4f95835ef1$exports, "exactEquals", () => $26675c4f95835ef1$export$f2599a5cf1109d8);
$parcel$export($26675c4f95835ef1$exports, "equals", () => $26675c4f95835ef1$export$e9bab7fafb253603);
$parcel$export($26675c4f95835ef1$exports, "mul", () => $26675c4f95835ef1$export$6e3a27864ab166fe);
$parcel$export($26675c4f95835ef1$exports, "sub", () => $26675c4f95835ef1$export$f93b5905241a7cca);
var $78ae820aa9ececfa$exports = {};

$parcel$export($78ae820aa9ececfa$exports, "EPSILON", () => $78ae820aa9ececfa$export$fd293b15f47e270);
$parcel$export($78ae820aa9ececfa$exports, "ARRAY_TYPE", () => $78ae820aa9ececfa$export$b67359430d3b1b2);
$parcel$export($78ae820aa9ececfa$exports, "RANDOM", () => $78ae820aa9ececfa$export$5ada478c8a628231);
$parcel$export($78ae820aa9ececfa$exports, "setMatrixArrayType", () => $78ae820aa9ececfa$export$cb2c0eb57f5e532c);
$parcel$export($78ae820aa9ececfa$exports, "toRadian", () => $78ae820aa9ececfa$export$408b8ee5959eefd5);
$parcel$export($78ae820aa9ececfa$exports, "equals", () => $78ae820aa9ececfa$export$e9bab7fafb253603);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $78ae820aa9ececfa$export$fd293b15f47e270 = 0.000001;
var $78ae820aa9ececfa$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $78ae820aa9ececfa$export$5ada478c8a628231 = Math.random;
function $78ae820aa9ececfa$export$cb2c0eb57f5e532c(type) {
    $78ae820aa9ececfa$export$b67359430d3b1b2 = type;
}
var $78ae820aa9ececfa$var$degree = Math.PI / 180;
function $78ae820aa9ececfa$export$408b8ee5959eefd5(a) {
    return a * $78ae820aa9ececfa$var$degree;
}
function $78ae820aa9ececfa$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};


function $26675c4f95835ef1$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(16);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $26675c4f95835ef1$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $26675c4f95835ef1$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $26675c4f95835ef1$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $26675c4f95835ef1$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $78ae820aa9ececfa$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $26675c4f95835ef1$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $26675c4f95835ef1$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $26675c4f95835ef1$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $78ae820aa9ececfa$export$fd293b15f47e270) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ff497f2be31cc6a(out, a) {
    var translation = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $26675c4f95835ef1$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $26675c4f95835ef1$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $26675c4f95835ef1$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $26675c4f95835ef1$export$df3937d3b537df0a(out, mat) {
    var scaling = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    $26675c4f95835ef1$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $26675c4f95835ef1$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $26675c4f95835ef1$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $26675c4f95835ef1$export$541149539f3a4684 = $26675c4f95835ef1$export$4cf19729ec9a96b8;
function $26675c4f95835ef1$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $26675c4f95835ef1$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $26675c4f95835ef1$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $26675c4f95835ef1$export$4f2167e613cfc87b = $26675c4f95835ef1$export$c5f65ef3eb668f27;
function $26675c4f95835ef1$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $78ae820aa9ececfa$export$fd293b15f47e270 && Math.abs(eyey - centery) < $78ae820aa9ececfa$export$fd293b15f47e270 && Math.abs(eyez - centerz) < $78ae820aa9ececfa$export$fd293b15f47e270) return $26675c4f95835ef1$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $26675c4f95835ef1$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $26675c4f95835ef1$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $26675c4f95835ef1$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $26675c4f95835ef1$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $26675c4f95835ef1$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $26675c4f95835ef1$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $26675c4f95835ef1$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $26675c4f95835ef1$export$6e3a27864ab166fe = $26675c4f95835ef1$export$2060d2db72cce88f;
var $26675c4f95835ef1$export$f93b5905241a7cca = $26675c4f95835ef1$export$4e2d2ead65e5f7e3;


const $9ecda7333d28e490$export$c647cb0ee6e282fe = {
    tile: 16
};
const $9ecda7333d28e490$export$871de8747c9eaa88 = {
    movementSpeedTilesPerSecond: $9ecda7333d28e490$export$c647cb0ee6e282fe.tile * 2,
    maxHeight: 8,
    smoothingIterations: 3,
    unitRenderHeight: $9ecda7333d28e490$export$c647cb0ee6e282fe.tile / 2,
    maxZoom: 30.0,
    minZoom: 0.1
};
const $9ecda7333d28e490$export$1ffe7377828dbf0a = {
    buildSpeedVoxelsPerSecond: 128
};


function $6b248c1fdea83752$export$441ba46c5fcd50d9(gl) {
    gl.clearColor(0.0, 0.0, 0.0, 1.0);
    gl.clearDepth(1.0);
    gl.enable(gl.DEPTH_TEST);
    gl.disable(gl.CULL_FACE);
    gl.depthFunc(gl.LEQUAL);
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
//gl.enable(gl.SAMPLE_COVERAGE)
//sgl.sampleCoverage(0.9, false)
}
function $6b248c1fdea83752$export$d1bc072841c808d0(gl, frameBuffer, width, height, x = 0, y = 0) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.viewport(x, y, width, height);
}
function $6b248c1fdea83752$export$792a1e95a9bc00fc(gl, width, height) {
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const level = 0;
    const internalFormat = gl.RGBA;
    const border = 0;
    const format = gl.RGBA;
    const type = gl.UNSIGNED_BYTE;
    const data = null;
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, format, type, data);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    return texture;
}
function $6b248c1fdea83752$export$3fb2efb4293ebbde(width, height, zFar) {
    const fieldOfView = 45 * Math.PI / 180 // in radians
    ;
    const aspect = width / height;
    const zNear = 0.1;
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    // note: glmatrix.js always has the first argument
    // as the destination to receive the result.
    (0, $26675c4f95835ef1$exports).perspective(projectionMatrix, fieldOfView, aspect, zNear, zFar);
    return projectionMatrix;
}
function $6b248c1fdea83752$export$b4b257f6294f012(game, width, height) {
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    const maxDepth = game.simulation.landscape.size * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile * 1.5 / 2 // the 1.2 is just a fudge factor for the angle of the tiles
    ;
    const zoom = 1 / game.view.zoom;
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, -width / 2 * zoom, width / 2 * zoom, -height / 2 * zoom, height / 2 * zoom, -maxDepth, maxDepth);
    const viewMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).lookAt(viewMatrix, game.view.position, game.view.lookAt, [
        0,
        1,
        0
    ]);
    return (0, $26675c4f95835ef1$exports).multiply((0, $26675c4f95835ef1$exports).create(), projectionMatrix, viewMatrix);
}


function $8ed303d5d07f367a$export$83674196993caf59(gl, type, source) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        alert(`An error occurred compiling the shaders: ${gl.getShaderInfoLog(shader)}`);
        gl.deleteShader(shader);
        return null;
    }
    return shader;
}
let $8ed303d5d07f367a$var$shaderMap = new Map();
function $8ed303d5d07f367a$export$5f960e5136fd65f5(gl, vsSource, fsSource) {
    const key = `${vsSource}:${fsSource}`;
    let shaderProgram = $8ed303d5d07f367a$var$shaderMap.get(key);
    if (!shaderProgram) {
        const vertexShader = $8ed303d5d07f367a$export$83674196993caf59(gl, gl.VERTEX_SHADER, vsSource);
        const fragmentShader = $8ed303d5d07f367a$export$83674196993caf59(gl, gl.FRAGMENT_SHADER, fsSource);
        shaderProgram = gl.createProgram();
        gl.attachShader(shaderProgram, vertexShader);
        gl.attachShader(shaderProgram, fragmentShader);
        gl.linkProgram(shaderProgram);
        if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
            alert(`Unable to initialize the shader program: ${gl.getProgramInfoLog(shaderProgram)}`);
            return null;
        }
        $8ed303d5d07f367a$var$shaderMap.set(key, shaderProgram);
    }
    return shaderProgram;
}
function $8ed303d5d07f367a$export$f7c2b6763dc47773(gl, source) {
    const vertexShader = $8ed303d5d07f367a$export$83674196993caf59(gl, gl.VERTEX_SHADER, source.vert);
    const fragmentShader = $8ed303d5d07f367a$export$83674196993caf59(gl, gl.FRAGMENT_SHADER, source.frag);
    const shaderProgram = gl.createProgram();
    gl.attachShader(shaderProgram, vertexShader);
    gl.attachShader(shaderProgram, fragmentShader);
    gl.linkProgram(shaderProgram);
    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) {
        alert(`Unable to initialize the shader program: ${gl.getProgramInfoLog(shaderProgram)}`);
        return null;
    }
    return shaderProgram;
}


var $4ce98914b6676340$exports = {};

$parcel$export($4ce98914b6676340$exports, "create", () => $4ce98914b6676340$export$185802fd694ee1f5);
$parcel$export($4ce98914b6676340$exports, "clone", () => $4ce98914b6676340$export$9cd59f9826255e47);
$parcel$export($4ce98914b6676340$exports, "fromValues", () => $4ce98914b6676340$export$a82be99ed2a44a7d);
$parcel$export($4ce98914b6676340$exports, "copy", () => $4ce98914b6676340$export$784d13d8ee351f07);
$parcel$export($4ce98914b6676340$exports, "set", () => $4ce98914b6676340$export$adaa4cf7ef1b65be);
$parcel$export($4ce98914b6676340$exports, "add", () => $4ce98914b6676340$export$e16d8520af44a096);
$parcel$export($4ce98914b6676340$exports, "subtract", () => $4ce98914b6676340$export$4e2d2ead65e5f7e3);
$parcel$export($4ce98914b6676340$exports, "multiply", () => $4ce98914b6676340$export$2060d2db72cce88f);
$parcel$export($4ce98914b6676340$exports, "divide", () => $4ce98914b6676340$export$cd007d971a5a2143);
$parcel$export($4ce98914b6676340$exports, "ceil", () => $4ce98914b6676340$export$803ce6b71a0a94b2);
$parcel$export($4ce98914b6676340$exports, "floor", () => $4ce98914b6676340$export$a3fe094919f356fd);
$parcel$export($4ce98914b6676340$exports, "min", () => $4ce98914b6676340$export$96ec731ed4dcb222);
$parcel$export($4ce98914b6676340$exports, "max", () => $4ce98914b6676340$export$8960430cfd85939f);
$parcel$export($4ce98914b6676340$exports, "round", () => $4ce98914b6676340$export$2077e0241d6afd3c);
$parcel$export($4ce98914b6676340$exports, "scale", () => $4ce98914b6676340$export$dcdf75081b88279d);
$parcel$export($4ce98914b6676340$exports, "scaleAndAdd", () => $4ce98914b6676340$export$19cedf1da84ba854);
$parcel$export($4ce98914b6676340$exports, "distance", () => $4ce98914b6676340$export$9f17032d917177de);
$parcel$export($4ce98914b6676340$exports, "squaredDistance", () => $4ce98914b6676340$export$88e6ebb4fe54f538);
$parcel$export($4ce98914b6676340$exports, "length", () => $4ce98914b6676340$export$f24224f1c91d8156);
$parcel$export($4ce98914b6676340$exports, "squaredLength", () => $4ce98914b6676340$export$ab44e1323ffc8376);
$parcel$export($4ce98914b6676340$exports, "negate", () => $4ce98914b6676340$export$aef51622e549b8b0);
$parcel$export($4ce98914b6676340$exports, "inverse", () => $4ce98914b6676340$export$70ae2c07e401031b);
$parcel$export($4ce98914b6676340$exports, "normalize", () => $4ce98914b6676340$export$a3295358bff77e);
$parcel$export($4ce98914b6676340$exports, "dot", () => $4ce98914b6676340$export$94132a0e348806d4);
$parcel$export($4ce98914b6676340$exports, "cross", () => $4ce98914b6676340$export$bb646b20bb93d339);
$parcel$export($4ce98914b6676340$exports, "lerp", () => $4ce98914b6676340$export$3a89f8d6f6bf6c9f);
$parcel$export($4ce98914b6676340$exports, "random", () => $4ce98914b6676340$export$4385e60b38654f68);
$parcel$export($4ce98914b6676340$exports, "transformMat2", () => $4ce98914b6676340$export$b732428d73874bfc);
$parcel$export($4ce98914b6676340$exports, "transformMat2d", () => $4ce98914b6676340$export$3e55bc4b3707dfd3);
$parcel$export($4ce98914b6676340$exports, "transformMat3", () => $4ce98914b6676340$export$f0bfa0a0024626ee);
$parcel$export($4ce98914b6676340$exports, "transformMat4", () => $4ce98914b6676340$export$5ffbd13800309d59);
$parcel$export($4ce98914b6676340$exports, "rotate", () => $4ce98914b6676340$export$bb628a54ab399bc9);
$parcel$export($4ce98914b6676340$exports, "angle", () => $4ce98914b6676340$export$944b09d2ad10b378);
$parcel$export($4ce98914b6676340$exports, "zero", () => $4ce98914b6676340$export$7f9972325ebfd559);
$parcel$export($4ce98914b6676340$exports, "str", () => $4ce98914b6676340$export$42d51816ce590c93);
$parcel$export($4ce98914b6676340$exports, "exactEquals", () => $4ce98914b6676340$export$f2599a5cf1109d8);
$parcel$export($4ce98914b6676340$exports, "equals", () => $4ce98914b6676340$export$e9bab7fafb253603);
$parcel$export($4ce98914b6676340$exports, "len", () => $4ce98914b6676340$export$fc1400facf92c78);
$parcel$export($4ce98914b6676340$exports, "sub", () => $4ce98914b6676340$export$f93b5905241a7cca);
$parcel$export($4ce98914b6676340$exports, "mul", () => $4ce98914b6676340$export$6e3a27864ab166fe);
$parcel$export($4ce98914b6676340$exports, "div", () => $4ce98914b6676340$export$159d9494db57879b);
$parcel$export($4ce98914b6676340$exports, "dist", () => $4ce98914b6676340$export$6c4a311cc157c764);
$parcel$export($4ce98914b6676340$exports, "sqrDist", () => $4ce98914b6676340$export$2422cd6c492a8b3a);
$parcel$export($4ce98914b6676340$exports, "sqrLen", () => $4ce98914b6676340$export$99d8dd3f32a3435);
$parcel$export($4ce98914b6676340$exports, "forEach", () => $4ce98914b6676340$export$4b80e395e36b5a56);

function $4ce98914b6676340$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $4ce98914b6676340$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$a82be99ed2a44a7d(x, y) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $4ce98914b6676340$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $4ce98914b6676340$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $4ce98914b6676340$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $4ce98914b6676340$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $4ce98914b6676340$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $4ce98914b6676340$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $4ce98914b6676340$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $4ce98914b6676340$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $4ce98914b6676340$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $4ce98914b6676340$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $4ce98914b6676340$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $4ce98914b6676340$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $4ce98914b6676340$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $4ce98914b6676340$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $4ce98914b6676340$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $4ce98914b6676340$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $4ce98914b6676340$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $78ae820aa9ececfa$export$5ada478c8a628231() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $4ce98914b6676340$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $4ce98914b6676340$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $4ce98914b6676340$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $4ce98914b6676340$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $4ce98914b6676340$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $4ce98914b6676340$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1], // mag is the product of the magnitudes of a and b
    mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2), // mag &&.. short circuits if mag == 0
    cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $4ce98914b6676340$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $4ce98914b6676340$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $4ce98914b6676340$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $4ce98914b6676340$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $4ce98914b6676340$export$fc1400facf92c78 = $4ce98914b6676340$export$f24224f1c91d8156;
var $4ce98914b6676340$export$f93b5905241a7cca = $4ce98914b6676340$export$4e2d2ead65e5f7e3;
var $4ce98914b6676340$export$6e3a27864ab166fe = $4ce98914b6676340$export$2060d2db72cce88f;
var $4ce98914b6676340$export$159d9494db57879b = $4ce98914b6676340$export$cd007d971a5a2143;
var $4ce98914b6676340$export$6c4a311cc157c764 = $4ce98914b6676340$export$9f17032d917177de;
var $4ce98914b6676340$export$2422cd6c492a8b3a = $4ce98914b6676340$export$88e6ebb4fe54f538;
var $4ce98914b6676340$export$99d8dd3f32a3435 = $4ce98914b6676340$export$ab44e1323ffc8376;
var $4ce98914b6676340$export$4b80e395e36b5a56 = function() {
    var vec = $4ce98914b6676340$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

var $ab7f6dc0910e1ef7$exports = {};

$parcel$export($ab7f6dc0910e1ef7$exports, "create", () => $ab7f6dc0910e1ef7$export$185802fd694ee1f5);
$parcel$export($ab7f6dc0910e1ef7$exports, "clone", () => $ab7f6dc0910e1ef7$export$9cd59f9826255e47);
$parcel$export($ab7f6dc0910e1ef7$exports, "length", () => $ab7f6dc0910e1ef7$export$f24224f1c91d8156);
$parcel$export($ab7f6dc0910e1ef7$exports, "fromValues", () => $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d);
$parcel$export($ab7f6dc0910e1ef7$exports, "copy", () => $ab7f6dc0910e1ef7$export$784d13d8ee351f07);
$parcel$export($ab7f6dc0910e1ef7$exports, "set", () => $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be);
$parcel$export($ab7f6dc0910e1ef7$exports, "add", () => $ab7f6dc0910e1ef7$export$e16d8520af44a096);
$parcel$export($ab7f6dc0910e1ef7$exports, "subtract", () => $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3);
$parcel$export($ab7f6dc0910e1ef7$exports, "multiply", () => $ab7f6dc0910e1ef7$export$2060d2db72cce88f);
$parcel$export($ab7f6dc0910e1ef7$exports, "divide", () => $ab7f6dc0910e1ef7$export$cd007d971a5a2143);
$parcel$export($ab7f6dc0910e1ef7$exports, "ceil", () => $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2);
$parcel$export($ab7f6dc0910e1ef7$exports, "floor", () => $ab7f6dc0910e1ef7$export$a3fe094919f356fd);
$parcel$export($ab7f6dc0910e1ef7$exports, "min", () => $ab7f6dc0910e1ef7$export$96ec731ed4dcb222);
$parcel$export($ab7f6dc0910e1ef7$exports, "max", () => $ab7f6dc0910e1ef7$export$8960430cfd85939f);
$parcel$export($ab7f6dc0910e1ef7$exports, "round", () => $ab7f6dc0910e1ef7$export$2077e0241d6afd3c);
$parcel$export($ab7f6dc0910e1ef7$exports, "scale", () => $ab7f6dc0910e1ef7$export$dcdf75081b88279d);
$parcel$export($ab7f6dc0910e1ef7$exports, "scaleAndAdd", () => $ab7f6dc0910e1ef7$export$19cedf1da84ba854);
$parcel$export($ab7f6dc0910e1ef7$exports, "distance", () => $ab7f6dc0910e1ef7$export$9f17032d917177de);
$parcel$export($ab7f6dc0910e1ef7$exports, "squaredDistance", () => $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538);
$parcel$export($ab7f6dc0910e1ef7$exports, "squaredLength", () => $ab7f6dc0910e1ef7$export$ab44e1323ffc8376);
$parcel$export($ab7f6dc0910e1ef7$exports, "negate", () => $ab7f6dc0910e1ef7$export$aef51622e549b8b0);
$parcel$export($ab7f6dc0910e1ef7$exports, "inverse", () => $ab7f6dc0910e1ef7$export$70ae2c07e401031b);
$parcel$export($ab7f6dc0910e1ef7$exports, "normalize", () => $ab7f6dc0910e1ef7$export$a3295358bff77e);
$parcel$export($ab7f6dc0910e1ef7$exports, "dot", () => $ab7f6dc0910e1ef7$export$94132a0e348806d4);
$parcel$export($ab7f6dc0910e1ef7$exports, "cross", () => $ab7f6dc0910e1ef7$export$bb646b20bb93d339);
$parcel$export($ab7f6dc0910e1ef7$exports, "lerp", () => $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f);
$parcel$export($ab7f6dc0910e1ef7$exports, "hermite", () => $ab7f6dc0910e1ef7$export$ae8865616f30561c);
$parcel$export($ab7f6dc0910e1ef7$exports, "bezier", () => $ab7f6dc0910e1ef7$export$b9c5f84610baddaf);
$parcel$export($ab7f6dc0910e1ef7$exports, "random", () => $ab7f6dc0910e1ef7$export$4385e60b38654f68);
$parcel$export($ab7f6dc0910e1ef7$exports, "transformMat4", () => $ab7f6dc0910e1ef7$export$5ffbd13800309d59);
$parcel$export($ab7f6dc0910e1ef7$exports, "transformMat3", () => $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee);
$parcel$export($ab7f6dc0910e1ef7$exports, "transformQuat", () => $ab7f6dc0910e1ef7$export$c32adef9e939ce85);
$parcel$export($ab7f6dc0910e1ef7$exports, "rotateX", () => $ab7f6dc0910e1ef7$export$a59c8716592e09af);
$parcel$export($ab7f6dc0910e1ef7$exports, "rotateY", () => $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd);
$parcel$export($ab7f6dc0910e1ef7$exports, "rotateZ", () => $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c);
$parcel$export($ab7f6dc0910e1ef7$exports, "angle", () => $ab7f6dc0910e1ef7$export$944b09d2ad10b378);
$parcel$export($ab7f6dc0910e1ef7$exports, "zero", () => $ab7f6dc0910e1ef7$export$7f9972325ebfd559);
$parcel$export($ab7f6dc0910e1ef7$exports, "str", () => $ab7f6dc0910e1ef7$export$42d51816ce590c93);
$parcel$export($ab7f6dc0910e1ef7$exports, "exactEquals", () => $ab7f6dc0910e1ef7$export$f2599a5cf1109d8);
$parcel$export($ab7f6dc0910e1ef7$exports, "equals", () => $ab7f6dc0910e1ef7$export$e9bab7fafb253603);
$parcel$export($ab7f6dc0910e1ef7$exports, "sub", () => $ab7f6dc0910e1ef7$export$f93b5905241a7cca);
$parcel$export($ab7f6dc0910e1ef7$exports, "mul", () => $ab7f6dc0910e1ef7$export$6e3a27864ab166fe);
$parcel$export($ab7f6dc0910e1ef7$exports, "div", () => $ab7f6dc0910e1ef7$export$159d9494db57879b);
$parcel$export($ab7f6dc0910e1ef7$exports, "dist", () => $ab7f6dc0910e1ef7$export$6c4a311cc157c764);
$parcel$export($ab7f6dc0910e1ef7$exports, "sqrDist", () => $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a);
$parcel$export($ab7f6dc0910e1ef7$exports, "len", () => $ab7f6dc0910e1ef7$export$fc1400facf92c78);
$parcel$export($ab7f6dc0910e1ef7$exports, "sqrLen", () => $ab7f6dc0910e1ef7$export$99d8dd3f32a3435);
$parcel$export($ab7f6dc0910e1ef7$exports, "forEach", () => $ab7f6dc0910e1ef7$export$4b80e395e36b5a56);

function $ab7f6dc0910e1ef7$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $ab7f6dc0910e1ef7$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $ab7f6dc0910e1ef7$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $ab7f6dc0910e1ef7$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $ab7f6dc0910e1ef7$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $78ae820aa9ececfa$export$5ada478c8a628231() * 2.0 * Math.PI;
    var z = $78ae820aa9ececfa$export$5ada478c8a628231() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $ab7f6dc0910e1ef7$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $ab7f6dc0910e1ef7$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag1 = Math.sqrt(ax * ax + ay * ay + az * az), mag2 = Math.sqrt(bx * bx + by * by + bz * bz), mag = mag1 * mag2, cosine = mag && $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $ab7f6dc0910e1ef7$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $ab7f6dc0910e1ef7$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $ab7f6dc0910e1ef7$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $ab7f6dc0910e1ef7$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $ab7f6dc0910e1ef7$export$f93b5905241a7cca = $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3;
var $ab7f6dc0910e1ef7$export$6e3a27864ab166fe = $ab7f6dc0910e1ef7$export$2060d2db72cce88f;
var $ab7f6dc0910e1ef7$export$159d9494db57879b = $ab7f6dc0910e1ef7$export$cd007d971a5a2143;
var $ab7f6dc0910e1ef7$export$6c4a311cc157c764 = $ab7f6dc0910e1ef7$export$9f17032d917177de;
var $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a = $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538;
var $ab7f6dc0910e1ef7$export$fc1400facf92c78 = $ab7f6dc0910e1ef7$export$f24224f1c91d8156;
var $ab7f6dc0910e1ef7$export$99d8dd3f32a3435 = $ab7f6dc0910e1ef7$export$ab44e1323ffc8376;
var $ab7f6dc0910e1ef7$export$4b80e395e36b5a56 = function() {
    var vec = $ab7f6dc0910e1ef7$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();


const $35806345bc1d62c5$var$materials = {
    darkgray: [
        0.2,
        0.2,
        0.2,
        1.0
    ],
    gray: [
        0.6,
        0.6,
        0.6,
        1.0
    ],
    orange: [
        0xf5 / 255.0,
        0x9e / 255.0,
        0x0b / 255.0,
        1.0
    ],
    lightblue: [
        0x7d / 255.0,
        0xd3 / 255.0,
        0xfd / 255.0,
        1.0
    ],
    red: [
        1.0,
        0.0,
        0.0,
        1.0
    ],
    green: [
        0.0,
        1.0,
        0.0,
        1.0
    ],
    yellow: [
        1.0,
        1.0,
        0.0,
        1.0
    ],
    black: [
        0.0,
        0.0,
        0.0,
        1.0
    ]
};
function $35806345bc1d62c5$var$extractFromObj(lines, scale, vertices, faceIndices, materialChanges, vertexNormals, vertexTextures) {
    lines.forEach((line)=>{
        const components = line.split(" ");
        if (components.length > 0) {
            if (components[0] == "v") {
                const newVector = (0, $ab7f6dc0910e1ef7$exports).fromValues(parseFloat(components[1]) * scale, parseFloat(components[2]) * scale, parseFloat(components[3]) * scale);
                vertices.push(newVector);
            } else if (components[0] == "f") {
                // Face can be in the formats:
                // f 1 2 3              indices for positions only
                // f 1/1 2/2 3/3        indices for positions and texcoords
                // f 1/1/1 2/2/2 3/3/3  indices for positions, texcoords, and normals
                // f 1//1 2//2 3//3     indices for positions and normals
                // Currently we deal with format f 1 2 3 and format f 1/1/1 2/2/2 3/3/3
                const newFace = components.slice(1).map((c)=>{
                    if (c.indexOf("/") > 0) {
                        let fc = c.split("/");
                        return {
                            vertexIndex: parseInt(fc[0]) - 1,
                            textureIndex: parseInt(fc[1]) - 1,
                            normalIndex: parseInt(fc[2]) - 1
                        };
                    }
                    return {
                        vertexIndex: parseInt(c) - 1,
                        textureIndex: null,
                        normalIndex: null
                    };
                });
                faceIndices.push(newFace);
            } else if (components[0] == "usemtl") //materialChanges.push({faceIndex: faceIndices.length, material: components[1]})
            {
                if ($35806345bc1d62c5$var$materials[components[1]]) // if we have the material mapped
                materialChanges[faceIndices.length] = components[1];
            } else if (components[0] == "vn") {
                const newNormal = (0, $ab7f6dc0910e1ef7$exports).fromValues(parseFloat(components[1]), parseFloat(components[2]), parseFloat(components[3]));
                vertexNormals.push(newNormal);
            } else if (components[0] === "vt") {
                const newVertexTexture = (0, $4ce98914b6676340$exports).fromValues(parseFloat(components[1]), parseFloat(components[2]));
                vertexTextures.push(newVertexTexture);
            }
        }
    });
}
async function $35806345bc1d62c5$export$86658c5a114b5e4d(path, scale) {
    const response = await fetch(path);
    const text = await response.text();
    const lines = text.split("\n");
    let vertices = [];
    let vertexNormals = [];
    const vertexTextures = [];
    const faceIndices = [];
    //const materialChanges:{[faceIndex:number], material:string}[] = []
    const materialChanges = [];
    $35806345bc1d62c5$var$extractFromObj(lines, scale, vertices, faceIndices, materialChanges, vertexNormals, vertexTextures);
    // Our models all have the nose pointing the wrong way so we rotate them as we load
    vertices = vertices.map((v)=>(0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), v, [
            0,
            0,
            0
        ], Math.PI));
    vertexNormals = vertexNormals.map((v)=>(0, $ab7f6dc0910e1ef7$exports).rotateY((0, $ab7f6dc0910e1ef7$exports).create(), v, [
            0,
            0,
            0
        ], Math.PI));
    let currentColor = $35806345bc1d62c5$var$materials.gray;
    const faces = faceIndices.flatMap((face, index)=>{
        const numberOfTriangles = face.length - 2;
        const subFaces = [];
        const newMaterial = materialChanges[index];
        if (newMaterial) currentColor = $35806345bc1d62c5$var$materials[newMaterial];
        for(let subFaceIndex = 0; subFaceIndex < numberOfTriangles; subFaceIndex++){
            //const faceVertices = face.slice(subFaceIndex,subFaceIndex+3).map(index => vertices[index-1])
            const faceVertices = [
                vertices[face[0].vertexIndex],
                vertices[face[subFaceIndex + 1].vertexIndex],
                vertices[face[subFaceIndex + 2].vertexIndex]
            ];
            let normals = [];
            if (face[0].normalIndex !== null) normals = [
                vertexNormals[face[0].normalIndex],
                vertexNormals[face[subFaceIndex + 1].normalIndex],
                vertexNormals[face[subFaceIndex + 2].normalIndex]
            ];
            else {
                // If the model doesn't contain a normal then we calculate it
                // The normal of a triangle is the cross-product of two edges of the triangle, normalised for the lighting
                const edge1 = (0, $ab7f6dc0910e1ef7$exports).create();
                const edge2 = (0, $ab7f6dc0910e1ef7$exports).create();
                const normal = (0, $ab7f6dc0910e1ef7$exports).create();
                if (faceVertices.length < 3) debugger;
                (0, $ab7f6dc0910e1ef7$exports).subtract(edge1, faceVertices[0], faceVertices[1]);
                (0, $ab7f6dc0910e1ef7$exports).subtract(edge2, faceVertices[1], faceVertices[2]);
                (0, $ab7f6dc0910e1ef7$exports).cross(normal, edge1, edge2);
                (0, $ab7f6dc0910e1ef7$exports).normalize(normal, normal);
                normals = [
                    normal,
                    normal,
                    normal
                ];
            }
            subFaces.push({
                vertices: faceVertices,
                normals: normals,
                color: currentColor
            });
        }
        return subFaces;
    });
    return {
        vertices: vertices,
        faces: faces
    };
}
async function $35806345bc1d62c5$export$5cfea46336e7b8ff(gl, path, scale = 1.0) {
    const { vertices: vertices, faces: faces } = await $35806345bc1d62c5$export$86658c5a114b5e4d(path, scale);
    const positions = faces.flatMap((face)=>face.vertices.flatMap((v)=>[
                v[0],
                v[1],
                v[2]
            ])) // v.entries()
    ;
    const normals = faces.flatMap((face)=>face.normals.flatMap((fn)=>[
                fn[0],
                fn[1],
                fn[2]
            ])) // v.entries()
    ;
    const indices = faces.flatMap((_, index)=>[
            index * 3,
            index * 3 + 1,
            index * 3 + 2
        ]);
    const colors = faces.flatMap((face, index)=>{
        return face.vertices.flatMap((_)=>face.color);
    });
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        objectIdColor: null,
        objectInfo: null,
        additionalObjectInfo: null,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: 0,
        texture: null,
        faceNormal: null,
        outlines: null
    };
}
function $35806345bc1d62c5$export$7c40b2ceeb961577(gl, color, customPositions = null, flippedTexCoords = false) {
    const positions = customPositions === null ? [
        -1,
        -1,
        0.0,
        1.0,
        -1,
        0.0,
        1.0,
        1.0,
        0.0,
        -1,
        1.0,
        0.0
    ] : customPositions;
    const normals = [
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0
    ];
    const indices = [
        0,
        1,
        2,
        0,
        2,
        3
    ];
    const textureCoords = flippedTexCoords ? [
        0.0,
        1.0,
        1.0,
        1.0,
        1.0,
        0.0,
        0.0,
        0.0
    ] : [
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0
    ];
    const colors = [
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3]
    ];
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoords), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: textureCoordBuffer,
        texture: null
    };
}
function $35806345bc1d62c5$export$fdbdb3a5cc488d7e(gl, texture, flipY = true, topLeftBased = false, smoothScaling = false) {
    const positions = !topLeftBased ? [
        -1,
        -1,
        0.0,
        1.0,
        -1,
        0.0,
        1.0,
        1.0,
        0.0,
        -1,
        1.0,
        0.0
    ] : [
        0,
        0,
        0,
        2,
        0,
        0,
        2,
        2,
        0,
        0,
        2,
        0
    ];
    const normals = [
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0,
        0.0,
        0.0,
        1.0
    ];
    const indices = [
        0,
        1,
        2,
        0,
        2,
        3
    ];
    const textureCoords = flipY ? [
        0.0,
        1.0,
        1.0,
        1.0,
        1.0,
        0.0,
        0.0,
        0.0
    ] : [
        0.0,
        0.0,
        1.0,
        0.0,
        1.0,
        1.0,
        0.0,
        1.0
    ];
    //[0.0, 0.0, 1.0, 0.0, 1.0, 1.0, 0.0, 1.0]
    const color = [
        1.0,
        1.0,
        1.0,
        1.0
    ];
    const colors = [
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3],
        color[0],
        color[1],
        color[2],
        color[3]
    ];
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoords), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        objectIdColor: null,
        objectInfo: null,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: textureCoordBuffer,
        texture: texture
    };
}


var $e92e4eb8d35aaf31$exports = {};

$parcel$export($e92e4eb8d35aaf31$exports, "create", () => $e92e4eb8d35aaf31$export$185802fd694ee1f5);
$parcel$export($e92e4eb8d35aaf31$exports, "identity", () => $e92e4eb8d35aaf31$export$f0954fd7d5368655);
$parcel$export($e92e4eb8d35aaf31$exports, "setAxisAngle", () => $e92e4eb8d35aaf31$export$4286ddefc8f49512);
$parcel$export($e92e4eb8d35aaf31$exports, "getAxisAngle", () => $e92e4eb8d35aaf31$export$3f70be5e7d7dc51);
$parcel$export($e92e4eb8d35aaf31$exports, "getAngle", () => $e92e4eb8d35aaf31$export$b363da9ded343252);
$parcel$export($e92e4eb8d35aaf31$exports, "dot", () => $e92e4eb8d35aaf31$export$94132a0e348806d4);
$parcel$export($e92e4eb8d35aaf31$exports, "multiply", () => $e92e4eb8d35aaf31$export$2060d2db72cce88f);
$parcel$export($e92e4eb8d35aaf31$exports, "rotateX", () => $e92e4eb8d35aaf31$export$a59c8716592e09af);
$parcel$export($e92e4eb8d35aaf31$exports, "rotateY", () => $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd);
$parcel$export($e92e4eb8d35aaf31$exports, "rotateZ", () => $e92e4eb8d35aaf31$export$ea6eae3365de5b9c);
$parcel$export($e92e4eb8d35aaf31$exports, "calculateW", () => $e92e4eb8d35aaf31$export$fb72b72e8d764d4e);
$parcel$export($e92e4eb8d35aaf31$exports, "exp", () => $e92e4eb8d35aaf31$export$b310ec824aaee37f);
$parcel$export($e92e4eb8d35aaf31$exports, "ln", () => $e92e4eb8d35aaf31$export$876cb1b29620556f);
$parcel$export($e92e4eb8d35aaf31$exports, "pow", () => $e92e4eb8d35aaf31$export$9c297f60e22e3389);
$parcel$export($e92e4eb8d35aaf31$exports, "scale", () => $e92e4eb8d35aaf31$export$dcdf75081b88279d);
$parcel$export($e92e4eb8d35aaf31$exports, "slerp", () => $e92e4eb8d35aaf31$export$1544d9bc2995de08);
$parcel$export($e92e4eb8d35aaf31$exports, "random", () => $e92e4eb8d35aaf31$export$4385e60b38654f68);
$parcel$export($e92e4eb8d35aaf31$exports, "invert", () => $e92e4eb8d35aaf31$export$6897c284b6f9f4dc);
$parcel$export($e92e4eb8d35aaf31$exports, "conjugate", () => $e92e4eb8d35aaf31$export$7679f47e72c62560);
$parcel$export($e92e4eb8d35aaf31$exports, "fromMat3", () => $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b);
$parcel$export($e92e4eb8d35aaf31$exports, "fromEuler", () => $e92e4eb8d35aaf31$export$7a404a587ea85af);
$parcel$export($e92e4eb8d35aaf31$exports, "str", () => $e92e4eb8d35aaf31$export$42d51816ce590c93);
$parcel$export($e92e4eb8d35aaf31$exports, "clone", () => $e92e4eb8d35aaf31$export$9cd59f9826255e47);
$parcel$export($e92e4eb8d35aaf31$exports, "fromValues", () => $e92e4eb8d35aaf31$export$a82be99ed2a44a7d);
$parcel$export($e92e4eb8d35aaf31$exports, "copy", () => $e92e4eb8d35aaf31$export$784d13d8ee351f07);
$parcel$export($e92e4eb8d35aaf31$exports, "set", () => $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be);
$parcel$export($e92e4eb8d35aaf31$exports, "add", () => $e92e4eb8d35aaf31$export$e16d8520af44a096);
$parcel$export($e92e4eb8d35aaf31$exports, "mul", () => $e92e4eb8d35aaf31$export$6e3a27864ab166fe);
$parcel$export($e92e4eb8d35aaf31$exports, "lerp", () => $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f);
$parcel$export($e92e4eb8d35aaf31$exports, "length", () => $e92e4eb8d35aaf31$export$f24224f1c91d8156);
$parcel$export($e92e4eb8d35aaf31$exports, "len", () => $e92e4eb8d35aaf31$export$fc1400facf92c78);
$parcel$export($e92e4eb8d35aaf31$exports, "squaredLength", () => $e92e4eb8d35aaf31$export$ab44e1323ffc8376);
$parcel$export($e92e4eb8d35aaf31$exports, "sqrLen", () => $e92e4eb8d35aaf31$export$99d8dd3f32a3435);
$parcel$export($e92e4eb8d35aaf31$exports, "normalize", () => $e92e4eb8d35aaf31$export$a3295358bff77e);
$parcel$export($e92e4eb8d35aaf31$exports, "exactEquals", () => $e92e4eb8d35aaf31$export$f2599a5cf1109d8);
$parcel$export($e92e4eb8d35aaf31$exports, "equals", () => $e92e4eb8d35aaf31$export$e9bab7fafb253603);
$parcel$export($e92e4eb8d35aaf31$exports, "rotationTo", () => $e92e4eb8d35aaf31$export$72d66f5842c00904);
$parcel$export($e92e4eb8d35aaf31$exports, "sqlerp", () => $e92e4eb8d35aaf31$export$699b0866ca50f6cb);
$parcel$export($e92e4eb8d35aaf31$exports, "setAxes", () => $e92e4eb8d35aaf31$export$937ca0a544b2d712);


function $879d8210211d0bfa$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $879d8210211d0bfa$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $879d8210211d0bfa$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20; // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $879d8210211d0bfa$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $879d8210211d0bfa$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $879d8210211d0bfa$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $879d8210211d0bfa$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $879d8210211d0bfa$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $879d8210211d0bfa$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $879d8210211d0bfa$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $879d8210211d0bfa$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$42d51816ce590c93(a) {
    return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
function $879d8210211d0bfa$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
function $879d8210211d0bfa$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $879d8210211d0bfa$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $879d8210211d0bfa$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $879d8210211d0bfa$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $879d8210211d0bfa$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $879d8210211d0bfa$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $879d8210211d0bfa$export$6e3a27864ab166fe = $879d8210211d0bfa$export$2060d2db72cce88f;
var $879d8210211d0bfa$export$f93b5905241a7cca = $879d8210211d0bfa$export$4e2d2ead65e5f7e3;



var $e38eb280d3b76273$exports = {};

$parcel$export($e38eb280d3b76273$exports, "create", () => $e38eb280d3b76273$export$185802fd694ee1f5);
$parcel$export($e38eb280d3b76273$exports, "clone", () => $e38eb280d3b76273$export$9cd59f9826255e47);
$parcel$export($e38eb280d3b76273$exports, "fromValues", () => $e38eb280d3b76273$export$a82be99ed2a44a7d);
$parcel$export($e38eb280d3b76273$exports, "copy", () => $e38eb280d3b76273$export$784d13d8ee351f07);
$parcel$export($e38eb280d3b76273$exports, "set", () => $e38eb280d3b76273$export$adaa4cf7ef1b65be);
$parcel$export($e38eb280d3b76273$exports, "add", () => $e38eb280d3b76273$export$e16d8520af44a096);
$parcel$export($e38eb280d3b76273$exports, "subtract", () => $e38eb280d3b76273$export$4e2d2ead65e5f7e3);
$parcel$export($e38eb280d3b76273$exports, "multiply", () => $e38eb280d3b76273$export$2060d2db72cce88f);
$parcel$export($e38eb280d3b76273$exports, "divide", () => $e38eb280d3b76273$export$cd007d971a5a2143);
$parcel$export($e38eb280d3b76273$exports, "ceil", () => $e38eb280d3b76273$export$803ce6b71a0a94b2);
$parcel$export($e38eb280d3b76273$exports, "floor", () => $e38eb280d3b76273$export$a3fe094919f356fd);
$parcel$export($e38eb280d3b76273$exports, "min", () => $e38eb280d3b76273$export$96ec731ed4dcb222);
$parcel$export($e38eb280d3b76273$exports, "max", () => $e38eb280d3b76273$export$8960430cfd85939f);
$parcel$export($e38eb280d3b76273$exports, "round", () => $e38eb280d3b76273$export$2077e0241d6afd3c);
$parcel$export($e38eb280d3b76273$exports, "scale", () => $e38eb280d3b76273$export$dcdf75081b88279d);
$parcel$export($e38eb280d3b76273$exports, "scaleAndAdd", () => $e38eb280d3b76273$export$19cedf1da84ba854);
$parcel$export($e38eb280d3b76273$exports, "distance", () => $e38eb280d3b76273$export$9f17032d917177de);
$parcel$export($e38eb280d3b76273$exports, "squaredDistance", () => $e38eb280d3b76273$export$88e6ebb4fe54f538);
$parcel$export($e38eb280d3b76273$exports, "length", () => $e38eb280d3b76273$export$f24224f1c91d8156);
$parcel$export($e38eb280d3b76273$exports, "squaredLength", () => $e38eb280d3b76273$export$ab44e1323ffc8376);
$parcel$export($e38eb280d3b76273$exports, "negate", () => $e38eb280d3b76273$export$aef51622e549b8b0);
$parcel$export($e38eb280d3b76273$exports, "inverse", () => $e38eb280d3b76273$export$70ae2c07e401031b);
$parcel$export($e38eb280d3b76273$exports, "normalize", () => $e38eb280d3b76273$export$a3295358bff77e);
$parcel$export($e38eb280d3b76273$exports, "dot", () => $e38eb280d3b76273$export$94132a0e348806d4);
$parcel$export($e38eb280d3b76273$exports, "cross", () => $e38eb280d3b76273$export$bb646b20bb93d339);
$parcel$export($e38eb280d3b76273$exports, "lerp", () => $e38eb280d3b76273$export$3a89f8d6f6bf6c9f);
$parcel$export($e38eb280d3b76273$exports, "random", () => $e38eb280d3b76273$export$4385e60b38654f68);
$parcel$export($e38eb280d3b76273$exports, "transformMat4", () => $e38eb280d3b76273$export$5ffbd13800309d59);
$parcel$export($e38eb280d3b76273$exports, "transformQuat", () => $e38eb280d3b76273$export$c32adef9e939ce85);
$parcel$export($e38eb280d3b76273$exports, "zero", () => $e38eb280d3b76273$export$7f9972325ebfd559);
$parcel$export($e38eb280d3b76273$exports, "str", () => $e38eb280d3b76273$export$42d51816ce590c93);
$parcel$export($e38eb280d3b76273$exports, "exactEquals", () => $e38eb280d3b76273$export$f2599a5cf1109d8);
$parcel$export($e38eb280d3b76273$exports, "equals", () => $e38eb280d3b76273$export$e9bab7fafb253603);
$parcel$export($e38eb280d3b76273$exports, "sub", () => $e38eb280d3b76273$export$f93b5905241a7cca);
$parcel$export($e38eb280d3b76273$exports, "mul", () => $e38eb280d3b76273$export$6e3a27864ab166fe);
$parcel$export($e38eb280d3b76273$exports, "div", () => $e38eb280d3b76273$export$159d9494db57879b);
$parcel$export($e38eb280d3b76273$exports, "dist", () => $e38eb280d3b76273$export$6c4a311cc157c764);
$parcel$export($e38eb280d3b76273$exports, "sqrDist", () => $e38eb280d3b76273$export$2422cd6c492a8b3a);
$parcel$export($e38eb280d3b76273$exports, "len", () => $e38eb280d3b76273$export$fc1400facf92c78);
$parcel$export($e38eb280d3b76273$exports, "sqrLen", () => $e38eb280d3b76273$export$99d8dd3f32a3435);
$parcel$export($e38eb280d3b76273$exports, "forEach", () => $e38eb280d3b76273$export$4b80e395e36b5a56);

function $e38eb280d3b76273$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $e38eb280d3b76273$export$9cd59f9826255e47(a) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $e38eb280d3b76273$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $e38eb280d3b76273$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $e38eb280d3b76273$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $e38eb280d3b76273$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $e38eb280d3b76273$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $e38eb280d3b76273$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $e38eb280d3b76273$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $e38eb280d3b76273$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $e38eb280d3b76273$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $e38eb280d3b76273$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $e38eb280d3b76273$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $e38eb280d3b76273$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $e38eb280d3b76273$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $e38eb280d3b76273$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $e38eb280d3b76273$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $e38eb280d3b76273$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $e38eb280d3b76273$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        v2 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        v4 = $78ae820aa9ececfa$export$5ada478c8a628231() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $e38eb280d3b76273$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $e38eb280d3b76273$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $e38eb280d3b76273$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $e38eb280d3b76273$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $e38eb280d3b76273$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $78ae820aa9ececfa$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $e38eb280d3b76273$export$f93b5905241a7cca = $e38eb280d3b76273$export$4e2d2ead65e5f7e3;
var $e38eb280d3b76273$export$6e3a27864ab166fe = $e38eb280d3b76273$export$2060d2db72cce88f;
var $e38eb280d3b76273$export$159d9494db57879b = $e38eb280d3b76273$export$cd007d971a5a2143;
var $e38eb280d3b76273$export$6c4a311cc157c764 = $e38eb280d3b76273$export$9f17032d917177de;
var $e38eb280d3b76273$export$2422cd6c492a8b3a = $e38eb280d3b76273$export$88e6ebb4fe54f538;
var $e38eb280d3b76273$export$fc1400facf92c78 = $e38eb280d3b76273$export$f24224f1c91d8156;
var $e38eb280d3b76273$export$99d8dd3f32a3435 = $e38eb280d3b76273$export$ab44e1323ffc8376;
var $e38eb280d3b76273$export$4b80e395e36b5a56 = function() {
    var vec = $e38eb280d3b76273$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();


function $e92e4eb8d35aaf31$export$185802fd694ee1f5() {
    var out = new $78ae820aa9ececfa$export$b67359430d3b1b2(4);
    if ($78ae820aa9ececfa$export$b67359430d3b1b2 != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $e92e4eb8d35aaf31$export$3f70be5e7d7dc51(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s > $78ae820aa9ececfa$export$fd293b15f47e270) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
function $e92e4eb8d35aaf31$export$b363da9ded343252(a, b) {
    var dotproduct = $e92e4eb8d35aaf31$export$94132a0e348806d4(a, b);
    return Math.acos(2 * dotproduct * dotproduct - 1);
}
function $e92e4eb8d35aaf31$export$2060d2db72cce88f(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $e92e4eb8d35aaf31$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$fb72b72e8d764d4e(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
function $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var et = Math.exp(w);
    var s = r > 0 ? et * Math.sin(r) / r : 0;
    out[0] = x * s;
    out[1] = y * s;
    out[2] = z * s;
    out[3] = et * Math.cos(r);
    return out;
}
function $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var t = r > 0 ? Math.atan2(r, w) / r : 0;
    out[0] = x * t;
    out[1] = y * t;
    out[2] = z * t;
    out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
    return out;
}
function $e92e4eb8d35aaf31$export$9c297f60e22e3389(out, a, b) {
    $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a);
    $e92e4eb8d35aaf31$export$dcdf75081b88279d(out, out, b);
    $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, out);
    return out;
}
function $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega, cosom, sinom, scale0, scale1; // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    } // calculate coefficients
    if (1.0 - cosom > $78ae820aa9ececfa$export$fd293b15f47e270) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    } // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $e92e4eb8d35aaf31$export$4385e60b38654f68(out) {
    // Implementation of http://planning.cs.uiuc.edu/node198.html
    // TODO: Calling random 3 times is probably not the fastest solution
    var u1 = $78ae820aa9ececfa$export$5ada478c8a628231();
    var u2 = $78ae820aa9ececfa$export$5ada478c8a628231();
    var u3 = $78ae820aa9ececfa$export$5ada478c8a628231();
    var sqrt1MinusU1 = Math.sqrt(1 - u1);
    var sqrtU1 = Math.sqrt(u1);
    out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
    out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
    out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
    out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
    return out;
}
function $e92e4eb8d35aaf31$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    var invDot = dot ? 1.0 / dot : 0; // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $e92e4eb8d35aaf31$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $e92e4eb8d35aaf31$export$7a404a587ea85af(out, x, y, z) {
    var halfToRad = 0.5 * Math.PI / 180.0;
    x *= halfToRad;
    y *= halfToRad;
    z *= halfToRad;
    var sx = Math.sin(x);
    var cx = Math.cos(x);
    var sy = Math.sin(y);
    var cy = Math.cos(y);
    var sz = Math.sin(z);
    var cz = Math.cos(z);
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
    return out;
}
function $e92e4eb8d35aaf31$export$42d51816ce590c93(a) {
    return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
var $e92e4eb8d35aaf31$export$9cd59f9826255e47 = $e38eb280d3b76273$export$9cd59f9826255e47;
var $e92e4eb8d35aaf31$export$a82be99ed2a44a7d = $e38eb280d3b76273$export$a82be99ed2a44a7d;
var $e92e4eb8d35aaf31$export$784d13d8ee351f07 = $e38eb280d3b76273$export$784d13d8ee351f07;
var $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be = $e38eb280d3b76273$export$adaa4cf7ef1b65be;
var $e92e4eb8d35aaf31$export$e16d8520af44a096 = $e38eb280d3b76273$export$e16d8520af44a096;
var $e92e4eb8d35aaf31$export$6e3a27864ab166fe = $e92e4eb8d35aaf31$export$2060d2db72cce88f;
var $e92e4eb8d35aaf31$export$dcdf75081b88279d = $e38eb280d3b76273$export$dcdf75081b88279d;
var $e92e4eb8d35aaf31$export$94132a0e348806d4 = $e38eb280d3b76273$export$94132a0e348806d4;
var $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f = $e38eb280d3b76273$export$3a89f8d6f6bf6c9f;
var $e92e4eb8d35aaf31$export$f24224f1c91d8156 = $e38eb280d3b76273$export$f24224f1c91d8156;
var $e92e4eb8d35aaf31$export$fc1400facf92c78 = $e92e4eb8d35aaf31$export$f24224f1c91d8156;
var $e92e4eb8d35aaf31$export$ab44e1323ffc8376 = $e38eb280d3b76273$export$ab44e1323ffc8376;
var $e92e4eb8d35aaf31$export$99d8dd3f32a3435 = $e92e4eb8d35aaf31$export$ab44e1323ffc8376;
var $e92e4eb8d35aaf31$export$a3295358bff77e = $e38eb280d3b76273$export$a3295358bff77e;
var $e92e4eb8d35aaf31$export$f2599a5cf1109d8 = $e38eb280d3b76273$export$f2599a5cf1109d8;
var $e92e4eb8d35aaf31$export$e9bab7fafb253603 = $e38eb280d3b76273$export$e9bab7fafb253603;
var $e92e4eb8d35aaf31$export$72d66f5842c00904 = function() {
    var tmpvec3 = $ab7f6dc0910e1ef7$export$185802fd694ee1f5();
    var xUnitVec3 = $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(1, 0, 0);
    var yUnitVec3 = $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(0, 1, 0);
    return function(out, a, b) {
        var dot = $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b);
        if (dot < -0.999999) {
            $ab7f6dc0910e1ef7$export$bb646b20bb93d339(tmpvec3, xUnitVec3, a);
            if ($ab7f6dc0910e1ef7$export$fc1400facf92c78(tmpvec3) < 0.000001) $ab7f6dc0910e1ef7$export$bb646b20bb93d339(tmpvec3, yUnitVec3, a);
            $ab7f6dc0910e1ef7$export$a3295358bff77e(tmpvec3, tmpvec3);
            $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            $ab7f6dc0910e1ef7$export$bb646b20bb93d339(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $e92e4eb8d35aaf31$export$a3295358bff77e(out, out);
        }
    };
}();
var $e92e4eb8d35aaf31$export$699b0866ca50f6cb = function() {
    var temp1 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    var temp2 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    return function(out, a, b, c, d, t) {
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp1, a, d, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp2, b, c, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}();
var $e92e4eb8d35aaf31$export$937ca0a544b2d712 = function() {
    var matr = $879d8210211d0bfa$export$185802fd694ee1f5();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $e92e4eb8d35aaf31$export$a3295358bff77e(out, $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, matr));
    };
}();


function $b125b9470601071f$export$f5a01205d395aca(gl, buffers, programInfo) {
    $b125b9470601071f$var$internalSetCommonAttributes(gl, buffers, programInfo, 3);
}
function $b125b9470601071f$export$f1fc9c1971337e7c(gl, buffers, programInfo) {
    $b125b9470601071f$var$internalSetCommonAttributes(gl, buffers, programInfo, 2);
}
function $b125b9470601071f$var$internalSetCommonAttributes(gl, buffers, programInfo, positionBufferComponents) {
    if (buffers.textureCoords !== undefined && programInfo.attribLocations.textureCoords !== undefined) $b125b9470601071f$var$setTextureAttribute(gl, buffers.textureCoords, programInfo.attribLocations.textureCoords);
    if (buffers.position !== undefined && programInfo.attribLocations.vertexPosition !== undefined) $b125b9470601071f$var$setPositionAttribute(gl, buffers.position, programInfo.attribLocations.vertexPosition, positionBufferComponents);
    if (buffers.normals !== undefined && programInfo.attribLocations.vertexNormal !== undefined) $b125b9470601071f$var$setNormalAttribute(gl, buffers.normals, programInfo.attribLocations.vertexNormal);
    if (buffers.color !== undefined && programInfo.attribLocations.vertexColor !== undefined) $b125b9470601071f$export$5d3c14eddb229f8b(gl, buffers.color, programInfo.attribLocations.vertexColor);
    if (buffers.objectIdColor !== null && buffers.objectIdColor !== undefined && programInfo.attribLocations.objectIdColor !== undefined) $b125b9470601071f$export$5d3c14eddb229f8b(gl, buffers.objectIdColor, programInfo.attribLocations.objectIdColor);
    if (buffers.objectInfo !== null && buffers.objectInfo !== undefined && programInfo.attribLocations.objectInfo !== undefined) $b125b9470601071f$export$5d3c14eddb229f8b(gl, buffers.objectInfo, programInfo.attribLocations.objectInfo);
    if (buffers.additionalObjectInfo !== null && buffers.additionalObjectInfo !== undefined && programInfo.attribLocations.additionalObjectInfo !== undefined) $b125b9470601071f$export$5d3c14eddb229f8b(gl, buffers.additionalObjectInfo, programInfo.attribLocations.additionalObjectInfo);
}
function $b125b9470601071f$export$9ed6815acb35f982(gl, programInfo, uniforms, texture, texture2) {
    if (uniforms.projectionMatrix !== undefined && programInfo.uniformLocations.projectionMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, uniforms.projectionMatrix);
    if (uniforms.viewMatrix !== undefined && programInfo.uniformLocations.viewMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.viewMatrix, false, uniforms.viewMatrix);
    if (uniforms.worldMatrix !== undefined && programInfo.uniformLocations.worldMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.worldMatrix, false, uniforms.worldMatrix);
    if (uniforms.modelViewMatrix !== undefined && programInfo.uniformLocations.modelViewMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.modelViewMatrix, false, uniforms.modelViewMatrix);
    if (uniforms.normalMatrix !== undefined && programInfo.uniformLocations.normalMatrix !== undefined) gl.uniformMatrix4fv(programInfo.uniformLocations.normalMatrix, false, uniforms.normalMatrix);
    if (uniforms.lightWorldPosition !== undefined && programInfo.uniformLocations.lightWorldPosition !== undefined) gl.uniform3fv(programInfo.uniformLocations.lightWorldPosition, uniforms.lightWorldPosition);
    if (uniforms.shininess !== undefined && programInfo.uniformLocations.shininess !== undefined) gl.uniform1f(programInfo.uniformLocations.shininess, uniforms.shininess);
    if (uniforms.textureIndex !== undefined && programInfo.uniformLocations.textureSampler !== undefined && texture !== undefined) {
        gl.activeTexture($b125b9470601071f$var$getGLTexture(gl, uniforms.textureIndex));
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.uniform1i(programInfo.uniformLocations.textureSampler, uniforms.textureIndex);
    }
    if (uniforms.textureIndex !== undefined && programInfo.uniformLocations.texture2Sampler !== undefined && texture2 !== undefined) {
        gl.activeTexture($b125b9470601071f$var$getGLTexture(gl, uniforms.textureIndex + 1));
        gl.bindTexture(gl.TEXTURE_2D, texture2);
        gl.uniform1i(programInfo.uniformLocations.texture2Sampler, uniforms.textureIndex + 1);
    }
    if (uniforms.color !== undefined && programInfo.uniformLocations.color !== undefined) gl.uniform4fv(programInfo.uniformLocations.color, uniforms.color);
    if (uniforms.time !== undefined && programInfo.uniformLocations.time !== undefined) gl.uniform1f(programInfo.uniformLocations.time, uniforms.time);
}
function $b125b9470601071f$var$setNormalAttribute(gl, normalsBuffer, vertexNormal) {
    const numComponents = 3;
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;
    gl.bindBuffer(gl.ARRAY_BUFFER, normalsBuffer);
    gl.vertexAttribPointer(vertexNormal, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(vertexNormal);
}
function $b125b9470601071f$export$5d3c14eddb229f8b(gl, colorsBuffer, vertexColor) {
    const numComponents = 4;
    const type = gl.FLOAT;
    const normalize = false;
    const stride = 0;
    const offset = 0;
    gl.bindBuffer(gl.ARRAY_BUFFER, colorsBuffer);
    gl.vertexAttribPointer(vertexColor, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(vertexColor);
}
function $b125b9470601071f$var$setPositionAttribute(gl, vertexBuffer, vertexPosition, numComponents) {
    const type = gl.FLOAT // the data in the buffer is 32bit floats
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set of values to the next
    ;
    // 0 = use type and numComponents above
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.vertexAttribPointer(vertexPosition, numComponents, type, normalize, stride, offset);
    gl.enableVertexAttribArray(vertexPosition);
}
function $b125b9470601071f$var$setTextureAttribute(gl, textureCoordsBuffer, textureCoordsPosition) {
    const num = 2 // every coordinate composed of 2 values
    ;
    const type = gl.FLOAT // the data in the buffer is 32-bit float
    ;
    const normalize = false // don't normalize
    ;
    const stride = 0 // how many bytes to get from one set to the next
    ;
    const offset = 0 // how many bytes inside the buffer to start from
    ;
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordsBuffer);
    gl.vertexAttribPointer(textureCoordsPosition, num, type, normalize, stride, offset);
    gl.enableVertexAttribArray(textureCoordsPosition);
}
function $b125b9470601071f$var$getGLTexture(gl, index) {
    return index == 0 ? gl.TEXTURE0 : index == 1 ? gl.TEXTURE1 : index == 2 ? gl.TEXTURE2 : index == 3 ? gl.TEXTURE3 : index == 4 ? gl.TEXTURE4 : index == 5 ? gl.TEXTURE5 : gl.TEXTURE0;
}


var $4201279bb1ce70f6$export$266137087bc184a6;
(function(RenderEffect) {
    RenderEffect[RenderEffect["None"] = 0] = "None";
    RenderEffect[RenderEffect["CRT"] = 1] = "CRT";
    RenderEffect[RenderEffect["AmberCRT"] = 2] = "AmberCRT";
    RenderEffect[RenderEffect["GreenCRT"] = 3] = "GreenCRT";
    RenderEffect[RenderEffect["VCR"] = 4] = "VCR";
})($4201279bb1ce70f6$export$266137087bc184a6 || ($4201279bb1ce70f6$export$266137087bc184a6 = {}));
const $4201279bb1ce70f6$var$globalRenderEffects = [
    0,
    1,
    2,
    3,
    4
];
function $4201279bb1ce70f6$export$b9078b15078e248(currentEffect) {
    const index = $4201279bb1ce70f6$var$globalRenderEffects.indexOf(currentEffect);
    if (index + 1 >= $4201279bb1ce70f6$var$globalRenderEffects.length) return $4201279bb1ce70f6$var$globalRenderEffects[0];
    return $4201279bb1ce70f6$var$globalRenderEffects[index + 1];
}
function $4201279bb1ce70f6$export$e5234cdd7d162a18(currentEffect) {
    const index = $4201279bb1ce70f6$var$globalRenderEffects.indexOf(currentEffect);
    if (index - 1 < 0) return $4201279bb1ce70f6$var$globalRenderEffects[$4201279bb1ce70f6$var$globalRenderEffects.length - 1];
    return $4201279bb1ce70f6$var$globalRenderEffects[index - 1];
}
function $4201279bb1ce70f6$var$initShaderProgram(gl, shaderSource) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, shaderSource);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler"),
            texture2Sampler: gl.getUniformLocation(shaderProgram, "uNoise"),
            resolution: gl.getUniformLocation(shaderProgram, "iResolution"),
            time: gl.getUniformLocation(shaderProgram, "iTime")
        }
    };
}
function $4201279bb1ce70f6$var$createRenderer(gl, width, height, source, noise) {
    const programInfo = $4201279bb1ce70f6$var$initShaderProgram(gl, source);
    const square = (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
        1.0,
        0.0,
        0.0,
        1.0
    ], null, true);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    const resolution = (0, $4ce98914b6676340$exports).fromValues(width, height);
    const dispose = ()=>{};
    const render = function(position, size, texture, time) {
        // the divide by two is because the model has extents of -1.0 to 1.0
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0] + size[0] / 2,
            position[1] + size[1] / 2,
            0.0
        ], [
            size[0] / 2,
            size[1] / 2,
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f5a01205d395aca)(gl, square, programInfo);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, square.indices);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            textureIndex: 0,
            time: time
        }, texture, noise.handle);
        gl.uniform2fv(programInfo.uniformLocations.resolution, resolution);
        const vertexCount = square.vertexCount;
        const type = gl.UNSIGNED_SHORT;
        const offset = 0;
        gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
    };
    return {
        render: render,
        dispose: dispose
    };
}
function $4201279bb1ce70f6$var$createFrameBuffer(gl, width, height) {
    const frameBufferTexture = (0, $6b248c1fdea83752$export$792a1e95a9bc00fc)(gl, width, height);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, frameBufferTexture, 0);
    const depthBuffer = gl.createRenderbuffer();
    gl.bindRenderbuffer(gl.RENDERBUFFER, depthBuffer);
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT32F, width, height);
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, depthBuffer);
    return {
        frameBuffer: frameBuffer,
        frameBufferTexture: frameBufferTexture
    };
}
function $4201279bb1ce70f6$export$230dc02396b6bf57(gl, resources, sceneRenderer) {
    const width = gl.canvas.width;
    const height = gl.canvas.height;
    // This sets up a frame buffer that will render to a texture and attaches a depth buffer to it
    const { frameBuffer: frameBuffer, frameBufferTexture: frameBufferTexture } = $4201279bb1ce70f6$var$createFrameBuffer(gl, width, height);
    const createGlobalRenderEffect = (src)=>$4201279bb1ce70f6$var$createRenderer(gl, width, height, src, resources.textures.noise);
    var globalEffects = new Map([
        [
            0,
            createGlobalRenderEffect(resources.shaderSource.simpleTexture)
        ],
        [
            1,
            createGlobalRenderEffect(resources.shaderSource.crt)
        ],
        [
            2,
            createGlobalRenderEffect(resources.shaderSource.amberCrt)
        ],
        [
            3,
            createGlobalRenderEffect(resources.shaderSource.greenCrt)
        ],
        [
            4,
            createGlobalRenderEffect(resources.shaderSource.vcr)
        ]
    ]);
    let time = 0.0;
    const dispose = ()=>{
        gl.deleteFramebuffer(frameBuffer);
        gl.deleteTexture(frameBufferTexture);
        globalEffects.forEach((ge)=>ge.dispose());
    };
    const render = (game, timeDelta, effect)=>{
        const projectionViewMatrix = (0, $6b248c1fdea83752$export$b4b257f6294f012)(game, width, height);
        time += timeDelta;
        // Now select the frame buffer
        (0, $6b248c1fdea83752$export$d1bc072841c808d0)(gl, frameBuffer, width, height);
        (0, $6b248c1fdea83752$export$441ba46c5fcd50d9)(gl);
        sceneRenderer(projectionViewMatrix, game, timeDelta);
        // finally target the output buffer and render our texture applying a whole screen post processing effect if
        // required
        (0, $6b248c1fdea83752$export$d1bc072841c808d0)(gl, null, width, height);
        globalEffects.get(effect).render([
            0,
            0
        ], [
            width,
            height
        ], frameBufferTexture, time);
    };
    return {
        render: render,
        dispose: dispose
    };
}







/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};




function $46c01301d2cf88f0$export$94f493b007b3adc5(value) {
    return (0, $e38eb280d3b76273$exports).fromValues((value >> 24 & 0xff) / 0xff, (value >> 16 & 0xff) / 0xff, (value >> 8 & 0xff) / 0xff, (value >> 0 & 0xff) / 0xff);
}
function $46c01301d2cf88f0$export$33148e2253a40f88(value) {
    return Math.floor(value[3] * 255.0) + (Math.floor(value[2] * 255.0) << 8) + (Math.floor(value[1] * 255.0) << 16) + (Math.floor(value[0] * 255.0) << 24);
}
function $46c01301d2cf88f0$export$80889d3a746c7e11(attributes, key, defaultValue) {
    if (attributes === undefined) return defaultValue;
    const attribute = attributes[key];
    if (attribute === undefined) return defaultValue;
    return attribute;
}



class $3c467ee21e482183$export$b89a827e9254211a {
    constructor(left, top, width, height){
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    copy() {
        return new $3c467ee21e482183$export$b89a827e9254211a(this.left, this.top, this.width, this.height);
    }
    get topLeft() {
        return (0, $4ce98914b6676340$exports).fromValues(this.left, this.top);
    }
    get topRight() {
        return (0, $4ce98914b6676340$exports).fromValues(this.left + this.width, this.top);
    }
    get bottomLeft() {
        return (0, $4ce98914b6676340$exports).fromValues(this.left, this.top + this.height);
    }
    get bottomRight() {
        return (0, $4ce98914b6676340$exports).fromValues(this.left + this.width, this.top + this.height);
    }
    get size() {
        return (0, $4ce98914b6676340$exports).fromValues(this.width, this.height);
    }
}


class $2f09a4173c5bae5d$export$74d9d957b4593718 {
    constructor(initialValue, evalFunc){
        this.internalValue = initialValue;
        this.evalFunc = evalFunc;
    }
    get value() {
        if (this.evalFunc !== undefined) this.internalValue = this.evalFunc();
        return this.internalValue;
    }
    set value(newValue) {
        if (newValue !== this.internalValue && this.evalFunc === undefined) {
            this.internalValue = newValue;
            if (this.onChange) this.onChange(newValue);
        }
    }
    static with(newValue) {
        return new $2f09a4173c5bae5d$export$74d9d957b4593718(newValue);
    }
}
function $2f09a4173c5bae5d$export$b117a75c60dd5fc1(value) {
    if (typeof value === "number") return new $2f09a4173c5bae5d$export$74d9d957b4593718(value);
    else return value;
}
function $2f09a4173c5bae5d$export$7c57ec354b9e0076(value) {
    if (typeof value === "boolean") return new $2f09a4173c5bae5d$export$74d9d957b4593718(value);
    else if (typeof value === "function") {
        const func = value;
        return new $2f09a4173c5bae5d$export$74d9d957b4593718(func(), func);
    } else return value;
}


/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $8f0e7f8ac8870583$var$Reflect;
(function(Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function(factory) {
        var root = typeof globalThis === "object" ? globalThis : typeof $parcel$global === "object" ? $parcel$global : typeof self === "object" ? self : typeof this === "object" ? this : sloppyModeThis();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect !== "undefined") exporter = makeExporter(root.Reflect, exporter);
        factory(exporter, root);
        if (typeof root.Reflect === "undefined") root.Reflect = Reflect;
        function makeExporter(target, previous) {
            return function(key, value) {
                Object.defineProperty(target, key, {
                    configurable: true,
                    writable: true,
                    value: value
                });
                if (previous) previous(key, value);
            };
        }
        function functionThis() {
            try {
                return Function("return this;")();
            } catch (_) {}
        }
        function indirectEvalThis() {
            try {
                return (0, eval)("(function() { return this; })()");
            } catch (_) {}
        }
        function sloppyModeThis() {
            return functionThis() || indirectEvalThis();
        }
    })(function(exporter, root) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = ({
            __proto__: []
        }) instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate ? function() {
                return MakeDictionary(Object.create(null));
            } : supportsProto ? function() {
                return MakeDictionary({
                    __proto__: null
                });
            } : function() {
                return MakeDictionary({});
            },
            has: downLevel ? function(map, key) {
                return hasOwn.call(map, key);
            } : function(map, key) {
                return key in map;
            },
            get: downLevel ? function(map, key) {
                return hasOwn.call(map, key) ? map[key] : undefined;
            } : function(map, key) {
                return map[key];
            }
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var _Map = typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        var registrySymbol = supportsSymbol ? Symbol.for("@reflect-metadata:registry") : undefined;
        var metadataRegistry = GetOrCreateMetadataRegistry();
        var metadataProvider = CreateMetadataProvider(metadataRegistry);
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */ function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsObject(target)) throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes)) throw new TypeError();
                if (IsNull(attributes)) attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            } else {
                if (!IsArray(decorators)) throw new TypeError();
                if (!IsConstructor(target)) throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */ function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target)) throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey)) throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */ function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */ function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */ function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */ function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            if (!IsObject(target)) throw new TypeError();
            if (!IsUndefined(propertyKey)) propertyKey = ToPropertyKey(propertyKey);
            var provider = GetMetadataProvider(target, propertyKey, /*Create*/ false);
            if (IsUndefined(provider)) return false;
            return provider.OrdinaryDeleteMetadata(metadataKey, target, propertyKey);
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated)) throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for(var i = decorators.length - 1; i >= 0; --i){
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated)) throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var provider = GetMetadataProvider(O, P, /*Create*/ false);
            if (IsUndefined(provider)) return false;
            return ToBoolean(provider.OrdinaryHasOwnMetadata(MetadataKey, O, P));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn) return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent)) return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var provider = GetMetadataProvider(O, P, /*Create*/ false);
            if (IsUndefined(provider)) return;
            return provider.OrdinaryGetOwnMetadata(MetadataKey, O, P);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var provider = GetMetadataProvider(O, P, /*Create*/ true);
            provider.OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null) return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0) return ownKeys;
            if (ownKeys.length <= 0) return parentKeys;
            var set = new _Set();
            var keys = [];
            for(var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++){
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for(var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++){
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var provider = GetMetadataProvider(O, P, /*create*/ false);
            if (!provider) return [];
            return provider.OrdinaryOwnMetadataKeys(O, P);
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null) return 1 /* Null */ ;
            switch(typeof x){
                case "undefined":
                    return 0 /* Undefined */ ;
                case "boolean":
                    return 2 /* Boolean */ ;
                case "string":
                    return 3 /* String */ ;
                case "symbol":
                    return 4 /* Symbol */ ;
                case "number":
                    return 5 /* Number */ ;
                case "object":
                    return x === null ? 1 /* Null */  : 6 /* Object */ ;
                default:
                    return 6 /* Object */ ;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch(Type(input)){
                case 0 /* Undefined */ :
                    return input;
                case 1 /* Null */ :
                    return input;
                case 2 /* Boolean */ :
                    return input;
                case 3 /* String */ :
                    return input;
                case 4 /* Symbol */ :
                    return input;
                case 5 /* Number */ :
                    return input;
            }
            var hint = PreferredType === 3 /* String */  ? "string" : PreferredType === 5 /* Number */  ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result)) throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result)) return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
            } else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result)) return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result)) return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */ );
            if (IsSymbol(key)) return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray ? Array.isArray(argument) : argument instanceof Object ? argument instanceof Array : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch(Type(argument)){
                case 3 /* String */ :
                    return true;
                case 4 /* Symbol */ :
                    return true;
                default:
                    return false;
            }
        }
        function SameValueZero(x, y) {
            return x === y || x !== x && y !== y;
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null) return undefined;
            if (!IsCallable(func)) throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method)) throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator)) throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f) f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype) return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype) return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype) return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function") return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O) return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // Global metadata registry
        // - Allows `import "reflect-metadata"` and `import "reflect-metadata/no-conflict"` to interoperate.
        // - Uses isolated metadata if `Reflect` is frozen before the registry can be installed.
        /**
         * Creates a registry used to allow multiple `reflect-metadata` providers.
         */ function CreateMetadataRegistry() {
            var fallback;
            if (!IsUndefined(registrySymbol) && typeof root.Reflect !== "undefined" && !(registrySymbol in root.Reflect) && typeof root.Reflect.defineMetadata === "function") // interoperate with older version of `reflect-metadata` that did not support a registry.
            fallback = CreateFallbackProvider(root.Reflect);
            var first;
            var second;
            var rest;
            var targetProviderMap = new _WeakMap();
            var registry = {
                registerProvider: registerProvider,
                getProvider: getProvider,
                setProvider: setProvider
            };
            return registry;
            function registerProvider(provider) {
                if (!Object.isExtensible(registry)) throw new Error("Cannot add provider to a frozen registry.");
                switch(true){
                    case fallback === provider:
                        break;
                    case IsUndefined(first):
                        first = provider;
                        break;
                    case first === provider:
                        break;
                    case IsUndefined(second):
                        second = provider;
                        break;
                    case second === provider:
                        break;
                    default:
                        if (rest === undefined) rest = new _Set();
                        rest.add(provider);
                        break;
                }
            }
            function getProviderNoCache(O, P) {
                if (!IsUndefined(first)) {
                    if (first.isProviderFor(O, P)) return first;
                    if (!IsUndefined(second)) {
                        if (second.isProviderFor(O, P)) return first;
                        if (!IsUndefined(rest)) {
                            var iterator = GetIterator(rest);
                            while(true){
                                var next = IteratorStep(iterator);
                                if (!next) return undefined;
                                var provider = IteratorValue(next);
                                if (provider.isProviderFor(O, P)) {
                                    IteratorClose(iterator);
                                    return provider;
                                }
                            }
                        }
                    }
                }
                if (!IsUndefined(fallback) && fallback.isProviderFor(O, P)) return fallback;
                return undefined;
            }
            function getProvider(O, P) {
                var providerMap = targetProviderMap.get(O);
                var provider;
                if (!IsUndefined(providerMap)) provider = providerMap.get(P);
                if (!IsUndefined(provider)) return provider;
                provider = getProviderNoCache(O, P);
                if (!IsUndefined(provider)) {
                    if (IsUndefined(providerMap)) {
                        providerMap = new _Map();
                        targetProviderMap.set(O, providerMap);
                    }
                    providerMap.set(P, provider);
                }
                return provider;
            }
            function hasProvider(provider) {
                if (IsUndefined(provider)) throw new TypeError();
                return first === provider || second === provider || !IsUndefined(rest) && rest.has(provider);
            }
            function setProvider(O, P, provider) {
                if (!hasProvider(provider)) throw new Error("Metadata provider not registered.");
                var existingProvider = getProvider(O, P);
                if (existingProvider !== provider) {
                    if (!IsUndefined(existingProvider)) return false;
                    var providerMap = targetProviderMap.get(O);
                    if (IsUndefined(providerMap)) {
                        providerMap = new _Map();
                        targetProviderMap.set(O, providerMap);
                    }
                    providerMap.set(P, provider);
                }
                return true;
            }
        }
        /**
         * Gets or creates the shared registry of metadata providers.
         */ function GetOrCreateMetadataRegistry() {
            var metadataRegistry;
            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) metadataRegistry = root.Reflect[registrySymbol];
            if (IsUndefined(metadataRegistry)) metadataRegistry = CreateMetadataRegistry();
            if (!IsUndefined(registrySymbol) && IsObject(root.Reflect) && Object.isExtensible(root.Reflect)) Object.defineProperty(root.Reflect, registrySymbol, {
                enumerable: false,
                configurable: false,
                writable: false,
                value: metadataRegistry
            });
            return metadataRegistry;
        }
        function CreateMetadataProvider(registry) {
            // [[Metadata]] internal slot
            // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
            var metadata = new _WeakMap();
            var provider = {
                isProviderFor: function(O, P) {
                    var targetMetadata = metadata.get(O);
                    if (IsUndefined(targetMetadata)) return false;
                    return targetMetadata.has(P);
                },
                OrdinaryDefineOwnMetadata: OrdinaryDefineOwnMetadata,
                OrdinaryHasOwnMetadata: OrdinaryHasOwnMetadata,
                OrdinaryGetOwnMetadata: OrdinaryGetOwnMetadata,
                OrdinaryOwnMetadataKeys: OrdinaryOwnMetadataKeys,
                OrdinaryDeleteMetadata: OrdinaryDeleteMetadata
            };
            metadataRegistry.registerProvider(provider);
            return provider;
            function GetOrCreateMetadataMap(O, P, Create) {
                var targetMetadata = metadata.get(O);
                var createdTargetMetadata = false;
                if (IsUndefined(targetMetadata)) {
                    if (!Create) return undefined;
                    targetMetadata = new _Map();
                    metadata.set(O, targetMetadata);
                    createdTargetMetadata = true;
                }
                var metadataMap = targetMetadata.get(P);
                if (IsUndefined(metadataMap)) {
                    if (!Create) return undefined;
                    metadataMap = new _Map();
                    targetMetadata.set(P, metadataMap);
                    if (!registry.setProvider(O, P, provider)) {
                        targetMetadata.delete(P);
                        if (createdTargetMetadata) metadata.delete(O);
                        throw new Error("Wrong provider for target.");
                    }
                }
                return metadataMap;
            }
            // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
            function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return false;
                return ToBoolean(metadataMap.has(MetadataKey));
            }
            // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
            function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return undefined;
                return metadataMap.get(MetadataKey);
            }
            // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
            function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
                metadataMap.set(MetadataKey, MetadataValue);
            }
            // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
            // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
            function OrdinaryOwnMetadataKeys(O, P) {
                var keys = [];
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return keys;
                var keysObj = metadataMap.keys();
                var iterator = GetIterator(keysObj);
                var k = 0;
                while(true){
                    var next = IteratorStep(iterator);
                    if (!next) {
                        keys.length = k;
                        return keys;
                    }
                    var nextValue = IteratorValue(next);
                    try {
                        keys[k] = nextValue;
                    } catch (e) {
                        try {
                            IteratorClose(iterator);
                        } finally{
                            throw e;
                        }
                    }
                    k++;
                }
            }
            function OrdinaryDeleteMetadata(MetadataKey, O, P) {
                var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
                if (IsUndefined(metadataMap)) return false;
                if (!metadataMap.delete(MetadataKey)) return false;
                if (metadataMap.size === 0) {
                    var targetMetadata = metadata.get(O);
                    if (!IsUndefined(targetMetadata)) {
                        targetMetadata.delete(P);
                        if (targetMetadata.size === 0) metadata.delete(targetMetadata);
                    }
                }
                return true;
            }
        }
        function CreateFallbackProvider(reflect) {
            var defineMetadata = reflect.defineMetadata, hasOwnMetadata = reflect.hasOwnMetadata, getOwnMetadata = reflect.getOwnMetadata, getOwnMetadataKeys = reflect.getOwnMetadataKeys, deleteMetadata = reflect.deleteMetadata;
            var metadataOwner = new _WeakMap();
            var provider = {
                isProviderFor: function(O, P) {
                    var metadataPropertySet = metadataOwner.get(O);
                    if (!IsUndefined(metadataPropertySet)) return metadataPropertySet.has(P);
                    if (getOwnMetadataKeys(O, P).length) {
                        if (IsUndefined(metadataPropertySet)) {
                            metadataPropertySet = new _Set();
                            metadataOwner.set(O, metadataPropertySet);
                        }
                        metadataPropertySet.add(P);
                        return true;
                    }
                    return false;
                },
                OrdinaryDefineOwnMetadata: defineMetadata,
                OrdinaryHasOwnMetadata: hasOwnMetadata,
                OrdinaryGetOwnMetadata: getOwnMetadata,
                OrdinaryOwnMetadataKeys: getOwnMetadataKeys,
                OrdinaryDeleteMetadata: deleteMetadata
            };
            return provider;
        }
        /**
         * Gets the metadata provider for an object. If the object has no metadata provider and this is for a create operation,
         * then this module's metadata provider is assigned to the object.
         */ function GetMetadataProvider(O, P, Create) {
            var registeredProvider = metadataRegistry.getProvider(O, P);
            if (!IsUndefined(registeredProvider)) return registeredProvider;
            if (Create) {
                if (metadataRegistry.setProvider(O, P, metadataProvider)) return metadataProvider;
                throw new Error("Illegal state.");
            }
            return undefined;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ function() {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function() {
                    return this;
                };
                MapIterator.prototype[iteratorSymbol] = function() {
                    return this;
                };
                MapIterator.prototype.next = function() {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        } else this._index++;
                        return {
                            value: result,
                            done: false
                        };
                    }
                    return {
                        value: undefined,
                        done: true
                    };
                };
                MapIterator.prototype.throw = function(error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function(value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return {
                        value: value,
                        done: true
                    };
                };
                return MapIterator;
            }();
            var Map1 = /** @class */ function() {
                function Map1() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map1.prototype, "size", {
                    get: function() {
                        return this._keys.length;
                    },
                    enumerable: true,
                    configurable: true
                });
                Map1.prototype.has = function(key) {
                    return this._find(key, /*insert*/ false) >= 0;
                };
                Map1.prototype.get = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map1.prototype.set = function(key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map1.prototype.delete = function(key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for(var i = index + 1; i < size; i++){
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (SameValueZero(key, this._cacheKey)) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map1.prototype.clear = function() {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map1.prototype.keys = function() {
                    return new MapIterator(this._keys, this._values, getKey);
                };
                Map1.prototype.values = function() {
                    return new MapIterator(this._keys, this._values, getValue);
                };
                Map1.prototype.entries = function() {
                    return new MapIterator(this._keys, this._values, getEntry);
                };
                Map1.prototype["@@iterator"] = function() {
                    return this.entries();
                };
                Map1.prototype[iteratorSymbol] = function() {
                    return this.entries();
                };
                Map1.prototype._find = function(key, insert) {
                    if (!SameValueZero(this._cacheKey, key)) {
                        this._cacheIndex = -1;
                        for(var i = 0; i < this._keys.length; i++)if (SameValueZero(this._keys[i], key)) {
                            this._cacheIndex = i;
                            break;
                        }
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map1;
            }();
            return Map1;
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [
                    key,
                    value
                ];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            var Set1 = /** @class */ function() {
                function Set1() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set1.prototype, "size", {
                    get: function() {
                        return this._map.size;
                    },
                    enumerable: true,
                    configurable: true
                });
                Set1.prototype.has = function(value) {
                    return this._map.has(value);
                };
                Set1.prototype.add = function(value) {
                    return this._map.set(value, value), this;
                };
                Set1.prototype.delete = function(value) {
                    return this._map.delete(value);
                };
                Set1.prototype.clear = function() {
                    this._map.clear();
                };
                Set1.prototype.keys = function() {
                    return this._map.keys();
                };
                Set1.prototype.values = function() {
                    return this._map.keys();
                };
                Set1.prototype.entries = function() {
                    return this._map.entries();
                };
                Set1.prototype["@@iterator"] = function() {
                    return this.keys();
                };
                Set1.prototype[iteratorSymbol] = function() {
                    return this.keys();
                };
                return Set1;
            }();
            return Set1;
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ function() {
                function WeakMap1() {
                    this._key = CreateUniqueKey();
                }
                WeakMap1.prototype.has = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap1.prototype.get = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap1.prototype.set = function(target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap1.prototype.delete = function(target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap1.prototype.clear = function() {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap1;
            }();
            function CreateUniqueKey() {
                var key;
                do key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create) return undefined;
                    Object.defineProperty(target, rootKey, {
                        value: HashMap.create()
                    });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for(var i = 0; i < size; ++i)buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined") return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined") return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for(var offset = 0; offset < UUID_SIZE; ++offset){
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8) result += "-";
                    if (byte < 16) result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})($8f0e7f8ac8870583$var$Reflect || ($8f0e7f8ac8870583$var$Reflect = {}));


function $353b5110e2c290c2$export$c84671f46d6a1ca() {
    return function(target, propertyKey) {
        const pkey = typeof propertyKey === "string" ? propertyKey : propertyKey.description;
        const backingFieldSymbol = `_${pkey}`;
        if (!target.hasOwnProperty(backingFieldSymbol)) target[backingFieldSymbol] = target[pkey];
        // Delete the original property
        if (delete target[pkey]) // Create new property with getter and setter
        Object.defineProperty(target, pkey, {
            get: function() {
                return this[backingFieldSymbol];
            },
            set: function(newValue) {
                if (target[backingFieldSymbol] !== undefined) {
                    const prop = this[backingFieldSymbol];
                    if (prop.value != newValue.value) {
                        prop.value = newValue.value;
                        this._layoutRequired = true;
                    }
                } else {
                    this[backingFieldSymbol] = newValue;
                    this._layoutRequired = true;
                }
            },
            enumerable: false,
            configurable: true
        });
    };
}


var $d7c3074262118be2$export$d94dcb5bec64086e;
(function(HorizontalAlignment) {
    HorizontalAlignment[HorizontalAlignment["Left"] = 0] = "Left";
    HorizontalAlignment[HorizontalAlignment["Middle"] = 1] = "Middle";
    HorizontalAlignment[HorizontalAlignment["Right"] = 2] = "Right";
})($d7c3074262118be2$export$d94dcb5bec64086e || ($d7c3074262118be2$export$d94dcb5bec64086e = {}));
var $d7c3074262118be2$export$80aaf7ab7c413899;
(function(SizeToFit) {
    SizeToFit[SizeToFit["None"] = 0] = "None";
    SizeToFit[SizeToFit["Width"] = 1] = "Width";
    SizeToFit[SizeToFit["Height"] = 2] = "Height";
    SizeToFit[SizeToFit["WidthAndHeight"] = 3] = "WidthAndHeight";
})($d7c3074262118be2$export$80aaf7ab7c413899 || ($d7c3074262118be2$export$80aaf7ab7c413899 = {}));
class $d7c3074262118be2$export$dff6abe3fa9858c4 {
    constructor(attributes, children){
        this._layoutRequired = true;
        this.children = children;
        let isVisible = undefined;
        if (attributes !== undefined) {
            const left = attributes["left"];
            if (left !== undefined) this.left = (0, $2f09a4173c5bae5d$export$b117a75c60dd5fc1)(left);
            const top = attributes["top"];
            if (top !== undefined) this.top = (0, $2f09a4173c5bae5d$export$b117a75c60dd5fc1)(top);
            const width = attributes["width"];
            if (width !== undefined) this.width = new (0, $2f09a4173c5bae5d$export$74d9d957b4593718)(width);
            const height = attributes["height"];
            if (height !== undefined) this.height = new (0, $2f09a4173c5bae5d$export$74d9d957b4593718)(height);
            const padding = attributes["padding"];
            if (padding !== undefined) this.padding = new (0, $2f09a4173c5bae5d$export$74d9d957b4593718)(padding);
            const isVisibleAttr = attributes["isVisible"];
            if (isVisibleAttr !== undefined) isVisible = (0, $2f09a4173c5bae5d$export$7c57ec354b9e0076)(isVisibleAttr);
        }
        this.isVisible = isVisible ?? (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(true);
        this.sizeToFitParent = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(attributes, "sizeToFitParent", 0) //sizeToFit(attributeOrDefault(attributes, "sizeToFitParent", "none"))
        ;
        this.outerFrame = new (0, $3c467ee21e482183$export$b89a827e9254211a)(-1, -1, -1, -1);
        this.innerFrame = this.outerFrame.copy();
        this.objectId = null;
    }
    get position() {
        return (0, $4ce98914b6676340$exports).fromValues(this.outerFrame.left, this.outerFrame.top);
    }
    get topRight() {
        return (0, $4ce98914b6676340$exports).fromValues(this.outerFrame.left + this.outerFrame.width, this.outerFrame.top);
    }
    get bottomLeft() {
        return (0, $4ce98914b6676340$exports).fromValues(this.outerFrame.left, this.outerFrame.top + this.outerFrame.height);
    }
    get size() {
        return (0, $4ce98914b6676340$exports).fromValues(this.outerFrame.width, this.outerFrame.height);
    }
    get isInteractive() {
        return false;
    }
    renderFlow(context, control, children) {
        const resolvedFrame = new (0, $3c467ee21e482183$export$b89a827e9254211a)(context.frame.left + this.outerFrame.left, context.frame.top + this.outerFrame.top, this.outerFrame.width, this.outerFrame.height);
        const thisContext = {
            ...context,
            frame: resolvedFrame
        };
        control(thisContext);
        const padding = this.padding?.value ?? 0;
        const innerFrame = new (0, $3c467ee21e482183$export$b89a827e9254211a)(context.frame.left + this.outerFrame.left, context.frame.top + this.outerFrame.top, this.outerFrame.width, this.outerFrame.height);
        const childFrame = {
            ...context,
            frame: innerFrame
        };
        this.children.forEach((c)=>children(c, childFrame));
    }
    render(context) {
        if (!this.isVisible.value) return;
        this.renderFlow(context, (ctx)=>this.renderControl(ctx), (ctrl, ctx)=>ctrl.render(ctx));
    }
    renderControl(context) {}
    renderObjectPicker(context) {
        if (!this.isVisible.value) return;
        this.renderFlow(context, (ctx)=>this.renderObjectPickerControl(ctx), (ctrl, ctx)=>ctrl.renderObjectPicker(ctx));
    }
    renderObjectPickerControl(context) {}
    layout(context) {
        //if (!this._layoutRequired) return
        this.outerFrame = new (0, $3c467ee21e482183$export$b89a827e9254211a)((this.left?.value ?? 0) + context.frame.left, (this.top?.value ?? 0) + context.frame.top, (this.sizeToFitParent & 1) === 1 ? context.frame.width - (this.left?.value ?? 0) : this.width?.value ?? -1, (this.sizeToFitParent & 2) === 2 ? context.frame.height - (this.top?.value ?? 0) : this.height?.value ?? -1);
        this.layoutChildren(context);
    }
    calculateInnerFrame() {
        const padding = this.padding?.value ?? 0;
        return new (0, $3c467ee21e482183$export$b89a827e9254211a)(padding, padding, this.outerFrame.width - padding * 2, this.outerFrame.height - padding * 2);
    }
    layoutChildren(context) {
        const innerFrame = this.calculateInnerFrame();
        this.children.forEach((c)=>c.layout({
                ...context,
                frame: innerFrame,
                parent: this
            }));
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $353b5110e2c290c2$export$c84671f46d6a1ca)()
], $d7c3074262118be2$export$dff6abe3fa9858c4.prototype, "left", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $353b5110e2c290c2$export$c84671f46d6a1ca)()
], $d7c3074262118be2$export$dff6abe3fa9858c4.prototype, "top", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $353b5110e2c290c2$export$c84671f46d6a1ca)()
], $d7c3074262118be2$export$dff6abe3fa9858c4.prototype, "width", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $353b5110e2c290c2$export$c84671f46d6a1ca)()
], $d7c3074262118be2$export$dff6abe3fa9858c4.prototype, "height", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $353b5110e2c290c2$export$c84671f46d6a1ca)()
], $d7c3074262118be2$export$dff6abe3fa9858c4.prototype, "padding", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $353b5110e2c290c2$export$c84671f46d6a1ca)()
], $d7c3074262118be2$export$dff6abe3fa9858c4.prototype, "isVisible", void 0);


function $96fe3a99b59d4e0f$export$b87ac40d93907239(objectId) {
    return (0, $e38eb280d3b76273$exports).fromValues((objectId >> 0 & 0xff) / 0xff, (objectId >> 8 & 0xff) / 0xff, (objectId >> 16 & 0xff) / 0xff, (objectId >> 24 & 0xff) / 0xff);
}
function $96fe3a99b59d4e0f$export$a4a96014f5f7182e(data) {
    return data[0] + (data[1] << 8) + (data[2] << 16) + (data[3] << 24);
}
function $96fe3a99b59d4e0f$export$79fe3c21609d3982(objectId, mapSize) {
    return {
        x: Math.floor(objectId % mapSize),
        y: Math.floor(objectId / mapSize)
    };
}
function $96fe3a99b59d4e0f$export$34e7e97d0c3c203e(value) {
    switch(value){
        case "middle":
            return (0, $d7c3074262118be2$export$d94dcb5bec64086e).Middle;
        case "right":
            return (0, $d7c3074262118be2$export$d94dcb5bec64086e).Right;
        default:
            return (0, $d7c3074262118be2$export$d94dcb5bec64086e).Left;
    }
}
function $96fe3a99b59d4e0f$export$4577f149a860e3e5(value) {
    switch(value){
        case "width":
            return (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width;
        case "height":
            return (0, $d7c3074262118be2$export$80aaf7ab7c413899).Height;
        case "widthAndHeight":
            return (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight;
        case "none":
            return (0, $d7c3074262118be2$export$80aaf7ab7c413899).None;
    }
}
function $96fe3a99b59d4e0f$export$5f8c1fa73181ace8(range) {
    return {
        left: Math.min(range.start.x, range.end.x),
        top: Math.min(range.start.y, range.end.y),
        right: Math.max(range.start.x, range.end.x),
        bottom: Math.max(range.start.y, range.end.y)
    };
}


function $27957a4d435d2c0f$export$a4ba47fb37e20d42() {
    return {
        mapForwards: false,
        mapLeft: false,
        mapBackwards: false,
        mapRight: false,
        mapRotateClockwise: false,
        mapRotateAnticlockwise: false,
        mouseZoom: 0,
        mousePosition: {
            x: 0,
            y: 0
        },
        mouseButtons: {
            left: false,
            right: false
        }
    };
}




function $b0f378f81618fc12$export$31292c3816ebd5b3() {
    return {
        residential: 0,
        commercial: 0,
        industrial: 0
    };
}
function $b0f378f81618fc12$export$a4c25a570331cfa2(simulationLandscape) {
    return {
        population: {
            ...$b0f378f81618fc12$export$31292c3816ebd5b3(),
            total: 0
        },
        valves: $b0f378f81618fc12$export$31292c3816ebd5b3(),
        valveMaximums: {
            residential: 2000,
            commercial: 1500,
            industrial: 1500
        },
        valveHistory: Array.from({
            length: 120
        }, ()=>$b0f378f81618fc12$export$31292c3816ebd5b3()),
        time: {
            clock: 0.0,
            lastPowerGridUpdateAt: 0.0,
            lastZoneUpdateAt: 0.0
        },
        taxLevel: 3,
        taxTable: Array.from({
            length: 20
        }, (_, index)=>index),
        landscape: simulationLandscape,
        buildings: new Map()
    };
}


var $bd101182371a0deb$export$724f6b867059ef5f;
(function(Tool) {
    Tool[Tool["None"] = 0] = "None";
    Tool[Tool["Road"] = 1] = "Road";
    Tool[Tool["ClearTerrain"] = 2] = "ClearTerrain";
    Tool[Tool["RaiseTerrain"] = 3] = "RaiseTerrain";
    Tool[Tool["LowerTerrain"] = 4] = "LowerTerrain";
    Tool[Tool["Dezone"] = 5] = "Dezone";
    Tool[Tool["LightResidential"] = 6] = "LightResidential";
    Tool[Tool["DenseResidential"] = 7] = "DenseResidential";
    Tool[Tool["LightCommercial"] = 8] = "LightCommercial";
    Tool[Tool["DenseCommercial"] = 9] = "DenseCommercial";
    Tool[Tool["LightIndustrial"] = 10] = "LightIndustrial";
    Tool[Tool["DenseIndustrial"] = 11] = "DenseIndustrial";
    Tool[Tool["PowerLine"] = 12] = "PowerLine";
    Tool[Tool["CoalPowerPlant"] = 13] = "CoalPowerPlant";
    Tool[Tool["NuclearPowerPlant"] = 14] = "NuclearPowerPlant";
    Tool[Tool["SolarPowerPlant"] = 15] = "SolarPowerPlant";
    Tool[Tool["WindTurbine"] = 16] = "WindTurbine";
})($bd101182371a0deb$export$724f6b867059ef5f || ($bd101182371a0deb$export$724f6b867059ef5f = {}));
var $bd101182371a0deb$export$ddbdda658d7cd694;
(function(ToolSelectionMode) {
    ToolSelectionMode[ToolSelectionMode["None"] = 0] = "None";
    ToolSelectionMode[ToolSelectionMode["Single"] = 1] = "Single";
    ToolSelectionMode[ToolSelectionMode["Range"] = 2] = "Range";
    ToolSelectionMode[ToolSelectionMode["Prefab"] = 3] = "Prefab";
})($bd101182371a0deb$export$ddbdda658d7cd694 || ($bd101182371a0deb$export$ddbdda658d7cd694 = {}));
var $bd101182371a0deb$export$dcb506b218208434;
(function(DifficultyLevel) {
    DifficultyLevel[DifficultyLevel["Easy"] = 0] = "Easy";
    DifficultyLevel[DifficultyLevel["Medium"] = 1] = "Medium";
    DifficultyLevel[DifficultyLevel["Hard"] = 2] = "Hard";
})($bd101182371a0deb$export$dcb506b218208434 || ($bd101182371a0deb$export$dcb506b218208434 = {}));
const $bd101182371a0deb$var$distance = 32 // Distance from the scene center, adjust based on your scene size
;
const $bd101182371a0deb$var$isometricAngle = 35.264 // Tilt angle in degrees
;
const $bd101182371a0deb$var$radians = (0, $78ae820aa9ececfa$exports).toRadian($bd101182371a0deb$var$isometricAngle) // * (Math.PI / 180) // Convert angle to radians
;
// Calculate camera position
const $bd101182371a0deb$var$eyeX = $bd101182371a0deb$var$distance * Math.cos($bd101182371a0deb$var$radians) * Math.sqrt(2) / 2;
const $bd101182371a0deb$var$eyeY = 32 * Math.sin($bd101182371a0deb$var$radians);
const $bd101182371a0deb$var$eyeZ = $bd101182371a0deb$var$distance * Math.cos($bd101182371a0deb$var$radians) * Math.sqrt(2) / 2;
function $bd101182371a0deb$export$b112baf41a575b61(simulationLandscape, rendererLandscape) {
    const defaultWindowState = ()=>({
            isVisible: (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(false),
            left: (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(500),
            top: (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(50)
        });
    return {
        controlState: {
            current: (0, $27957a4d435d2c0f$export$a4ba47fb37e20d42)(),
            previous: (0, $27957a4d435d2c0f$export$a4ba47fb37e20d42)()
        },
        view: {
            position: (0, $ab7f6dc0910e1ef7$exports).fromValues($bd101182371a0deb$var$eyeX, $bd101182371a0deb$var$eyeY, $bd101182371a0deb$var$eyeZ),
            lookAt: (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 0, 0),
            rotation: 0,
            targetRotation: null,
            zoom: 5
        },
        light: {
            direction: (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 300, 0)
        },
        buildingLight: {
            direction: (0, $ab7f6dc0910e1ef7$exports).fromValues(0, 300, 0)
        },
        powerPulse: {
            level: 0.0,
            opacity: 0.7
        },
        powerlineModels: Array.from({
            length: simulationLandscape.size
        }, ()=>new Array(simulationLandscape.size).fill(null)),
        landscape: rendererLandscape,
        selectedObjectId: null,
        simulation: (0, $b0f378f81618fc12$export$a4c25a570331cfa2)(simulationLandscape),
        difficultyLevel: 0,
        gui: {
            windows: {
                zoning: defaultWindowState(),
                bulldozer: defaultWindowState(),
                power: defaultWindowState(),
                info: defaultWindowState()
            },
            currentTool: 0,
            selection: null,
            layers: {
                power: false,
                buildings: true,
                zones: true
            }
        }
    };
}


var $342158d303fb2c9a$export$9b9b94eedad86502;
(function(TerrainTypeEnum) {
    TerrainTypeEnum[TerrainTypeEnum["Plain"] = 0] = "Plain";
    TerrainTypeEnum[TerrainTypeEnum["Grass"] = 1] = "Grass";
    TerrainTypeEnum[TerrainTypeEnum["Water"] = 2] = "Water";
})($342158d303fb2c9a$export$9b9b94eedad86502 || ($342158d303fb2c9a$export$9b9b94eedad86502 = {}));
var $342158d303fb2c9a$export$2483f397fd596eb8;
(function(ElevatedZoneEnum) {
    ElevatedZoneEnum[ElevatedZoneEnum["None"] = 0] = "None";
    ElevatedZoneEnum[ElevatedZoneEnum["PowerLine"] = 1] = "PowerLine";
})($342158d303fb2c9a$export$2483f397fd596eb8 || ($342158d303fb2c9a$export$2483f397fd596eb8 = {}));
var $342158d303fb2c9a$export$d6725ccf2a601a8d;
(function(ZoneEnum) {
    ZoneEnum[ZoneEnum["None"] = 0] = "None";
    ZoneEnum[ZoneEnum["LightResidential"] = 1] = "LightResidential";
    ZoneEnum[ZoneEnum["DenseResidential"] = 2] = "DenseResidential";
    ZoneEnum[ZoneEnum["LightCommercial"] = 3] = "LightCommercial";
    ZoneEnum[ZoneEnum["DenseCommercial"] = 4] = "DenseCommercial";
    ZoneEnum[ZoneEnum["LightIndustrial"] = 5] = "LightIndustrial";
    ZoneEnum[ZoneEnum["DenseIndustrial"] = 6] = "DenseIndustrial";
    ZoneEnum[ZoneEnum["Road"] = 7] = "Road";
    ZoneEnum[ZoneEnum["CoalPowerPlant"] = 8] = "CoalPowerPlant";
})($342158d303fb2c9a$export$d6725ccf2a601a8d || ($342158d303fb2c9a$export$d6725ccf2a601a8d = {}));
var $342158d303fb2c9a$export$1a3ef2e71e8411ab;
(function(LandscapeTexture) {
    LandscapeTexture[LandscapeTexture["RoadNorthSouth"] = 0] = "RoadNorthSouth";
    LandscapeTexture[LandscapeTexture["RoadEastWest"] = 1] = "RoadEastWest";
    LandscapeTexture[LandscapeTexture["RoadNorthEast"] = 2] = "RoadNorthEast";
    LandscapeTexture[LandscapeTexture["RoadNorthWest"] = 3] = "RoadNorthWest";
    LandscapeTexture[LandscapeTexture["RoadNorthToEastWest"] = 4] = "RoadNorthToEastWest";
    LandscapeTexture[LandscapeTexture["RoadWestToNorthSouth"] = 5] = "RoadWestToNorthSouth";
    LandscapeTexture[LandscapeTexture["RoadSouthEast"] = 6] = "RoadSouthEast";
    LandscapeTexture[LandscapeTexture["RoadSouthWest"] = 7] = "RoadSouthWest";
    LandscapeTexture[LandscapeTexture["RoadEastTNorthSouth"] = 8] = "RoadEastTNorthSouth";
    LandscapeTexture[LandscapeTexture["RoadSouthTEastWest"] = 9] = "RoadSouthTEastWest";
    LandscapeTexture[LandscapeTexture["RoadCrossroads"] = 10] = "RoadCrossroads";
    LandscapeTexture[LandscapeTexture["RoadNorthStub"] = 11] = "RoadNorthStub";
    LandscapeTexture[LandscapeTexture["RoadSouthStub"] = 12] = "RoadSouthStub";
    LandscapeTexture[LandscapeTexture["RoadWestStub"] = 13] = "RoadWestStub";
    LandscapeTexture[LandscapeTexture["RoadEastStub"] = 14] = "RoadEastStub";
    LandscapeTexture[LandscapeTexture["RoadIsolate"] = 15] = "RoadIsolate";
})($342158d303fb2c9a$export$1a3ef2e71e8411ab || ($342158d303fb2c9a$export$1a3ef2e71e8411ab = {}));


function $062f33e36c4b51df$export$33310c7323b98d23(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).ClearTerrain:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).RaiseTerrain:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LowerTerrain:
            return false;
        default:
            return true;
    }
}
function $062f33e36c4b51df$export$bdb857808a1c9e63(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).RaiseTerrain:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LowerTerrain:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).ClearTerrain:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Road:
            return true;
        default:
            return false;
    }
}
function $062f33e36c4b51df$export$774dc1e17bc20c30(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightCommercial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightIndustrial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightResidential:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseResidential:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseIndustrial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseCommercial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Dezone:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Road:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine:
            return (0, $bd101182371a0deb$export$ddbdda658d7cd694).Range;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).ClearTerrain:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LowerTerrain:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).RaiseTerrain:
            return (0, $bd101182371a0deb$export$ddbdda658d7cd694).Single // we actually want this to be a direction locked "1 unit wide" range
            ;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).CoalPowerPlant:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).NuclearPowerPlant:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).WindTurbine:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).SolarPowerPlant:
            return (0, $bd101182371a0deb$export$ddbdda658d7cd694).Prefab;
        default:
            return (0, $bd101182371a0deb$export$ddbdda658d7cd694).None;
    }
}
function $062f33e36c4b51df$export$e0afb1a06840e23d(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Road:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine:
            return true;
        default:
            return false;
    }
}
function $062f33e36c4b51df$export$1d4d18fba3efd3d6(tool, tileInfo) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightCommercial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightIndustrial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightResidential:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseResidential:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseIndustrial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseCommercial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).CoalPowerPlant:
            return tileInfo.isFlat;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Road:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Dezone:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine:
            // actually we can't road and powerlines to every kind of slope so we need to add that here
            return true;
        default:
            return false;
    }
}
function $062f33e36c4b51df$export$4c66c50cdfefffaa(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine:
            return true;
        default:
            return false;
    }
}
function $062f33e36c4b51df$export$823ce3235b6e647b(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightCommercial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightIndustrial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightResidential:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseResidential:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseIndustrial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseCommercial:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Road:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Dezone:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).CoalPowerPlant:
            return true;
        default:
            return false;
    }
}
function $062f33e36c4b51df$export$71c8031283bc130e(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine:
            return (0, $342158d303fb2c9a$export$2483f397fd596eb8).PowerLine;
        default:
            return (0, $342158d303fb2c9a$export$2483f397fd596eb8).None;
    }
}
function $062f33e36c4b51df$export$d6c9745c2b081ac3(tool) {
    switch(tool){
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightCommercial:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).LightCommercial;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightIndustrial:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).LightIndustrial;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).LightResidential:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).LightResidential;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseResidential:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).DenseResidential;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseIndustrial:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).DenseIndustrial;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseCommercial:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).DenseCommercial;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Road:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).Road;
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).CoalPowerPlant:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).CoalPowerPlant;
        default:
        case (0, $bd101182371a0deb$export$724f6b867059ef5f).Dezone:
            return (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).None;
    }
}


function $3b85c34af31bdb96$var$packLayerConfiguration(layers) {
    return (layers.power ? 1 : 0) + (layers.buildings ? 2 : 0) + (layers.zones ? 4 : 0);
}
function $3b85c34af31bdb96$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.directional);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor"),
            objectIdColor: gl.getAttribLocation(shaderProgram, "aTileId"),
            objectInfo: gl.getAttribLocation(shaderProgram, "aObjectInfo"),
            additionalObjectInfo: gl.getAttribLocation(shaderProgram, "aAdditionalObjectInfo"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            worldMatrix: gl.getUniformLocation(shaderProgram, "uWorldMatrix"),
            viewMatrix: gl.getUniformLocation(shaderProgram, "uViewMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            lightWorldPosition: gl.getUniformLocation(shaderProgram, "uLightWorldPosition"),
            lineColorPosition: gl.getUniformLocation(shaderProgram, "uLineColor"),
            zoomedTileSize: gl.getUniformLocation(shaderProgram, "uZoomedTileSize"),
            uSelectedTileId: gl.getUniformLocation(shaderProgram, "uSelectedTileId"),
            uMapSize: gl.getUniformLocation(shaderProgram, "uMapSize"),
            uRangeLeft: gl.getUniformLocation(shaderProgram, "uRangeLeft"),
            uRangeTop: gl.getUniformLocation(shaderProgram, "uRangeTop"),
            uRangeRight: gl.getUniformLocation(shaderProgram, "uRangeRight"),
            uRangeBottom: gl.getUniformLocation(shaderProgram, "uRangeBottom"),
            uAllowRangeOnSloped: gl.getUniformLocation(shaderProgram, "uAllowRangeOnSloped"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uTextureSampler"),
            uLayerConfiguration: gl.getUniformLocation(shaderProgram, "uLayerConfiguration")
        }
    };
}
function $3b85c34af31bdb96$var$initPickerShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.objectPicking);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            objectIdColor: gl.getAttribLocation(shaderProgram, "aVertexColor")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix")
        }
    };
}
function $3b85c34af31bdb96$export$b4d03d0dcd77df78(gl, resources) {
    const programInfo = $3b85c34af31bdb96$var$initShaderProgram(gl, resources);
    const pickerProgramInfo = $3b85c34af31bdb96$var$initPickerShaderProgram(gl, resources);
    const dispose = ()=>{};
    const render = (projectionMatrix, game)=>{
        gl.useProgram(programInfo.program);
        const lightPosition = game.light.direction;
        let worldMatrix = (0, $26675c4f95835ef1$exports).create();
        const normalMatrix = (0, $26675c4f95835ef1$exports).create();
        (0, $26675c4f95835ef1$exports).invert(normalMatrix, worldMatrix);
        (0, $26675c4f95835ef1$exports).transpose(normalMatrix, normalMatrix);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: worldMatrix,
            normalMatrix: normalMatrix,
            lightWorldPosition: lightPosition,
            textureIndex: 0
        }, resources.textures.landscape.handle);
        const selectedObjectId = (0, $96fe3a99b59d4e0f$export$b87ac40d93907239)(game.selectedObjectId ?? -1);
        gl.uniform1i(programInfo.uniformLocations.uMapSize, game.simulation.landscape.size);
        if (game.gui.selection !== null) {
            const r = (0, $96fe3a99b59d4e0f$export$5f8c1fa73181ace8)(game.gui.selection);
            gl.uniform1i(programInfo.uniformLocations.uRangeLeft, r.left);
            // noinspection JSSuspiciousNameCombination
            gl.uniform1i(programInfo.uniformLocations.uRangeTop, r.top);
            // noinspection JSSuspiciousNameCombination
            gl.uniform1i(programInfo.uniformLocations.uRangeBottom, r.bottom);
            gl.uniform1i(programInfo.uniformLocations.uRangeRight, r.right);
        } else {
            gl.uniform1i(programInfo.uniformLocations.uRangeLeft, -1);
            gl.uniform1i(programInfo.uniformLocations.uRangeTop, -1);
            gl.uniform1i(programInfo.uniformLocations.uRangeBottom, -1);
            gl.uniform1i(programInfo.uniformLocations.uRangeRight, -1);
        }
        gl.uniform1i(programInfo.uniformLocations.uAllowRangeOnSloped, (0, $062f33e36c4b51df$export$bdb857808a1c9e63)(game.gui.currentTool) ? 1 : 0);
        gl.uniform4fv(programInfo.uniformLocations.uSelectedTileId, selectedObjectId);
        gl.uniform1f(programInfo.uniformLocations.zoomedTileSize, (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile * 1.5);
        gl.uniform4fv(programInfo.uniformLocations.lineColorPosition, [
            120.0 / 255.0,
            92.0 / 255.0,
            40.0 / 255.0,
            1.0
        ]);
        gl.uniform1i(programInfo.uniformLocations.uLayerConfiguration, $3b85c34af31bdb96$var$packLayerConfiguration(game.gui.layers));
        game.landscape.chunks.forEach((chunk)=>{
            (0, $b125b9470601071f$export$f5a01205d395aca)(gl, chunk.model, programInfo);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, chunk.model.indices);
            const vertexCount = chunk.model.vertexCount;
            const type = gl.UNSIGNED_SHORT;
            const offset = 0;
            gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
        });
    };
    const renderObjectPicker = (projectionMatrix, game)=>{
        gl.useProgram(pickerProgramInfo.program);
        let worldMatrix = (0, $26675c4f95835ef1$exports).create();
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, pickerProgramInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: worldMatrix
        });
        game.landscape.chunks.forEach((chunk)=>{
            (0, $b125b9470601071f$export$f5a01205d395aca)(gl, chunk.model, pickerProgramInfo);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, chunk.model.indices);
            const vertexCount = chunk.model.vertexCount;
            const type = gl.UNSIGNED_SHORT;
            const offset = 0;
            gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
        });
    };
    return {
        dispose: dispose,
        render: render,
        renderObjectPicker: renderObjectPicker
    };
}



function $42e66745a803db06$export$6ff9e6a1f2205960(controlState) {
    const setControl = (e, newState)=>{
        let handled = true;
        switch(e.key){
            case "w":
            case "W":
            case "ArrowUp":
                controlState.mapForwards = newState;
                break;
            case "s":
            case "S":
            case "ArrowDown":
                controlState.mapBackwards = newState;
                break;
            case "a":
            case "A":
            case "ArrowLeft":
                controlState.mapLeft = newState;
                break;
            case "d":
            case "D":
            case "ArrowRight":
                controlState.mapRight = newState;
                break;
            case "e":
            case "E":
                controlState.mapRotateClockwise = newState;
                break;
            case "q":
            case "Q":
                controlState.mapRotateAnticlockwise = newState;
                break;
            default:
                handled = false;
        }
        if (handled) e.preventDefault();
    };
    const keyDown = (e)=>setControl(e, true);
    const keyUp = (e)=>setControl(e, false);
    window.addEventListener("keydown", keyDown);
    window.addEventListener("keyup", keyUp);
    return ()=>{
        window.removeEventListener("keydown", keyDown);
        window.removeEventListener("keyup", keyUp);
    };
}








const $002cbbc91e2fdd97$var$waterVoxelsPerTile = 4;
const $002cbbc91e2fdd97$var$waterVoxelSize = (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile / $002cbbc91e2fdd97$var$waterVoxelsPerTile;
function $002cbbc91e2fdd97$export$d65402acc8627110(gl, landscape, chunkSize) {
    const waterChunks = [];
    for(let y = 0; y < landscape.size - 1; y += chunkSize)for(let x = 0; x < landscape.size - 1; x += chunkSize){
        const toX = Math.min(landscape.size - 1, x + chunkSize - 1);
        const toY = Math.min(landscape.size - 1, y + chunkSize - 1);
        const chunk = {
            fromX: x,
            fromZ: y,
            model: $002cbbc91e2fdd97$var$createWaterChunk(gl, landscape, x, y, toX, toY)
        };
        waterChunks.push(chunk);
    }
    return {
        chunks: waterChunks
    };
}
const $002cbbc91e2fdd97$var$createEmptyChunk = ()=>({
        positions: [],
        indices: [],
        normals: [],
        colors: [],
        offsets: []
    });
function $002cbbc91e2fdd97$var$createWaterChunk(gl, landscape, fromX, fromZ, toX, toZ) {
    let currentChunk = $002cbbc91e2fdd97$var$createEmptyChunk();
    for(let z = fromZ; z <= toZ; z++){
        let row = landscape.tileInfo[z];
        for(let x = fromX; x <= toX; x++){
            const tileInfo = row[x];
            $002cbbc91e2fdd97$var$createVoxelForTileInfo(currentChunk, landscape, tileInfo, x, z);
        }
    }
    return $002cbbc91e2fdd97$var$createWaterRenderingModel(gl, currentChunk);
}
function $002cbbc91e2fdd97$var$createVoxelForTileInfo(currentChunk, landscape, tileInfo, x, y) {
    if (tileInfo.terrain === (0, $342158d303fb2c9a$export$9b9b94eedad86502).Water) {
        $002cbbc91e2fdd97$var$addWaterToChunk(currentChunk, landscape.size - 1, x, y);
        if (x > 0 && landscape.tileInfo[y][x - 1].terrain != (0, $342158d303fb2c9a$export$9b9b94eedad86502).Water) $002cbbc91e2fdd97$var$addBorderVoxel(currentChunk, landscape.size - 1, x - 1, y);
        if (x < landscape.size - 1 && landscape.tileInfo[y][x + 1].terrain != (0, $342158d303fb2c9a$export$9b9b94eedad86502).Water) $002cbbc91e2fdd97$var$addBorderVoxel(currentChunk, landscape.size - 1, x + 1, y);
        if (y > 0 && landscape.tileInfo[y - 1][x].terrain != (0, $342158d303fb2c9a$export$9b9b94eedad86502).Water) $002cbbc91e2fdd97$var$addBorderVoxel(currentChunk, landscape.size - 1, x, y - 1);
        if (y < landscape.size - 1 && landscape.tileInfo[y + 1][x].terrain != (0, $342158d303fb2c9a$export$9b9b94eedad86502).Water) $002cbbc91e2fdd97$var$addBorderVoxel(currentChunk, landscape.size - 1, x, y + 1);
    }
}
function $002cbbc91e2fdd97$export$14f9d47804476afd(gl, landscape) {
    let currentChunk = $002cbbc91e2fdd97$var$createEmptyChunk();
    let water = {
        chunks: []
    };
    for(let y = 0; y < landscape.size - 1; y++)for(let x = 0; x < landscape.size - 1; x++){
        const tileInfo = landscape.tileInfo[y][x];
        $002cbbc91e2fdd97$var$createVoxelForTileInfo(currentChunk, landscape, tileInfo, x, y);
        if (currentChunk.positions.length > 48000) {
            water.chunks.push({
                model: $002cbbc91e2fdd97$var$createWaterRenderingModel(gl, currentChunk),
                fromX: -1,
                fromZ: -1
            });
            currentChunk = $002cbbc91e2fdd97$var$createEmptyChunk();
        }
    }
    if (currentChunk.positions.length > 0) water.chunks.push({
        model: $002cbbc91e2fdd97$var$createWaterRenderingModel(gl, currentChunk),
        fromX: -1,
        fromZ: -1
    });
    return water;
}
function $002cbbc91e2fdd97$var$createWaterRenderingModel(gl, data) {
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data.positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data.normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(data.indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data.colors), gl.STATIC_DRAW);
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([]), gl.STATIC_DRAW);
    const objectInfoBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, objectInfoBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(data.offsets), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        objectIdColor: null,
        objectInfo: objectInfoBuffer,
        additionalObjectInfo: null,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: data.indices.length,
        textureCoords: textureCoordBuffer,
        texture: null
    };
}
const $002cbbc91e2fdd97$var$baseCubePositions = [
    // Front face
    0.0,
    0.0,
    1.0,
    1.0,
    0.0,
    1.0,
    1.0,
    1.0,
    1.0,
    0.0,
    1.0,
    1.0,
    // Back face
    0.0,
    0.0,
    0.0,
    0.0,
    1.0,
    0.0,
    1.0,
    1.0,
    0.0,
    1.0,
    0.0,
    0.0,
    // Top face
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    1.0,
    0.0,
    // Bottom face
    0.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    // Right face
    1.0,
    0.0,
    0.0,
    1.0,
    1.0,
    0.0,
    1.0,
    1.0,
    1.0,
    1.0,
    0.0,
    1.0,
    // Left face
    0.0,
    0.0,
    0.0,
    0.0,
    0.0,
    1.0,
    0.0,
    1.0,
    1.0,
    0.0,
    1.0,
    0.0
];
const $002cbbc91e2fdd97$var$baseCubeIndices = [
    0,
    1,
    2,
    0,
    2,
    3,
    4,
    5,
    6,
    4,
    6,
    7,
    8,
    9,
    10,
    8,
    10,
    11,
    12,
    13,
    14,
    12,
    14,
    15,
    16,
    17,
    18,
    16,
    18,
    19,
    20,
    21,
    22,
    20,
    22,
    23
];
const $002cbbc91e2fdd97$var$baseCubeNormals = [
    // Front
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    // Back
    0.0,
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    // Top
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    // Bottom
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    // Right
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    1.0,
    0.0,
    0.0,
    // Left
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    0.0,
    -1,
    0.0,
    0.0
];
function $002cbbc91e2fdd97$var$addWaterToChunk(chunk, mapSize, tileX, tileY) {
    for(let subZ = 0; subZ < $002cbbc91e2fdd97$var$waterVoxelsPerTile; subZ++)for(let subX = 0; subX < $002cbbc91e2fdd97$var$waterVoxelsPerTile; subX++)$002cbbc91e2fdd97$var$addWavingVoxel(chunk, mapSize, tileX, tileY, subX, subZ);
}
function $002cbbc91e2fdd97$var$addBorderVoxel(chunk, mapSize, tileX, tileY) {
    const offset = chunk.positions.length / 3;
    const voxelX = (tileX - mapSize / 2) * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile - (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile;
    const voxelZ = (mapSize / 2 - tileY) * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile;
    const waveOffset = -1 // don't wave it
    ;
    const color = [
        0.0,
        52.0 / 255.0,
        107.0 / 255.0,
        1.0
    ];
    for(let pi = 0; pi < $002cbbc91e2fdd97$var$baseCubePositions.length; pi += 3){
        chunk.positions.push($002cbbc91e2fdd97$var$baseCubePositions[pi] * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile + voxelX);
        chunk.positions.push($002cbbc91e2fdd97$var$baseCubePositions[pi + 1] * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile - (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile - 0.1);
        chunk.positions.push($002cbbc91e2fdd97$var$baseCubePositions[pi + 2] * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile + voxelZ);
    }
    chunk.normals = [
        ...chunk.normals,
        ...$002cbbc91e2fdd97$var$baseCubeNormals
    ];
    $002cbbc91e2fdd97$var$baseCubeIndices.forEach((vertexIndex)=>chunk.indices.push(vertexIndex + offset));
    for(let vi = 0; vi < $002cbbc91e2fdd97$var$baseCubePositions.length / 3; vi++){
        chunk.colors.push(color[0]);
        chunk.colors.push(color[1]);
        chunk.colors.push(color[2]);
        chunk.colors.push(color[3]);
        chunk.offsets.push(waveOffset);
        chunk.offsets.push(waveOffset);
        chunk.offsets.push(waveOffset);
        chunk.offsets.push(waveOffset);
    }
}
function $002cbbc91e2fdd97$var$addWavingVoxel(chunk, mapSize, tileX, tileY, subX, subY) {
    const offset = chunk.positions.length / 3;
    const voxelX = (tileX - mapSize / 2) * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile - (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile + subX * $002cbbc91e2fdd97$var$waterVoxelSize;
    const voxelZ = (mapSize / 2 - tileY) * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile + subY * $002cbbc91e2fdd97$var$waterVoxelSize;
    const waterX = tileX * $002cbbc91e2fdd97$var$waterVoxelsPerTile + subX;
    const waterZ = tileY * $002cbbc91e2fdd97$var$waterVoxelsPerTile + subY;
    const waveOffset = waterZ % 8;
    const darkColor = [
        4.0 / 255.0,
        79.0 / 255.0,
        159.0 / 255.0,
        1.0
    ];
    const lightColor = [
        22.0 / 255.0,
        114.0 / 255.0,
        212.0 / 255.0,
        1.0
    ];
    const color = waterZ % 2 == 0 ? waterX % 2 == 0 ? darkColor : lightColor : waterX % 2 == 0 ? lightColor : darkColor;
    for(let pi = 0; pi < $002cbbc91e2fdd97$var$baseCubePositions.length; pi += 3){
        chunk.positions.push($002cbbc91e2fdd97$var$baseCubePositions[pi] * $002cbbc91e2fdd97$var$waterVoxelSize + voxelX);
        chunk.positions.push($002cbbc91e2fdd97$var$baseCubePositions[pi + 1] * $002cbbc91e2fdd97$var$waterVoxelSize - $002cbbc91e2fdd97$var$waterVoxelSize);
        chunk.positions.push($002cbbc91e2fdd97$var$baseCubePositions[pi + 2] * $002cbbc91e2fdd97$var$waterVoxelSize + voxelZ);
    }
    chunk.normals = [
        ...chunk.normals,
        ...$002cbbc91e2fdd97$var$baseCubeNormals
    ];
    $002cbbc91e2fdd97$var$baseCubeIndices.forEach((vertexIndex)=>chunk.indices.push(vertexIndex + offset));
    for(let vi = 0; vi < $002cbbc91e2fdd97$var$baseCubePositions.length / 3; vi++){
        chunk.colors.push(color[0]);
        chunk.colors.push(color[1]);
        chunk.colors.push(color[2]);
        chunk.colors.push(color[3]);
        chunk.offsets.push(waveOffset);
        chunk.offsets.push(waveOffset);
        chunk.offsets.push(waveOffset);
        chunk.offsets.push(waveOffset);
    }
}


const $aeab7555fdde6942$var$chunkSize = 32;
function $aeab7555fdde6942$var$getChunksForRange(landscape, range) {
    const r = (0, $96fe3a99b59d4e0f$export$5f8c1fa73181ace8)(range);
    return landscape.chunks.filter((c)=>c.fromX <= r.right && c.fromX + $aeab7555fdde6942$var$chunkSize >= r.left && c.fromY <= r.bottom && c.fromY + $aeab7555fdde6942$var$chunkSize >= r.top);
}
function $aeab7555fdde6942$var$vecFromTileInfo(tileInfo) {
    // I can imagine us eventually having enough info that we have to bit twiddle it in
    return [
        (0, $e38eb280d3b76273$exports).fromValues(tileInfo.terrain, tileInfo.zone, tileInfo.isFlat ? 1.0 : 0.0, tileInfo.isPoweredByBuildingId !== null ? 1.0 : 0.0),
        (0, $e38eb280d3b76273$exports).fromValues((tileInfo.textureIndex ?? -1) + 1.0, tileInfo.elevatedZone, 0.0, 0.0)
    ];
}
function $aeab7555fdde6942$export$efede7f0dce421e8(gl, game, range) {
    const chunks = $aeab7555fdde6942$var$getChunksForRange(game.landscape, range);
    chunks.forEach((chunk)=>{
        const toX = Math.min(game.simulation.landscape.size - 1, chunk.fromX + $aeab7555fdde6942$var$chunkSize - 1);
        const toY = Math.min(game.simulation.landscape.size - 1, chunk.fromY + $aeab7555fdde6942$var$chunkSize - 1);
        const tileInfos = [];
        const additionalTileInfos = [];
        for(let y = chunk.fromY; y <= toY; y++){
            let row = game.simulation.landscape.tileInfo[y];
            for(let x = chunk.fromX; x <= toX; x++){
                const tileInfo = row[x];
                // I can imagine us eventually having enough info that we have to bit twiddle it in
                const [vectorTileInfo, vectorAdditionalTileInfo] = $aeab7555fdde6942$var$vecFromTileInfo(tileInfo);
                for(let v = 0; v < 6; v++){
                    tileInfos.push(vectorTileInfo[0]);
                    tileInfos.push(vectorTileInfo[1]);
                    tileInfos.push(vectorTileInfo[2]);
                    tileInfos.push(vectorTileInfo[3]);
                    additionalTileInfos.push(vectorAdditionalTileInfo[0]);
                    additionalTileInfos.push(vectorAdditionalTileInfo[1]);
                    additionalTileInfos.push(vectorAdditionalTileInfo[2]);
                    additionalTileInfos.push(vectorAdditionalTileInfo[3]);
                }
            }
        }
        gl.deleteBuffer(chunk.model.objectInfo);
        gl.deleteBuffer(chunk.model.additionalObjectInfo);
        const tileInfoBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, tileInfoBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(tileInfos), gl.STATIC_DRAW);
        chunk.model.objectInfo = tileInfoBuffer;
        const additionalTileInfoBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, additionalTileInfoBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(additionalTileInfos), gl.STATIC_DRAW);
        chunk.model.additionalObjectInfo = additionalTileInfoBuffer;
    });
}
function $aeab7555fdde6942$export$124d1786ae41597c(gl, simulationLandscape) {
    let heightMapSize = simulationLandscape.size;
    const landscape = {
        chunkSize: $aeab7555fdde6942$var$chunkSize,
        chunks: [],
        water: {
            chunks: []
        }
    };
    const heights = simulationLandscape.heights;
    const tileInfo = simulationLandscape.tileInfo;
    for(let y = 0; y < heightMapSize - 1; y += $aeab7555fdde6942$var$chunkSize)for(let x = 0; x < heightMapSize - 1; x += $aeab7555fdde6942$var$chunkSize){
        const toX = Math.min(heightMapSize - 1, x + $aeab7555fdde6942$var$chunkSize - 1);
        const toY = Math.min(heightMapSize - 1, y + $aeab7555fdde6942$var$chunkSize - 1);
        const chunk = {
            fromX: x,
            fromY: y,
            model: $aeab7555fdde6942$var$createLandscapeChunk(gl, heights, tileInfo, x, y, toX, toY, heightMapSize)
        };
        landscape.chunks.push(chunk);
    }
    landscape.water = (0, $002cbbc91e2fdd97$export$d65402acc8627110)(gl, simulationLandscape, $aeab7555fdde6942$var$chunkSize);
    return landscape;
}
function $aeab7555fdde6942$var$createLandscapeChunk(gl, heights, tileInfo, fromX, fromY, toX, toY, heightMapSize) {
    const positions = [];
    const indices = [];
    const normals = [];
    const textureCoords = [];
    const colors = [];
    const tileInfos = [];
    const additionalTileInfos = [];
    const objectIdColors = [];
    const half = (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile / 2;
    const faceIndices = [
        0,
        1,
        2,
        3,
        4,
        5
    ] //[3, 0, 1, 3, 1, 2]
    ;
    const dirt = (0, $e38eb280d3b76273$exports).fromValues(152.0 / 255.0, 132.0 / 255.0, 68.0 / 255.0, 1.0);
    const leftExtent = (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile * heights[0].length / 2;
    const topExtent = -(0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile * heights[0].length / 2;
    for(let y = fromY; y <= toY; y++){
        let rowTopHeights = heights[y];
        let rowBottomHeights = heights[y + 1];
        if (rowBottomHeights === undefined) debugger;
        let rowZones = tileInfo[y];
        const top = -(0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile * y - topExtent;
        for(let x = fromX; x <= toX; x++){
            const tileInfo = rowZones[x];
            //if (tileInfo.terrain === TerrainTypeEnum.Water) continue
            const objectId = y * heightMapSize + x;
            const objectIdColor = (0, $96fe3a99b59d4e0f$export$b87ac40d93907239)(objectId);
            const left = (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile * x - leftExtent;
            const indexOffset = positions.length / 3;
            const cellHeights = [
                rowTopHeights[x],
                rowTopHeights[x + 1],
                rowBottomHeights[x + 1],
                rowBottomHeights[x]
            ];
            const v = [
                (0, $ab7f6dc0910e1ef7$exports).fromValues(-half + left, rowTopHeights[x], half + top),
                (0, $ab7f6dc0910e1ef7$exports).fromValues(half + left, rowTopHeights[x + 1], half + top),
                (0, $ab7f6dc0910e1ef7$exports).fromValues(half + left, rowBottomHeights[x + 1], -half + top),
                (0, $ab7f6dc0910e1ef7$exports).fromValues(-half + left, rowBottomHeights[x], -half + top)
            ];
            // I can imagine us eventually having enough info that we have to bit twiddle it in
            const [vectorTileInfo, vectorAdditionalTileInfo] = $aeab7555fdde6942$var$vecFromTileInfo(tileInfo);
            const vertexTextureCoords = [
                [
                    0.0,
                    1.0
                ],
                [
                    1.0,
                    1.0
                ],
                [
                    1.0,
                    0.0
                ],
                [
                    0.0,
                    0.0
                ]
            ];
            // Any landscape tiles that have two faces (saddle, 3-high etc,) need forming from specifically arranged
            // triangles so that the normals can be set correctly
            const groupedHeights = $aeab7555fdde6942$var$getHeightCount(cellHeights);
            if (groupedHeights.min.count === 2 && groupedHeights.max.count === 2 && $aeab7555fdde6942$var$heightsAlternate(cellHeights)) {
                const firstLowPoint = cellHeights.indexOf(groupedHeights.min.height);
                const t1 = [
                    $aeab7555fdde6942$var$getAsRollingArray(v, firstLowPoint),
                    $aeab7555fdde6942$var$getAsRollingArray(v, firstLowPoint + 1),
                    $aeab7555fdde6942$var$getAsRollingArray(v, firstLowPoint + 2)
                ];
                const t2 = [
                    $aeab7555fdde6942$var$getAsRollingArray(v, firstLowPoint),
                    $aeab7555fdde6942$var$getAsRollingArray(v, firstLowPoint - 2),
                    $aeab7555fdde6942$var$getAsRollingArray(v, firstLowPoint - 1)
                ];
                const n1 = $aeab7555fdde6942$var$calculateTriangleNormal(t1[0], t1[1], t1[2]);
                const n2 = $aeab7555fdde6942$var$calculateTriangleNormal(t2[0], t2[1], t2[2]);
                const combinedVertex = [
                    ...t1,
                    ...t2
                ];
                const combinedNormals = [
                    n1,
                    n1,
                    n1,
                    n2,
                    n2,
                    n2
                ];
                combinedVertex.flatMap((p)=>[
                        p[0],
                        p[1],
                        p[2]
                    ]).forEach((p)=>positions.push(p));
                combinedNormals.flatMap((n)=>[
                        n[0],
                        n[1],
                        n[2]
                    ]).forEach((n)=>normals.push(n));
                faceIndices.forEach((i)=>indices.push(i + indexOffset));
                const shapeTextureCoords = [
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, firstLowPoint),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, firstLowPoint + 1),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, firstLowPoint + 2),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, firstLowPoint),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, firstLowPoint - 2),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, firstLowPoint - 1)
                ];
                shapeTextureCoords.flatMap((tc)=>tc).forEach((tc)=>textureCoords.push(tc));
            } else if (groupedHeights.max.count === 3) {
                // we're dealing with a "3-high" or a "1-high"
                // first we get the center point - this is the index of the height with the lowest count,
                // the high point or low point
                const centerIndex = cellHeights.indexOf(groupedHeights.min.height);
                const oppositeIndex = centerIndex - 2;
                // build a triangle around the center
                const t1 = [
                    $aeab7555fdde6942$var$getAsRollingArray(v, centerIndex - 1),
                    $aeab7555fdde6942$var$getAsRollingArray(v, centerIndex),
                    $aeab7555fdde6942$var$getAsRollingArray(v, centerIndex + 1)
                ];
                const t2 = [
                    $aeab7555fdde6942$var$getAsRollingArray(v, oppositeIndex - 1),
                    $aeab7555fdde6942$var$getAsRollingArray(v, oppositeIndex),
                    $aeab7555fdde6942$var$getAsRollingArray(v, oppositeIndex + 1)
                ];
                const n1 = $aeab7555fdde6942$var$calculateTriangleNormal(t1[0], t1[1], t1[2]);
                const n2 = $aeab7555fdde6942$var$calculateTriangleNormal(t2[0], t2[1], t2[2]);
                const combinedVertex = [
                    ...t1,
                    ...t2
                ];
                const combinedNormals = [
                    n1,
                    n1,
                    n1,
                    n2,
                    n2,
                    n2
                ];
                combinedVertex.flatMap((p)=>[
                        p[0],
                        p[1],
                        p[2]
                    ]).forEach((p)=>positions.push(p));
                combinedNormals.flatMap((n)=>[
                        n[0],
                        n[1],
                        n[2]
                    ]).forEach((n)=>normals.push(n));
                faceIndices.forEach((i)=>indices.push(i + indexOffset));
                const shapeTextureCoords = [
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, centerIndex - 1),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, centerIndex),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, centerIndex + 1),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, oppositeIndex - 1),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, oppositeIndex),
                    $aeab7555fdde6942$var$getAsRollingArray(vertexTextureCoords, oppositeIndex + 1)
                ];
                shapeTextureCoords.flatMap((tc)=>tc).forEach((tc)=>textureCoords.push(tc));
            } else {
                const vertexIndices = [
                    3,
                    0,
                    1,
                    3,
                    1,
                    2
                ];
                const tilePositions = vertexIndices.flatMap((vi)=>[
                        v[vi][0],
                        v[vi][1],
                        v[vi][2]
                    ]);
                tilePositions.forEach((p)=>positions.push(p));
                faceIndices.forEach((i)=>indices.push(i + indexOffset));
                vertexIndices.map((vi)=>vertexTextureCoords[vi]).flatMap((vtc)=>[
                        vtc[0],
                        vtc[1]
                    ]).forEach((vtc)=>textureCoords.push(vtc));
                const n1 = $aeab7555fdde6942$var$calculateTriangleNormal(v[3], v[0], v[1]);
                faceIndices.flatMap((_)=>[
                        n1[0],
                        n1[1],
                        n1[2]
                    ]).forEach((n)=>normals.push(n));
            }
            for(let v = 0; v < 6; v++){
                // useful for finding saddles
                // let color = x === 127 && y === 84 ? fire : grass
                const color = dirt;
                colors.push(color[0]);
                colors.push(color[1]);
                colors.push(color[2]);
                colors.push(color[3]);
                objectIdColors.push(objectIdColor[0]);
                objectIdColors.push(objectIdColor[1]);
                objectIdColors.push(objectIdColor[2]);
                objectIdColors.push(objectIdColor[3]);
                tileInfos.push(vectorTileInfo[0]);
                tileInfos.push(vectorTileInfo[1]);
                tileInfos.push(vectorTileInfo[2]);
                tileInfos.push(vectorTileInfo[3]);
                additionalTileInfos.push(vectorAdditionalTileInfo[0]);
                additionalTileInfos.push(vectorAdditionalTileInfo[1]);
                additionalTileInfos.push(vectorAdditionalTileInfo[2]);
                additionalTileInfos.push(vectorAdditionalTileInfo[3]);
            }
        }
    }
    const positionBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(positions), gl.STATIC_DRAW);
    const normalBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, normalBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(normals), gl.STATIC_DRAW);
    const indexBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), gl.STATIC_DRAW);
    const colorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, colorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colors), gl.STATIC_DRAW);
    const tileInfoBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, tileInfoBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(tileInfos), gl.STATIC_DRAW);
    const additionalTileInfoBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, additionalTileInfoBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(additionalTileInfos), gl.STATIC_DRAW);
    const objectIdColorBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, objectIdColorBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(objectIdColors), gl.STATIC_DRAW);
    const textureCoordBuffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, textureCoordBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(textureCoords), gl.STATIC_DRAW);
    return {
        position: positionBuffer,
        color: colorBuffer,
        objectIdColor: objectIdColorBuffer,
        objectInfo: tileInfoBuffer,
        additionalObjectInfo: additionalTileInfoBuffer,
        indices: indexBuffer,
        normals: normalBuffer,
        vertexCount: indices.length,
        textureCoords: textureCoordBuffer,
        texture: null
    };
}
function $aeab7555fdde6942$var$calculateTriangleNormal(v1, v2, v3) {
    const edge1 = (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), v2, v1);
    const edge2 = (0, $ab7f6dc0910e1ef7$exports).subtract((0, $ab7f6dc0910e1ef7$exports).create(), v3, v1);
    const normal = (0, $ab7f6dc0910e1ef7$exports).cross((0, $ab7f6dc0910e1ef7$exports).create(), edge1, edge2);
    (0, $ab7f6dc0910e1ef7$exports).normalize(normal, normal);
    return normal;
}
function $aeab7555fdde6942$var$getHeightCount(heights) {
    const result = new Map();
    const max = {
        height: -1,
        count: -1
    };
    heights.forEach((h)=>{
        let c = result.get(h);
        if (c === undefined) {
            c = {
                height: h,
                count: 0
            };
            result.set(h, c);
        }
        c.count++;
        if (c.count > max.count) {
            max.count = c.count;
            max.height = c.height;
        }
    });
    const min = {
        height: -1,
        count: 10000
    };
    result.forEach((r)=>{
        if (r.count < min.count) {
            min.height = r.height;
            min.count = r.count;
        }
    });
    return {
        heights: result,
        max: max,
        min: min
    };
}
function $aeab7555fdde6942$var$getAsRollingArray(items, index) {
    if (index < 0) index = items.length + index;
    if (index >= items.length) index = index - items.length;
    return items[index];
}
function $aeab7555fdde6942$var$heightsAlternate(heights) {
    if (heights.length < 2) return true;
    let currentValue = heights[0];
    for(let i = 1; i < heights.length; i++){
        const nextValue = heights[i];
        if (currentValue === nextValue) return false;
        currentValue = nextValue;
    }
    return true;
}


function $b1f5dc8e9ea362b8$export$10a20274f2224dff(controlState) {
    const wheel = (ev)=>controlState.mouseZoom = ev.deltaY;
    const mouseMove = (ev)=>controlState.mousePosition = {
            x: ev.clientX,
            y: ev.clientY
        };
    const mouseButtons = (ev)=>{
        ev.preventDefault();
        controlState.mouseButtons.left = (ev.buttons & 1) > 0;
        controlState.mouseButtons.right = (ev.buttons & 2) > 0;
    };
    const mouseUp = (ev)=>{
        ev.preventDefault();
        controlState.mouseButtons.left = (ev.buttons & 1) > 0;
        controlState.mouseButtons.right = (ev.buttons & 2) > 0;
    };
    window.addEventListener("wheel", wheel);
    window.addEventListener("mousemove", mouseMove);
    window.addEventListener("mousedown", mouseButtons);
    window.addEventListener("mouseup", mouseUp);
    return ()=>{
        window.removeEventListener("wheel", wheel);
    };
}




function $d98d276fb2a2b90f$export$fd37dabcec2bc46f(game, timeDelta) {
    const speed = (0, $9ecda7333d28e490$export$871de8747c9eaa88).movementSpeedTilesPerSecond * timeDelta * game.view.zoom // * (map.maxZoom - game.view.zoom)
    ;
    const delta = (0, $ab7f6dc0910e1ef7$exports).create();
    if (game.controlState.current.mapForwards) (0, $ab7f6dc0910e1ef7$exports).add(delta, delta, [
        -speed,
        0,
        -speed
    ]);
    else if (game.controlState.current.mapBackwards) (0, $ab7f6dc0910e1ef7$exports).add(delta, delta, [
        speed,
        0,
        speed
    ]);
    if (game.controlState.current.mapLeft) (0, $ab7f6dc0910e1ef7$exports).add(delta, delta, [
        -speed,
        0,
        speed
    ]);
    else if (game.controlState.current.mapRight) (0, $ab7f6dc0910e1ef7$exports).add(delta, delta, [
        speed,
        0,
        -speed
    ]);
    if (game.view.targetRotation === null) {
        if (game.controlState.current.mapRotateAnticlockwise && !game.controlState.previous.mapRotateAnticlockwise) game.view.targetRotation = game.view.rotation - 90;
        if (game.controlState.current.mapRotateClockwise && !game.controlState.previous.mapRotateClockwise) game.view.targetRotation = game.view.rotation + 90;
    }
    // translate our movement delta into so it is relative to the direction the camera is facing
    (0, $ab7f6dc0910e1ef7$exports).rotateY(delta, delta, [
        0,
        0,
        0
    ], (0, $78ae820aa9ececfa$exports).toRadian(game.view.rotation));
    (0, $ab7f6dc0910e1ef7$exports).add(game.view.position, game.view.position, delta);
    (0, $ab7f6dc0910e1ef7$exports).add(game.view.lookAt, game.view.lookAt, delta);
    game.view.zoom += game.controlState.current.mouseZoom * 0.01;
    if (game.view.zoom < (0, $9ecda7333d28e490$export$871de8747c9eaa88).minZoom) game.view.zoom = (0, $9ecda7333d28e490$export$871de8747c9eaa88).minZoom;
    else if (game.view.zoom > (0, $9ecda7333d28e490$export$871de8747c9eaa88).maxZoom) game.view.zoom = (0, $9ecda7333d28e490$export$871de8747c9eaa88).maxZoom;
}
function $d98d276fb2a2b90f$export$c02e7eb66ba9b6a7(game) {
    game.controlState.current.mouseZoom = 0;
    game.controlState.previous = {
        ...game.controlState.current,
        mousePosition: {
            ...game.controlState.current.mousePosition
        },
        mouseButtons: {
            ...game.controlState.current.mouseButtons
        }
    };
}




function $bdba9a3cd2da2555$var$createTexture(gl) {
    const targetTexture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, targetTexture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    return targetTexture;
}
function $bdba9a3cd2da2555$var$createDepthBuffer(gl) {
    const depthBuffer = gl.createRenderbuffer();
    gl.bindRenderbuffer(gl.RENDERBUFFER, depthBuffer);
    return depthBuffer;
}
function $bdba9a3cd2da2555$var$createFrameBuffer(gl, targetTexture, depthBuffer) {
    const fb = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
    // attach the texture as the first color attachment
    const attachmentPoint = gl.COLOR_ATTACHMENT0;
    const level = 0;
    gl.framebufferTexture2D(gl.FRAMEBUFFER, attachmentPoint, gl.TEXTURE_2D, targetTexture, level);
    // make a depth buffer and the same size as the targetTexture
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, depthBuffer);
    return fb;
}
function $bdba9a3cd2da2555$var$setFramebufferAttachmentSizes(gl, targetTexture, depthBuffer, width, height) {
    gl.bindTexture(gl.TEXTURE_2D, targetTexture);
    // define size and format of level 0
    const level = 0;
    const internalFormat = gl.RGBA;
    const border = 0;
    const format = gl.RGBA;
    const type = gl.UNSIGNED_BYTE;
    const data = null;
    gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, width, height, border, format, type, data);
    gl.bindRenderbuffer(gl.RENDERBUFFER, depthBuffer);
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, width, height);
}
function $bdba9a3cd2da2555$export$382274dfff412583(gl, resources, sceneRenderer) {
    const width = gl.canvas.width;
    const height = gl.canvas.height;
    let targetTexture = $bdba9a3cd2da2555$var$createTexture(gl);
    let depthBuffer = $bdba9a3cd2da2555$var$createDepthBuffer(gl);
    let frameBuffer = $bdba9a3cd2da2555$var$createFrameBuffer(gl, targetTexture, depthBuffer);
    $bdba9a3cd2da2555$var$setFramebufferAttachmentSizes(gl, targetTexture, depthBuffer, gl.canvas.width, gl.canvas.height);
    let selectedObjectId = -1;
    const dispose = ()=>{
        gl.deleteTexture(targetTexture);
        gl.deleteRenderbuffer(depthBuffer);
        gl.deleteFramebuffer(frameBuffer);
    };
    const render = (game, timeDelta)=>{
        const projectionViewMatrix = (0, $6b248c1fdea83752$export$b4b257f6294f012)(game, width, height);
        gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
        gl.viewport(0, 0, width, height);
        gl.enable(gl.CULL_FACE);
        gl.enable(gl.DEPTH_TEST);
        gl.disable(gl.BLEND);
        // Clear the canvas AND the depth buffer.
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        sceneRenderer(projectionViewMatrix, game, timeDelta);
        const pixelX = game.controlState.current.mousePosition.x;
        const pixelY = height - game.controlState.current.mousePosition.y - 1;
        const data = new Uint8Array(4);
        gl.readPixels(pixelX, pixelY, 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, data);
        selectedObjectId = (0, $96fe3a99b59d4e0f$export$a4a96014f5f7182e)(data);
    };
    const getObjectId = ()=>{
        return selectedObjectId;
    };
    return {
        dispose: dispose,
        render: render,
        getObjectId: getObjectId
    };
}




function $414768a68a64d68b$var$color(r, g, b, a) {
    return (0, $e38eb280d3b76273$exports).fromValues(r / 255.0, g / 255.0, b / 255.0, a / 255.0);
}
function $414768a68a64d68b$var$gray(g, a = 255.0) {
    return $414768a68a64d68b$var$color(g, g, g, a);
}
const $414768a68a64d68b$export$1a988e7317c65621 = {
    lightDarkChrome: 0x666666ff,
    midDarkChrome: 0x333333ff,
    darkDarkChrome: 0x000000ff,
    lightChrome: 0xa8a8a8ff,
    midChrome: 0x848484ff,
    darkChrome: 0x606060ff,
    midGreen: 0x687c4cff,
    lightGreen: 0x98b06cff,
    darkGreen: 0x3c5830ff,
    midBlue: 0x6267a3ff,
    lightBlue: 0x6c72c7ff,
    darkBlue: 0x575d8aff,
    midOrange: 0xd5922bff,
    lightOrange: 0xffc368ff,
    darkOrange: 0xc27500ff,
    midRed: 0xcd2c1eff,
    lightRed: 0xea6e5fff,
    darkRed: 0x921c12ff,
    chromeStrokeWidth: 2,
    window: {
        titleBarHeight: 32,
        closeButtonWidth: 32
    }
};





var $1738c453ffa3c8ca$export$92850d9476e00eee;
(function(MouseButton) {
    MouseButton[MouseButton["Left"] = 0] = "Left";
    MouseButton[MouseButton["Right"] = 1] = "Right";
})($1738c453ffa3c8ca$export$92850d9476e00eee || ($1738c453ffa3c8ca$export$92850d9476e00eee = {}));
class $1738c453ffa3c8ca$export$c0db965635c41eb6 extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(props, children){
        super(props, children);
        this.onMouseDown = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "onMouseDown", ()=>{});
        this.onMouseUp = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "onMouseUp", ()=>{});
        this.onMouseMove = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "onMouseMove", ()=>{});
        this.onClick = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "onClick", ()=>{});
    }
    get isInteractive() {
        return true;
    }
    renderObjectPickerControl(context) {
        if (this.objectId !== null) context.primitives.rect(context.frame.topLeft, context.frame.size, (0, $96fe3a99b59d4e0f$export$b87ac40d93907239)(this.objectId));
        super.renderObjectPickerControl(context);
    }
    handleMouseDown(button, position, capture) {
        if (this.onMouseDown === null) return false;
        const ev = {
            button: button,
            position: position,
            ...capture
        };
        this.onMouseDown(ev);
        return true;
    }
    handleMouseUp(button, position, timePressed, capture) {
        if (this.onMouseUp === null) return false;
        const ev = {
            button: button,
            position: position,
            timePressed: timePressed,
            ...capture
        };
        this.onMouseUp(ev);
        return true;
    }
    handleMouseMove(position, capture) {
        if (this.onMouseMove === null) return false;
        const ev = {
            position: position,
            ...capture
        };
        this.onMouseMove(ev);
        return true;
    }
    handleClick(button) {
        if (this.onClick === null) return false;
        this.onClick(button);
        return true;
    }
}






class $64949d8f3ef38e79$export$353f5b6fc5456de1 extends (0, $1738c453ffa3c8ca$export$c0db965635c41eb6) {
    constructor(props, children){
        super(props, children);
        this._mouseDown = false;
        this.lightChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "lightChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).lightChrome));
        this.midChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "midChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).midChrome));
        this.darkChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "darkChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).darkChrome));
        let isSelected;
        if (props !== undefined) {
            const isSelectedProp = props["isSelected"];
            if (isSelectedProp !== undefined) isSelected = (0, $2f09a4173c5bae5d$export$7c57ec354b9e0076)(isSelectedProp);
        }
        this.isSelected = isSelected === undefined ? (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(false) : isSelected;
    }
    handleMouseDown(button, position, capture) {
        this._mouseDown = true;
        return super.handleMouseDown(button, position, capture);
    }
    handleMouseUp(button, position, timePressed, capture) {
        this._mouseDown = false;
        return super.handleMouseUp(button, position, timePressed, capture);
    }
    get showPressed() {
        return this._mouseDown || this.isSelected.value;
    }
    renderControl(context) {
        super.renderControl(context);
        const { left: left, top: top, width: width, height: height } = context.frame;
        const cw = (0, $414768a68a64d68b$export$1a988e7317c65621).chromeStrokeWidth;
        context.primitives.rect([
            left,
            top
        ], [
            width,
            height
        ], this.midChrome);
        const topLeftColor = this.showPressed ? this.darkChrome : this.lightChrome;
        const bottomRightColor = this.showPressed ? this.lightChrome : this.darkChrome;
        context.primitives.rect([
            left,
            top
        ], [
            width,
            cw
        ], topLeftColor);
        context.primitives.rect([
            left,
            top
        ], [
            cw,
            height
        ], topLeftColor);
        context.primitives.rect([
            left + width - cw,
            top
        ], [
            cw,
            height
        ], bottomRightColor);
        context.primitives.rect([
            left,
            top + height - cw
        ], [
            width,
            cw
        ], bottomRightColor);
    }
    calculateInnerFrame() {
        if (!this.showPressed) return super.calculateInnerFrame();
        const padding = this.padding?.value ?? 0;
        return new (0, $3c467ee21e482183$export$b89a827e9254211a)(padding + 2, padding + 2, this.outerFrame.width - padding * 2, this.outerFrame.height - padding * 2);
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $353b5110e2c290c2$export$c84671f46d6a1ca)()
], $64949d8f3ef38e79$export$353f5b6fc5456de1.prototype, "isSelected", void 0);





class $7f9d72972a89c966$export$1cba436019d5e6c7 extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(props, children){
        super(props, children);
        this.horizontalAlignment = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "horizontalAlignment", (0, $d7c3074262118be2$export$d94dcb5bec64086e).Left);
    }
    layout(context) {
        super.layout(context);
        const contentWidth = this.children.reduce((w, child)=>w + child.outerFrame.width, 0);
        const left = (this.horizontalAlignment === (0, $d7c3074262118be2$export$d94dcb5bec64086e).Left ? 0 : this.horizontalAlignment === (0, $d7c3074262118be2$export$d94dcb5bec64086e).Right ? context.frame.width - contentWidth : (context.frame.width - contentWidth) / 2) + context.frame.left;
        this.children.reduce((x, child)=>{
            if (child.left !== undefined) child.left.value = x;
            else child.left = new (0, $2f09a4173c5bae5d$export$74d9d957b4593718)(x);
            return x + child.outerFrame.width;
        }, left);
        this.layoutChildren({
            ...context,
            frame: context.frame,
            parent: this
        });
    }
}



class $e4799da38f856da7$export$ffb0004e005737fa extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
}




class $e0d86674e6b310e1$export$6428a7f2611ef1fa extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(attributes, children){
        super(attributes, children);
        this.fill = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(attributes, "fill", 0));
    }
}


class $9675370eb5701fe2$export$c79fc6492f3af13d extends (0, $e0d86674e6b310e1$export$6428a7f2611ef1fa) {
    renderControl(context) {
        super.renderControl(context);
        context.primitives.rect(context.frame.topLeft, context.frame.size, this.fill);
    }
}




class $c47257031adb1c02$export$3e431a229df88919 extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(props, children){
        super(props, children);
        this.name = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "name", "").trim();
    }
    layout(context) {
        super.layout(context);
        const texture = context.textureProvider(this.name);
        if (texture === undefined) return;
        if (!this.sizeToFitParent) {
            this.outerFrame.width = texture.width;
            this.outerFrame.height = texture.height;
        }
    }
    renderControl(context) {
        super.renderControl(context);
        if (this.name.length === 0) return;
        const texture = context.textureProvider(this.name);
        if (texture === undefined) return;
        context.primitives.texturedRect([
            context.frame.left,
            context.frame.top
        ], this.size, texture);
    }
}



class $e4e17e86c187de9e$export$42a852a2b6b56249 extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(props, children){
        super(props, children);
        this.sizeToFitParent = (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight;
    }
}








class $14ca12d1754d362e$export$48be8b1cc5218244 extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(props, children){
        super(props, children);
        this.lightChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "lightChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).lightChrome));
        this.midChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "midChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).midChrome));
        this.darkChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "darkChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).darkChrome));
    }
    renderControl(context) {
        super.renderControl(context);
        const p = context.primitives;
        p.rect(context.frame.topLeft, [
            this.size[0],
            2
        ], this.lightChrome);
        p.rect(context.frame.topLeft, [
            2,
            this.size[1]
        ], this.lightChrome);
        p.rect([
            context.frame.topRight[0] - 2,
            context.frame.topRight[1]
        ], [
            2,
            this.size[1]
        ], this.darkChrome);
        p.rect([
            context.frame.bottomLeft[0],
            context.frame.bottomLeft[1] - 2
        ], [
            this.size[0],
            2
        ], this.darkChrome);
    }
}










class $56d2d17d5b73b07a$export$3562ac1c2406ec12 extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(props, children){
        super(props, children);
        this.lightChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "lightChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).lightChrome));
        this.midChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "midChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).midChrome));
        this.darkChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "darkChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).darkChrome));
    }
    renderControl(context) {
        super.renderControl(context);
        const p = context.primitives;
        const cw = (0, $414768a68a64d68b$export$1a988e7317c65621).chromeStrokeWidth;
        const f = context.frame;
        p.rect(f.topLeft, [
            this.size[0],
            cw
        ], this.lightChrome);
        p.rect(f.topLeft, [
            cw,
            this.size[1]
        ], this.lightChrome);
        p.rect([
            f.topRight[0] - cw,
            f.topRight[1]
        ], [
            cw,
            this.size[1]
        ], this.darkChrome);
        p.rect([
            f.bottomLeft[0],
            f.bottomLeft[1] - cw
        ], [
            this.size[0],
            cw
        ], this.darkChrome);
        p.rect([
            f.topLeft[0] + cw,
            f.topLeft[1] + cw
        ], [
            cw,
            this.size[1] - cw * 2
        ], this.darkChrome);
        p.rect([
            f.topLeft[0] + cw,
            f.topLeft[1] + cw
        ], [
            this.size[0] - cw,
            cw
        ], this.darkChrome);
        p.rect([
            f.topLeft[0] + cw * 2,
            f.topLeft[1] + this.size[1] - cw * 2
        ], [
            this.size[0] - cw * 3,
            cw
        ], this.lightChrome);
        p.rect([
            f.topLeft[0] + this.size[0] - cw * 2,
            f.topLeft[1] + cw * 2
        ], [
            cw,
            this.size[1] - cw * 3
        ], this.lightChrome);
    }
    layout(context) {
        super.layout(context);
    }
}




class $888bd522e34d200d$export$112bf4ce86e391d7 extends (0, $1738c453ffa3c8ca$export$c0db965635c41eb6) {
    constructor(props, children){
        super(props, children);
        this._isDragActive = false;
        this._lastPosition = {
            x: -1,
            y: -1
        };
        this.title = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "title", "");
        this.lightChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "lightChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).lightChrome));
        this.midChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "midChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).midChrome));
        this.darkChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "darkChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).darkChrome));
        const titleBarBevel = new (0, $56d2d17d5b73b07a$export$3562ac1c2406ec12)(undefined, []);
        titleBarBevel.midChrome = this.midChrome;
        titleBarBevel.lightChrome = this.lightChrome;
        titleBarBevel.darkChrome = this.darkChrome;
        titleBarBevel.sizeToFitParent = (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight;
        this.onMouseDown = (ev)=>{
            this._isDragActive = true;
            this._lastPosition = ev.position;
            ev.capture(this);
        };
        this.onMouseMove = (ev)=>this.dragWindow(ev.position);
        this.onMouseUp = (ev)=>{
            this._isDragActive = false;
            ev.endCapture();
        };
        this.children.push(titleBarBevel);
    }
    dragWindow(position) {
        if (!this._isDragActive) return;
        const xDelta = position.x - this._lastPosition.x;
        const yDelta = position.y - this._lastPosition.y;
        this._lastPosition = position;
        if (this.parentWindow?.left !== undefined) this.parentWindow.left.value += xDelta;
        if (this.parentWindow?.top !== undefined) this.parentWindow.top.value += yDelta;
    }
    renderControl(context) {
        super.renderControl(context);
        const p = context.primitives;
        const f = context.frame;
        const sz = p.text.measure(this.title);
        const left = f.left + f.width / 2 - sz.width / 2;
        const top = f.top + f.height / 2 - sz.height / 2;
        p.text.draw(this.title, [
            left + 2,
            top + 2
        ], [
            0,
            0,
            0,
            1
        ]);
        p.text.draw(this.title, [
            left,
            top
        ], [
            1,
            1,
            1,
            1
        ]);
    }
}



class $cde2c933e9480eef$export$cec157cbbbaf65c9 extends (0, $d7c3074262118be2$export$dff6abe3fa9858c4) {
    constructor(props, children){
        super(props, []);
        this.title = (0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "title", "");
        this.lightChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "lightChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).lightChrome));
        this.midChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "midChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).midChrome));
        this.darkChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "darkChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).darkChrome));
        const closeButtonImage = new (0, $c47257031adb1c02$export$3e431a229df88919)(undefined, []);
        closeButtonImage.sizeToFitParent = (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight;
        closeButtonImage.name = "xmark";
        const closeButton = new (0, $64949d8f3ef38e79$export$353f5b6fc5456de1)(undefined, []);
        closeButton.midChrome = this.midChrome;
        closeButton.lightChrome = this.lightChrome;
        closeButton.darkChrome = this.darkChrome;
        closeButton.left = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(0);
        closeButton.top = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(0);
        closeButton.width = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with((0, $414768a68a64d68b$export$1a988e7317c65621).window.closeButtonWidth);
        closeButton.height = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with((0, $414768a68a64d68b$export$1a988e7317c65621).window.titleBarHeight);
        closeButton.padding = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(6);
        closeButton.onClick = ()=>this.isVisible.value = !this.isVisible.value;
        closeButton.children.push(closeButtonImage);
        const raisedBevel = new (0, $14ca12d1754d362e$export$48be8b1cc5218244)({
            midChrome: (0, $46c01301d2cf88f0$export$33148e2253a40f88)(this.midChrome),
            lightChrome: (0, $46c01301d2cf88f0$export$33148e2253a40f88)(this.lightChrome),
            darkChrome: (0, $46c01301d2cf88f0$export$33148e2253a40f88)(this.darkChrome)
        }, []);
        raisedBevel.left = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(0);
        raisedBevel.top = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(0);
        raisedBevel.sizeToFitParent = (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight;
        this.titleBar = new (0, $888bd522e34d200d$export$112bf4ce86e391d7)({
            midChrome: (0, $46c01301d2cf88f0$export$33148e2253a40f88)(this.midChrome),
            lightChrome: (0, $46c01301d2cf88f0$export$33148e2253a40f88)(this.lightChrome),
            darkChrome: (0, $46c01301d2cf88f0$export$33148e2253a40f88)(this.darkChrome)
        }, []);
        this.titleBar.left = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with((0, $414768a68a64d68b$export$1a988e7317c65621).window.closeButtonWidth);
        this.titleBar.top = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with(0);
        this.titleBar.height = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with((0, $414768a68a64d68b$export$1a988e7317c65621).window.titleBarHeight);
        this.titleBar.sizeToFitParent = (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width;
        this.titleBar.title = this.title;
        this.titleBar.parentWindow = this;
        this.container = new (0, $e4e17e86c187de9e$export$42a852a2b6b56249)(undefined, children);
        this.container.top = (0, $2f09a4173c5bae5d$export$74d9d957b4593718).with((0, $414768a68a64d68b$export$1a988e7317c65621).window.titleBarHeight);
        this.container.sizeToFitParent = (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width;
        this.children.push(raisedBevel);
        this.children.push(closeButton);
        this.children.push(this.titleBar);
        this.children.push(this.container);
        this.lightChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "lightChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).lightGreen));
        this.midChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "midChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).midGreen));
        this.darkChrome = (0, $46c01301d2cf88f0$export$94f493b007b3adc5)((0, $46c01301d2cf88f0$export$80889d3a746c7e11)(props, "darkChrome", (0, $414768a68a64d68b$export$1a988e7317c65621).darkGreen));
    }
    renderControl(context) {
        super.renderControl(context);
        const p = context.primitives;
        p.rect(this.position, this.size, this.midChrome);
    }
    layout(context) {
        super.layout(context);
        this.layoutChildren(context);
    }
}



function $6f89098044ebec37$export$4465316da05b7233(type, props, ...children) {
    if (type === "button") return new (0, $64949d8f3ef38e79$export$353f5b6fc5456de1)(props ?? undefined, children);
    else if (type === "hlayout") return new (0, $7f9d72972a89c966$export$1cba436019d5e6c7)(props ?? undefined, children);
    else if (type === "rect") return new (0, $9675370eb5701fe2$export$c79fc6492f3af13d)(props ?? undefined, children);
    else if (type === "image") return new (0, $c47257031adb1c02$export$3e431a229df88919)(props ?? undefined, children);
    else if (type === "container") return new (0, $e4e17e86c187de9e$export$42a852a2b6b56249)(props ?? undefined, children);
    else if (type === "window") return new (0, $cde2c933e9480eef$export$cec157cbbbaf65c9)(props ?? undefined, children);
    else if (type === "raisedbevel") return new (0, $14ca12d1754d362e$export$48be8b1cc5218244)(props ?? undefined, children);
    else if (type === "bevel") return new (0, $14ca12d1754d362e$export$48be8b1cc5218244)(props ?? undefined, children);
    return new (0, $e4799da38f856da7$export$ffb0004e005737fa)(props ?? undefined, children);
}





function $27d32ecc35619740$export$39b88487f54d0231(state) {
    const bs = 48;
    const bp = 8;
    const colors = {
        build: {
            light: (0, $414768a68a64d68b$export$1a988e7317c65621).lightGreen,
            dark: (0, $414768a68a64d68b$export$1a988e7317c65621).darkGreen,
            medium: (0, $414768a68a64d68b$export$1a988e7317c65621).midGreen
        },
        power: {
            light: (0, $414768a68a64d68b$export$1a988e7317c65621).lightOrange,
            dark: (0, $414768a68a64d68b$export$1a988e7317c65621).darkOrange,
            medium: (0, $414768a68a64d68b$export$1a988e7317c65621).midOrange
        },
        info: {
            light: (0, $414768a68a64d68b$export$1a988e7317c65621).lightDarkChrome,
            dark: (0, $414768a68a64d68b$export$1a988e7317c65621).darkDarkChrome,
            medium: (0, $414768a68a64d68b$export$1a988e7317c65621).midDarkChrome
        }
    };
    const spacerWidth = 4;
    const openBuildWindow = (action)=>{
        state.gui.windows.zoning.isVisible.value = false;
        state.gui.windows.bulldozer.isVisible.value = false;
        state.gui.windows.power.isVisible.value = false;
        state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).None;
        action();
    };
    return /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("container", null, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("hlayout", {
        horizontalAlignment: "middle",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        onClick: (b)=>console.log(1),
        width: bs,
        height: bs
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "pause",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        onClick: (b)=>console.log(2),
        width: bs,
        height: bs
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "singlespeed",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "doublespeed",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("rect", {
        width: spacerWidth,
        height: bs,
        fill: 0xaa000033
    }), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        onClick: ()=>openBuildWindow(()=>{
                state.gui.windows.bulldozer.isVisible.value = !state.gui.windows.bulldozer.isVisible.value;
                state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).ClearTerrain;
            }),
        width: bs,
        height: bs
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "bulldozer",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        onClick: ()=>openBuildWindow(()=>{
                state.gui.windows.zoning.isVisible.value = !state.gui.windows.zoning.isVisible.value;
                state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).LightResidential;
            }),
        width: bs,
        height: bs
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "zones",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        onClick: ()=>openBuildWindow(()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).Road),
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).Road
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "road",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        onClick: ()=>openBuildWindow(()=>{
                state.gui.windows.power.isVisible.value = !state.gui.windows.power.isVisible.value;
                state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine;
            }),
        width: bs,
        height: bs
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "power",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("rect", {
        width: 4,
        height: bs,
        fill: 0xaa000033
    }), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        onClick: ()=>state.gui.windows.info.isVisible.value = !state.gui.windows.info.isVisible.value,
        width: bs,
        height: bs
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "layers",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    }))), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("window", {
        title: "Zoning",
        isVisible: state.gui.windows.zoning.isVisible,
        left: state.gui.windows.zoning.left,
        top: state.gui.windows.zoning.top,
        width: bs * 6,
        height: bs + (0, $414768a68a64d68b$export$1a988e7317c65621).window.titleBarHeight,
        padding: 0,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("hlayout", {
        horizontalAlignment: (0, $d7c3074262118be2$export$d94dcb5bec64086e).Left,
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).LightResidential,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).LightResidential
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "lightResidentialZone",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseResidential,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseResidential
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "denseResidentialZone",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).LightCommercial,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).LightCommercial
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "lightCommercialZone",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseCommercial,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseCommercial
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "denseCommercialZone",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).LightIndustrial,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).LightIndustrial
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "lightIndustrialZone",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseIndustrial,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).DenseIndustrial
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "denseIndustrialZone",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })))), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("window", {
        title: "Terrain",
        isVisible: state.gui.windows.bulldozer.isVisible,
        left: state.gui.windows.bulldozer.left,
        top: state.gui.windows.bulldozer.top,
        width: bs * 4,
        height: bs + (0, $414768a68a64d68b$export$1a988e7317c65621).window.titleBarHeight,
        padding: 0,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("hlayout", {
        horizontalAlignment: (0, $d7c3074262118be2$export$d94dcb5bec64086e).Left,
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).ClearTerrain,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).ClearTerrain
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "clearTerrain",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).Dezone,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).Dezone
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "dezone",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).LowerTerrain,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).LowerTerrain
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "lowerTerrain",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.build.light,
        midChrome: colors.build.medium,
        darkChrome: colors.build.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).RaiseTerrain,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).RaiseTerrain
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "raiseTerrain",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })))), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("window", {
        title: "Power",
        isVisible: state.gui.windows.power.isVisible,
        left: state.gui.windows.power.left,
        top: state.gui.windows.power.top,
        width: bs * 5,
        height: bs + (0, $414768a68a64d68b$export$1a988e7317c65621).window.titleBarHeight,
        padding: 0,
        lightChrome: colors.power.light,
        midChrome: colors.power.medium,
        darkChrome: colors.power.dark
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("hlayout", {
        horizontalAlignment: (0, $d7c3074262118be2$export$d94dcb5bec64086e).Left,
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.power.light,
        midChrome: colors.power.medium,
        darkChrome: colors.power.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "powerLine",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.power.light,
        midChrome: colors.power.medium,
        darkChrome: colors.power.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).CoalPowerPlant,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).CoalPowerPlant
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "coalPowerPlant",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.power.light,
        midChrome: colors.power.medium,
        darkChrome: colors.power.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).NuclearPowerPlant,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).NuclearPowerPlant
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "nuclearPowerPlant",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.power.light,
        midChrome: colors.power.medium,
        darkChrome: colors.power.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).SolarPowerPlant,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).SolarPowerPlant
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "solarPowerPlant",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.power.light,
        midChrome: colors.power.medium,
        darkChrome: colors.power.dark,
        onClick: ()=>state.gui.currentTool = (0, $bd101182371a0deb$export$724f6b867059ef5f).WindTurbine,
        isSelected: ()=>state.gui.currentTool === (0, $bd101182371a0deb$export$724f6b867059ef5f).WindTurbine
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "windTurbine",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })))), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("window", {
        title: "Overlays",
        isVisible: state.gui.windows.info.isVisible,
        left: state.gui.windows.info.left,
        top: state.gui.windows.info.top,
        width: bs * 3 + spacerWidth,
        height: bs + (0, $414768a68a64d68b$export$1a988e7317c65621).window.titleBarHeight,
        padding: 0,
        lightChrome: colors.info.light,
        midChrome: colors.info.medium,
        darkChrome: colors.info.dark
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("hlayout", {
        horizontalAlignment: (0, $d7c3074262118be2$export$d94dcb5bec64086e).Left,
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).Width
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.info.light,
        midChrome: colors.info.medium,
        darkChrome: colors.info.dark,
        onClick: ()=>{
            state.gui.layers.power = true;
            state.gui.layers.zones = false;
        },
        isSelected: ()=>state.gui.layers.power
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "whiteElectric",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.info.light,
        midChrome: colors.info.medium,
        darkChrome: colors.info.dark,
        onClick: ()=>{
            state.gui.layers.zones = true;
            state.gui.layers.power = false;
        },
        isSelected: ()=>state.gui.layers.zones
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "whiteZones",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("rect", {
        width: spacerWidth,
        height: bs,
        fill: colors.info.medium
    }), /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("button", {
        padding: bp,
        width: bs,
        height: bs,
        lightChrome: colors.info.light,
        midChrome: colors.info.medium,
        darkChrome: colors.info.dark,
        onClick: ()=>state.gui.layers.buildings = !state.gui.layers.buildings,
        isSelected: ()=>state.gui.layers.buildings
    }, /*#__PURE__*/ (0, $6f89098044ebec37$export$4465316da05b7233)("image", {
        name: "whiteBuildings",
        sizeToFitParent: (0, $d7c3074262118be2$export$80aaf7ab7c413899).WidthAndHeight
    })))));
}





function $debc6084a1282f62$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.uColor);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $debc6084a1282f62$var$createVertexBuffer(gl) {
    const vertexBuffer = gl.createBuffer();
    let vertices = [
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        1
    ].map((p)=>p);
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    return {
        buffer: vertexBuffer,
        vertCount: vertices.length / 2
    };
}
function $debc6084a1282f62$export$d526202d1c30049f(gl, width, height, resources) {
    const programInfo = $debc6084a1282f62$var$initShaderProgram(gl, resources);
    const vertices = $debc6084a1282f62$var$createVertexBuffer(gl);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    return function(position, size, color) {
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0],
            position[1],
            0.0
        ], [
            size[0],
            size[1],
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f1fc9c1971337e7c)(gl, {
            position: vertices.buffer
        }, programInfo);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            color: color
        });
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertices.vertCount);
    };
}





function $71c11ec3c9315904$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.uColor);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $71c11ec3c9315904$var$createVertexBuffer(gl) {
    const vertexBuffer = gl.createBuffer();
    let vertices = [];
    for(let angle = 0; angle <= 360.0; angle++){
        let radians = angle * Math.PI / 180.0;
        const vert1 = [
            Math.sin(radians),
            Math.cos(radians)
        ];
        const vert2 = [
            0.0,
            0.0
        ];
        vertices = vertices.concat(vert1);
        vertices = vertices.concat(vert2);
    }
    gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertices), gl.STATIC_DRAW);
    return {
        buffer: vertexBuffer,
        vertCount: vertices.length / 2
    };
}
function $71c11ec3c9315904$export$b7b99c5b53d1b03(gl, width, height, resources) {
    const programInfo = $71c11ec3c9315904$var$initShaderProgram(gl, resources);
    const vertices = $71c11ec3c9315904$var$createVertexBuffer(gl);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    return function(position, radius, color) {
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0],
            position[1],
            0.0
        ], [
            radius,
            radius,
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f1fc9c1971337e7c)(gl, {
            position: vertices.buffer
        }, programInfo);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            color: color
        });
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, vertices.vertCount);
    };
}


// Our font strip contains characters that are 8 pixels wide and 16 pixels high.
// Each character is positioned at a 16 offset (character 0 - x = 0, character 1 x = 16, character 2 x = 32 etc.)
// There are 96 characters in the strip




function $3c047a64f97dc4db$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.text);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            characterOffset: gl.getUniformLocation(shaderProgram, "uCharacterOffset"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler"),
            color: gl.getUniformLocation(shaderProgram, "uColor")
        }
    };
}
function $3c047a64f97dc4db$var$getFontSize(width, height, characterWidth) {
    if (characterWidth === undefined) {
        const characterHeight = height / 16.0;
        //characterWidth = width / 40.0
        return [
            characterHeight / 1.2,
            characterHeight
        ];
    }
    return [
        characterWidth,
        characterWidth * 1.2
    ];
}
function $3c047a64f97dc4db$export$b65634ddab3713db(gl, width, height, flippedY, resources, optionalCharacterWidth, font) {
    const programInfo = $3c047a64f97dc4db$var$initShaderProgram(gl, resources);
    const square = (0, $35806345bc1d62c5$export$fdbdb3a5cc488d7e)(gl, font !== undefined ? font : resources.textures.font.handle, flippedY, true);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    const [characterWidth, characterHeight] = [
        12,
        16
    ] // getFontSize(width, height, optionalCharacterWidth)
    ;
    const spacing = 1.0;
    const yMultiplier = flippedY ? -1 : 1;
    const convertToPosition = (characterPosition)=>(0, $4ce98914b6676340$exports).fromValues(characterPosition[0] * (characterWidth + spacing), characterPosition[1] * characterHeight);
    const convertToCharacterCoordinates = (position)=>(0, $4ce98914b6676340$exports).fromValues(Math.floor(position[0] / (characterWidth + spacing)), Math.floor(position[1] / characterHeight));
    const measure = (text)=>{
        return {
            width: (characterWidth + spacing) * text.length,
            height: characterHeight
        };
    };
    const draw = (text, position, color = (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 1.0, 1.0))=>{
        gl.useProgram(programInfo.program);
        // Set the shader uniforms
        gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
        let displayPosition = (0, $ab7f6dc0910e1ef7$exports).fromValues(position[0], position[1], 0.0);
        drawCharacters(text, displayPosition, characterWidth, characterHeight, color, spacing);
    };
    function drawCharacters(text, displayPosition, cw, ch, color, spacing) {
        Array.from(text).forEach((c)=>{
            const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), displayPosition, [
                cw / 2,
                ch / 2 * yMultiplier,
                1.0
            ]);
            (0, $b125b9470601071f$export$f5a01205d395aca)(gl, square, programInfo);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, square.indices);
            (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
                modelViewMatrix: modelViewMatrix,
                color: color,
                textureIndex: 0
            }, square.texture);
            gl.uniform1f(programInfo.uniformLocations.characterOffset, c.charCodeAt(0) - 32);
            {
                const vertexCount = square.vertexCount;
                const type = gl.UNSIGNED_SHORT;
                const offset = 0;
                gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
            }
            displayPosition[0] += cw + spacing;
        });
    }
    const drawAtSize = (text, position, cw, ch, spacing, color)=>{
        if (ch <= 0) ch = cw * 1.2;
        gl.useProgram(programInfo.program);
        // Set the shader uniforms
        gl.uniformMatrix4fv(programInfo.uniformLocations.projectionMatrix, false, projectionMatrix);
        let displayPosition = (0, $ab7f6dc0910e1ef7$exports).fromValues(position[0], position[1], 0.0);
        drawCharacters(text, displayPosition, cw, ch, color, spacing);
    };
    const center = (text, row, color = (0, $e38eb280d3b76273$exports).fromValues(1.0, 1.0, 1.0, 1.0))=>{
        const sz = measure(text);
        draw(text, [
            width / 2 - sz.width / 2,
            row * characterHeight
        ]);
    };
    return {
        convertToPosition: convertToPosition,
        convertToCharacterCoordinates: convertToCharacterCoordinates,
        draw: draw,
        measure: measure,
        drawAtSize: drawAtSize,
        center: center,
        fontSize: {
            width: characterWidth,
            height: characterHeight
        }
    };
}






function $ee9e5df9a99a98b2$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.simpleTexture);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            textureCoords: gl.getAttribLocation(shaderProgram, "aTextureCoord")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            textureSampler: gl.getUniformLocation(shaderProgram, "uSampler")
        }
    };
}
function $ee9e5df9a99a98b2$export$c91d19dba6aae8ce(gl, width, height, resources) {
    const programInfo = $ee9e5df9a99a98b2$var$initShaderProgram(gl, resources);
    const square = (0, $35806345bc1d62c5$export$7c40b2ceeb961577)(gl, [
        1.0,
        0.0,
        0.0,
        1.0
    ]);
    const projectionMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).ortho(projectionMatrix, 0, width, height, 0, -1, 1.0);
    return function(position, size, texture) {
        // the divide by two is because the model has extents of -1.0 to 1.0
        const modelViewMatrix = (0, $26675c4f95835ef1$exports).fromRotationTranslationScale((0, $26675c4f95835ef1$exports).create(), (0, $e92e4eb8d35aaf31$exports).create(), [
            position[0] + size[0] / 2,
            position[1] + size[1] / 2,
            0.0
        ], [
            size[0] / 2,
            size[1] / 2,
            1.0
        ]);
        gl.useProgram(programInfo.program);
        (0, $b125b9470601071f$export$f5a01205d395aca)(gl, square, programInfo);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, square.indices);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: modelViewMatrix,
            textureIndex: 0
        }, texture.handle);
        const vertexCount = square.vertexCount;
        const type = gl.UNSIGNED_SHORT;
        const offset = 0;
        gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
    };
}


function $45ed6fb76a623699$export$6bf5cf98c33b0c4b(gl, flippedY, resources, width, height) {
    return {
        rect: (0, $debc6084a1282f62$export$d526202d1c30049f)(gl, width, height, resources),
        texturedRect: (0, $ee9e5df9a99a98b2$export$c91d19dba6aae8ce)(gl, width, height, resources),
        circle: (0, $71c11ec3c9315904$export$b7b99c5b53d1b03)(gl, width, height, resources),
        text: (0, $3c047a64f97dc4db$export$b65634ddab3713db)(gl, width, height, false, resources),
        size: ()=>({
                width: width,
                height: height
            })
    };
}




function $76b671ed1fa99c76$export$c0571035d9f2a28d(gl, resources, width, height, createRoot, getTexture, startingObjectId) {
    const primitives = (0, $45ed6fb76a623699$export$6bf5cf98c33b0c4b)(gl, false, resources, width, height);
    const root = createRoot();
    let nextObjectId = startingObjectId;
    let objectIdMap = new Map();
    let mouseCapturedObject = null;
    const capture = (element)=>mouseCapturedObject = element;
    const endCapture = ()=>mouseCapturedObject = null;
    const recursivelySetObjectIds = (element)=>{
        if (element.isInteractive) {
            element.objectId = nextObjectId;
            objectIdMap.set(nextObjectId, element);
            nextObjectId++;
        }
        element.children.forEach((child)=>recursivelySetObjectIds(child));
    };
    recursivelySetObjectIds(root);
    const lastObjectId = nextObjectId - 1;
    let interactions = {
        leftMouseDown: null
    };
    const dispose = ()=>{};
    const render = ()=>{
        root.layout({
            gl: gl,
            primitives: primitives,
            textureProvider: getTexture,
            frame: new (0, $3c467ee21e482183$export$b89a827e9254211a)(0, 0, width, height)
        });
        root.render({
            gl: gl,
            primitives: primitives,
            textureProvider: getTexture,
            frame: new (0, $3c467ee21e482183$export$b89a827e9254211a)(0, 0, width, height)
        });
    };
    const renderObjectPicker = ()=>{
        // we always want the GUI to be more pickable than whats underneath so we disable the depth test
        gl.disable(gl.DEPTH_TEST);
        root.renderObjectPicker({
            gl: gl,
            primitives: primitives,
            textureProvider: getTexture,
            frame: new (0, $3c467ee21e482183$export$b89a827e9254211a)(0, 0, width, height)
        });
    };
    const applyControlState = (controlState, timeDelta, selectedObjectId)=>{
        if (selectedObjectId < startingObjectId || selectedObjectId > lastObjectId) return false;
        let handled = false;
        const selectedElement = mouseCapturedObject ?? objectIdMap.get(selectedObjectId);
        if (selectedElement === undefined) return;
        if (controlState.mouseButtons.left) {
            if (interactions.leftMouseDown === null) {
                interactions.leftMouseDown = {
                    timer: 0,
                    initialObjectId: selectedObjectId
                };
                handled = selectedElement.handleMouseDown((0, $1738c453ffa3c8ca$export$92850d9476e00eee).Left, controlState.mousePosition, {
                    capture: capture,
                    endCapture: endCapture
                });
            }
        } else if (interactions.leftMouseDown !== null) {
            selectedElement.handleMouseUp((0, $1738c453ffa3c8ca$export$92850d9476e00eee).Left, controlState.mousePosition, interactions.leftMouseDown.timer, {
                capture: capture,
                endCapture: endCapture
            });
            if (selectedObjectId === interactions.leftMouseDown.initialObjectId) handled = selectedElement.handleClick((0, $1738c453ffa3c8ca$export$92850d9476e00eee).Left);
            interactions.leftMouseDown = null;
        }
        // TODO: we only want to route this if in bounds
        handled = selectedElement.handleMouseMove(controlState.mousePosition, {
            capture: capture,
            endCapture: endCapture
        });
        return handled;
    };
    const update = (timeDelta)=>{
        if (interactions.leftMouseDown !== null) interactions.leftMouseDown.timer += timeDelta;
    };
    return {
        render: render,
        renderObjectPicker: renderObjectPicker,
        dispose: dispose,
        update: update,
        applyControlState: applyControlState
    };
}







let $b3c8824b30c2bc14$var$nextBuildingId = 1;
var $b3c8824b30c2bc14$export$45dc1a8cad5d6800;
(function(BuildingType) {
    BuildingType[BuildingType["CoalPowerStation"] = 0] = "CoalPowerStation";
    BuildingType[BuildingType["PowerLine"] = 1] = "PowerLine";
    BuildingType[BuildingType["SmallHouse"] = 2] = "SmallHouse";
    BuildingType[BuildingType["SmallChemicalStorage"] = 3] = "SmallChemicalStorage";
})($b3c8824b30c2bc14$export$45dc1a8cad5d6800 || ($b3c8824b30c2bc14$export$45dc1a8cad5d6800 = {}));
var $b3c8824b30c2bc14$export$f6cf33d5c0358b05;
(function(BlueprintCategory) {
    BlueprintCategory[BlueprintCategory["Residential"] = 0] = "Residential";
    BlueprintCategory[BlueprintCategory["Industrial"] = 1] = "Industrial";
    BlueprintCategory[BlueprintCategory["Commercial"] = 2] = "Commercial";
    BlueprintCategory[BlueprintCategory["Other"] = 3] = "Other";
})($b3c8824b30c2bc14$export$f6cf33d5c0358b05 || ($b3c8824b30c2bc14$export$f6cf33d5c0358b05 = {}));
const $b3c8824b30c2bc14$var$toolBuildingTypes = [
    [
        (0, $bd101182371a0deb$export$724f6b867059ef5f).CoalPowerPlant,
        0
    ],
    [
        (0, $bd101182371a0deb$export$724f6b867059ef5f).PowerLine,
        1
    ]
];
const $b3c8824b30c2bc14$var$toolBuildingTypesMap = new Map($b3c8824b30c2bc14$var$toolBuildingTypes);
const $b3c8824b30c2bc14$var$zeroOutput = ()=>({
        residential: 0,
        industrial: 0,
        commercial: 0
    });
const $b3c8824b30c2bc14$var$blueprintModels = [
    [
        0,
        (r)=>r.voxelModels.power.coal
    ],
    [
        1,
        (r)=>r.voxelModels.power.powerLineEastWest
    ],
    [
        2,
        (r)=>r.voxelModels.residential.house
    ],
    [
        3,
        (r)=>r.voxelModels.industrial.smallChemicalStorage
    ]
];
const $b3c8824b30c2bc14$var$blueprints = [
    [
        0,
        {
            blueprintCategory: 3,
            buildingType: 0,
            footprint: {
                width: 4,
                height: 4
            },
            powerGenerated: 2000,
            powerConsumed: 0,
            output: 0,
            isHeavyIndustrial: false,
            growthCap: null
        }
    ],
    [
        1,
        {
            blueprintCategory: 3,
            buildingType: 1,
            footprint: {
                width: 1,
                height: 1
            },
            powerGenerated: 0,
            powerConsumed: 0,
            output: 0,
            isHeavyIndustrial: false,
            growthCap: null
        }
    ],
    [
        2,
        {
            blueprintCategory: 0,
            buildingType: 2,
            footprint: {
                width: 1,
                height: 1
            },
            powerGenerated: 0,
            powerConsumed: 10,
            output: 0,
            isHeavyIndustrial: false,
            growthCap: null
        }
    ],
    [
        3,
        {
            blueprintCategory: 1,
            buildingType: 3,
            footprint: {
                width: 1,
                height: 1
            },
            powerGenerated: 0,
            powerConsumed: 30,
            output: 10,
            isHeavyIndustrial: false,
            growthCap: null
        }
    ]
];
const $b3c8824b30c2bc14$var$blueprintsMap = new Map($b3c8824b30c2bc14$var$blueprints);
const $b3c8824b30c2bc14$var$blueprintsModelsMap = new Map($b3c8824b30c2bc14$var$blueprintModels);
const $b3c8824b30c2bc14$var$blueprintsList = $b3c8824b30c2bc14$var$blueprints.map(([_, blueprint])=>blueprint);
const $b3c8824b30c2bc14$var$blueprintsForCategory = new Map([
    3,
    0,
    2,
    1
].map((bc)=>[
        bc,
        $b3c8824b30c2bc14$var$blueprintsList.filter((bp)=>bp.blueprintCategory === bc)
    ]));
function $b3c8824b30c2bc14$export$b973f82fe12e3bcf(building) {
    return $b3c8824b30c2bc14$var$blueprintsModelsMap.get(building.blueprint.buildingType);
}
function $b3c8824b30c2bc14$export$d20bcbe3bb1ddc99(blueprint) {
    return $b3c8824b30c2bc14$var$blueprintsModelsMap.get(blueprint.buildingType);
}
function $b3c8824b30c2bc14$export$8c6f03991534a6bd(category, growthScore) {
    return $b3c8824b30c2bc14$var$blueprintsForCategory.get(category)?.filter((bp)=>bp.output <= growthScore).sort((a, b)=>a.output - b.output) ?? [];
}
function $b3c8824b30c2bc14$export$ef976d59635a0da0(tool) {
    const buildingType = $b3c8824b30c2bc14$var$toolBuildingTypesMap.get(tool);
    return $b3c8824b30c2bc14$var$blueprintsMap.get(buildingType);
}
function $b3c8824b30c2bc14$export$9019cecb15291502(buildingType) {
    return $b3c8824b30c2bc14$var$blueprintsMap.get(buildingType);
}
function $b3c8824b30c2bc14$export$d9ceafed7fbbc1e4(resources, tool, position) {
    const buildingType = $b3c8824b30c2bc14$var$toolBuildingTypesMap.get(tool);
    const blueprint = $b3c8824b30c2bc14$var$blueprintsMap.get(buildingType);
    if (blueprint === undefined) return null;
    return $b3c8824b30c2bc14$export$973c9d96711656fc(resources, blueprint, position);
}
function $b3c8824b30c2bc14$export$973c9d96711656fc(resources, blueprint, position) {
    const model = $b3c8824b30c2bc14$var$blueprintsModelsMap.get(blueprint.buildingType)(resources);
    return {
        blueprint: blueprint,
        buildingId: $b3c8824b30c2bc14$var$nextBuildingId++,
        footprint: {
            ...blueprint.footprint
        },
        position: position,
        numberOfVoxelsToDisplay: model.voxelCount,
        isPoweredByBuildingId: null
    };
}
function $b3c8824b30c2bc14$export$f44d0f8a642e85a2(resources, zone, size, position) {
    const blueprint = $b3c8824b30c2bc14$var$blueprintsMap.get(2);
    const model = $b3c8824b30c2bc14$var$blueprintsModelsMap.get(blueprint.buildingType)(resources);
    return {
        blueprint: blueprint,
        buildingId: $b3c8824b30c2bc14$var$nextBuildingId++,
        model: model,
        footprint: {
            width: size,
            height: size
        },
        position: position,
        numberOfVoxelsToDisplay: model.voxelCount,
        isPoweredByBuildingId: null
    };
}
function $b3c8824b30c2bc14$export$1078ade21bd4346(blueprint, width, height, x, z, numberOfVoxelsToDisplay) {
    return {
        blueprint: blueprint,
        buildingId: $b3c8824b30c2bc14$var$nextBuildingId++,
        footprint: {
            width: width,
            height: height
        },
        position: {
            x: x,
            z: z
        },
        numberOfVoxelsToDisplay: numberOfVoxelsToDisplay,
        isPoweredByBuildingId: null
    };
}



const $1e58a7071d3cda74$export$115ceb706b6942b6 = {
    northSouth: [
        [
            0,
            1,
            0
        ],
        [
            0,
            0,
            0
        ],
        [
            0,
            1,
            0
        ]
    ],
    eastWest: [
        [
            0,
            0,
            0
        ],
        [
            1,
            0,
            1
        ],
        [
            0,
            0,
            0
        ]
    ],
    northEast: [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            1
        ],
        [
            0,
            1,
            0
        ]
    ],
    northWest: [
        [
            0,
            0,
            0
        ],
        [
            1,
            0,
            0
        ],
        [
            0,
            1,
            0
        ]
    ],
    northT: [
        [
            0,
            0,
            0
        ],
        [
            1,
            0,
            1
        ],
        [
            0,
            1,
            0
        ]
    ],
    westT: [
        [
            0,
            1,
            0
        ],
        [
            1,
            0,
            0
        ],
        [
            0,
            1,
            0
        ]
    ],
    southWest: [
        [
            0,
            1,
            0
        ],
        [
            1,
            0,
            0
        ],
        [
            0,
            0,
            0
        ]
    ],
    southEast: [
        [
            0,
            1,
            0
        ],
        [
            0,
            0,
            1
        ],
        [
            0,
            0,
            0
        ]
    ],
    eastT: [
        [
            0,
            1,
            0
        ],
        [
            0,
            0,
            1
        ],
        [
            0,
            1,
            0
        ]
    ],
    southT: [
        [
            0,
            1,
            0
        ],
        [
            1,
            0,
            1
        ],
        [
            0,
            0,
            0
        ]
    ],
    crossroads: [
        [
            0,
            1,
            0
        ],
        [
            1,
            0,
            1
        ],
        [
            0,
            1,
            0
        ]
    ],
    northStub: [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        [
            0,
            1,
            0
        ]
    ],
    southStub: [
        [
            0,
            1,
            0
        ],
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ]
    ],
    westStub: [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            1
        ],
        [
            0,
            0,
            0
        ]
    ],
    eastStub: [
        [
            0,
            0,
            0
        ],
        [
            1,
            0,
            0
        ],
        [
            0,
            0,
            0
        ]
    ],
    isolate: [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ]
    ]
};
function $1e58a7071d3cda74$export$2adb6bbc893073f4(game, x, y, isSet) {
    const tileInfos = game.simulation.landscape.tileInfo;
    const pattern = [
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ],
        [
            0,
            0,
            0
        ]
    ];
    if (y > 0) pattern[0][1] = isSet(tileInfos[y - 1][x]) ? 1 : 0;
    if (y < game.simulation.landscape.size - 1) pattern[2][1] = isSet(tileInfos[y + 1][x]) ? 1 : 0;
    if (x > 0) pattern[1][0] = isSet(tileInfos[y][x - 1]) ? 1 : 0;
    if (x < game.simulation.landscape.size - 1) pattern[1][2] = isSet(tileInfos[y][x + 1]) ? 1 : 0;
    return pattern;
}
function $1e58a7071d3cda74$export$cdded5b28a5f8c6d(patternA, patternB) {
    return patternA[0][1] === patternB[2][1] && patternA[1][0] === patternB[1][0] && patternA[1][2] === patternB[1][2] && patternA[2][1] === patternB[0][1];
}



const $72a1f38ca33acb35$var$roadPatterns = [
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadNorthSouth,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northSouth
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadEastWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).eastWest
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadNorthEast,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northEast
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadNorthWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northWest
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadNorthToEastWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northT
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadWestToNorthSouth,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).westT
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadSouthEast,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southEast
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadSouthWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southWest
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadEastTNorthSouth,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).eastT
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadSouthTEastWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southT
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadCrossroads,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).crossroads
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadNorthStub,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northStub
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadSouthStub,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southStub
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadWestStub,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).westStub
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadEastStub,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).eastStub
    },
    {
        type: (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadIsolate,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).isolate
    }
];
function $72a1f38ca33acb35$var$getRoadPattern(game, x, y) {
    return (0, $1e58a7071d3cda74$export$2adb6bbc893073f4)(game, x, y, (ti)=>ti.zone === (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).Road);
}
function $72a1f38ca33acb35$var$getTextureForPattern(pattern) {
    for (const roadPattern of $72a1f38ca33acb35$var$roadPatterns){
        if ((0, $1e58a7071d3cda74$export$cdded5b28a5f8c6d)(pattern, roadPattern.pattern)) return roadPattern.type;
    }
}
function $72a1f38ca33acb35$export$840a8d6bdf0270ff(gl, game, r) {
    for(let x = r.left - 1; x <= r.right + 1; x++)for(let y = r.top - 1; y <= r.bottom + 1; y++){
        if (x < 0 || x >= game.simulation.landscape.size || y < 0 || y >= game.simulation.landscape.size) continue;
        // only have the one texture for now
        if (game.simulation.landscape.tileInfo[y][x].zone === (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).Road) {
            const pattern = $72a1f38ca33acb35$var$getRoadPattern(game, x, y);
            game.simulation.landscape.tileInfo[y][x].textureIndex = $72a1f38ca33acb35$var$getTextureForPattern(pattern) ?? null;
        }
    }
    const range = {
        start: {
            x: r.left - 1,
            y: r.top - 1
        },
        end: {
            x: r.right + 1,
            y: r.bottom + 1
        }
    };
    (0, $aeab7555fdde6942$export$efede7f0dce421e8)(gl, game, range);
}






function $f3d92aebdafa46c7$export$4c8301bbafee0aac(simulation, building) {
    simulation.buildings.set(building.buildingId, building);
    for(let z = building.position.z; z < building.position.z + building.blueprint.footprint.height; z++)for(let x = building.position.x; x < building.position.x + building.blueprint.footprint.width; x++)simulation.landscape.tileInfo[z][x].building = building;
}
function $f3d92aebdafa46c7$export$5e760e49675dcec0(simulation, building) {
    for(let z = 0; z < building.blueprint.footprint.height; z++)for(let x = 0; x < building.blueprint.footprint.width; x++)simulation.landscape.tileInfo[building.position.z + z][building.position.x + x].building = null;
    simulation.buildings.delete(building.buildingId);
}


const $9f1bd9f37b3f78db$var$patterns = [
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineNorthSouth,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northSouth
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineEastWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).eastWest
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineNorthEast,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northEast
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineNorthWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northWest
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineNorthT,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northT
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineWestT,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).westT
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineSouthEast,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southEast
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineSouthWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southWest
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineEastT,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).eastT
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineSouthT,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southT
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineCrossRoads,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).crossroads
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineNorthSouth,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).northStub
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineNorthSouth,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).southStub
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineEastWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).westStub
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineEastWest,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).eastStub
    },
    {
        voxelModelBuilder: (r)=>r.voxelModels.power.powerLineNorthSouth,
        pattern: (0, $1e58a7071d3cda74$export$115ceb706b6942b6).isolate
    }
];
function $9f1bd9f37b3f78db$var$getPowerlinePattern(game, x, y) {
    return (0, $1e58a7071d3cda74$export$2adb6bbc893073f4)(game, x, y, (ti)=>ti.elevatedZone === (0, $342158d303fb2c9a$export$2483f397fd596eb8).PowerLine || ti.zone === (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).CoalPowerPlant);
}
function $9f1bd9f37b3f78db$var$getModelBuilderForPattern(pattern) {
    for (const roadPattern of $9f1bd9f37b3f78db$var$patterns){
        if ((0, $1e58a7071d3cda74$export$cdded5b28a5f8c6d)(pattern, roadPattern.pattern)) return roadPattern.voxelModelBuilder;
    }
}
function $9f1bd9f37b3f78db$export$4cb6e9ca55ebac1d(gl, game, resources, r) {
    const powerlineBlueprint = (0, $b3c8824b30c2bc14$export$9019cecb15291502)((0, $b3c8824b30c2bc14$export$45dc1a8cad5d6800).PowerLine);
    for(let x = r.left - 1; x <= r.right + 1; x++)for(let y = r.top - 1; y <= r.bottom + 1; y++){
        if (x < 0 || x >= game.simulation.landscape.size || y < 0 || y >= game.simulation.landscape.size) continue;
        // only have the one texture for now
        const tileInfo = game.simulation.landscape.tileInfo[y][x];
        if (tileInfo.elevatedZone === (0, $342158d303fb2c9a$export$2483f397fd596eb8).PowerLine) {
            let wasPowered = null;
            if (tileInfo.building) {
                wasPowered = tileInfo.building.isPoweredByBuildingId;
                (0, $f3d92aebdafa46c7$export$5e760e49675dcec0)(game.simulation, tileInfo.building);
                tileInfo.building = null;
                game.powerlineModels[y][x] = null;
            }
            const pattern = $9f1bd9f37b3f78db$var$getPowerlinePattern(game, x, y);
            const builder = tileInfo.zone === (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).Road && tileInfo.textureIndex === (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadNorthSouth ? (r)=>r.voxelModels.power.powerLineRoadEastWest : tileInfo.zone === (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).Road && tileInfo.textureIndex === (0, $342158d303fb2c9a$export$1a3ef2e71e8411ab).RoadEastWest ? (r)=>r.voxelModels.power.powerLineRoadNorthSouth : $9f1bd9f37b3f78db$var$getModelBuilderForPattern(pattern);
            if (builder) {
                const model = builder(resources);
                const building = (0, $b3c8824b30c2bc14$export$1078ade21bd4346)(powerlineBlueprint, 1, 1, x, y, model.voxelCount);
                building.isPoweredByBuildingId = wasPowered;
                (0, $f3d92aebdafa46c7$export$4c8301bbafee0aac)(game.simulation, building);
                tileInfo.building = building;
                game.powerlineModels[y][x] = model;
            }
        }
    }
    const range = {
        start: {
            x: r.left - 1,
            y: r.top - 1
        },
        end: {
            x: r.right + 1,
            y: r.bottom + 1
        }
    };
    (0, $aeab7555fdde6942$export$efede7f0dce421e8)(gl, game, range);
}




function $df80fab6633169c0$export$fe5065f49728f769(gl, game, resources) {
    if ((0, $062f33e36c4b51df$export$823ce3235b6e647b)(game.gui.currentTool) && game.gui.selection !== null) $df80fab6633169c0$var$applyZoning(gl, game, resources);
    else if ((0, $062f33e36c4b51df$export$4c66c50cdfefffaa)(game.gui.currentTool) && game.gui.selection !== null) $df80fab6633169c0$var$applyElevatedZoning(gl, game, resources);
}
function $df80fab6633169c0$var$applyElevatedZoning(gl, game, resources) {
    const newZone = (0, $062f33e36c4b51df$export$71c8031283bc130e)(game.gui.currentTool);
    const r = (0, $96fe3a99b59d4e0f$export$5f8c1fa73181ace8)(game.gui.selection);
    for(let x = r.left; x <= r.right; x++){
        for(let y = r.top; y <= r.bottom; y++)if ((0, $062f33e36c4b51df$export$1d4d18fba3efd3d6)(game.gui.currentTool, game.simulation.landscape.tileInfo[y][x])) {
            game.simulation.landscape.tileInfo[y][x].elevatedZone;
            game.simulation.landscape.tileInfo[y][x].elevatedZone = newZone;
        }
    }
    if (newZone === (0, $342158d303fb2c9a$export$2483f397fd596eb8).PowerLine) (0, $9f1bd9f37b3f78db$export$4cb6e9ca55ebac1d)(gl, game, resources, r);
}
function $df80fab6633169c0$var$applyZoning(gl, game, resources) {
    const newZone = (0, $062f33e36c4b51df$export$d6c9745c2b081ac3)(game.gui.currentTool);
    const r = (0, $96fe3a99b59d4e0f$export$5f8c1fa73181ace8)(game.gui.selection);
    for(let x = r.left; x <= r.right; x++){
        for(let y = r.top; y <= r.bottom; y++)if ((0, $062f33e36c4b51df$export$1d4d18fba3efd3d6)(game.gui.currentTool, game.simulation.landscape.tileInfo[y][x])) {
            game.simulation.landscape.tileInfo[y][x].zone;
            game.simulation.landscape.tileInfo[y][x].zone = newZone;
        }
    }
    // We have to apply the road textures after we've laid the road down as they impact each other and their neighbours
    if (newZone === (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).Road) (0, $72a1f38ca33acb35$export$840a8d6bdf0270ff)(gl, game, r);
    else {
        const blueprint = (0, $b3c8824b30c2bc14$export$ef976d59635a0da0)(game.gui.currentTool);
        if (blueprint !== undefined) {
            const building = (0, $b3c8824b30c2bc14$export$973c9d96711656fc)(resources, blueprint, {
                x: r.left,
                z: r.top
            });
            //building.numberOfVoxelsToDisplay = 0
            (0, $f3d92aebdafa46c7$export$4c8301bbafee0aac)(game.simulation, building);
            // after we place a building we re-evaluate the orientation of the power line models as we might want to connect
            // some to the building
            (0, $9f1bd9f37b3f78db$export$4cb6e9ca55ebac1d)(gl, game, resources, {
                top: r.top - 1,
                left: r.left - 1,
                bottom: r.bottom + 1,
                right: r.right + 1
            });
        }
        (0, $aeab7555fdde6942$export$efede7f0dce421e8)(gl, game, game.gui.selection);
    }
}








function $35956835e794db6c$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.building);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            lightWorldPosition: gl.getUniformLocation(shaderProgram, "uLightWorldPosition"),
            opacity: gl.getUniformLocation(shaderProgram, "uOpacity")
        }
    };
}
function $35956835e794db6c$var$initPickerShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.objectPicking);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            objectIdColor: gl.getAttribLocation(shaderProgram, "aVertexColor")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix")
        }
    };
}
function $35956835e794db6c$export$692860202374aaa8(gl, resources) {
    const programInfo = $35956835e794db6c$var$initShaderProgram(gl, resources);
    const pickerProgramInfo = $35956835e794db6c$var$initPickerShaderProgram(gl, resources);
    const dispose = ()=>{};
    const render = (projectionMatrix, game)=>{
        if (!game.gui.layers.buildings) return;
        gl.useProgram(programInfo.program);
        const lightPosition = game.buildingLight.direction;
        game.simulation.buildings.forEach((building)=>{
            //for (const building of game.buildings.values()) {
            let worldMatrix = (0, $26675c4f95835ef1$exports).create();
            (0, $26675c4f95835ef1$exports).translate(worldMatrix, worldMatrix, [
                (building.position.x - game.simulation.landscape.size / 2) * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile - (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile / 2,
                0,
                (game.simulation.landscape.size / 2 - building.position.z) * (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile - (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile / 2 - (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile * (building.blueprint.footprint.height - 1)
            ]);
            const normalMatrix = (0, $26675c4f95835ef1$exports).create();
            (0, $26675c4f95835ef1$exports).invert(normalMatrix, worldMatrix);
            (0, $26675c4f95835ef1$exports).transpose(normalMatrix, normalMatrix);
            (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
                projectionMatrix: projectionMatrix,
                modelViewMatrix: worldMatrix,
                normalMatrix: normalMatrix,
                lightWorldPosition: lightPosition
            });
            let voxelOffset = 0;
            if (building.blueprint.powerGenerated === 0 && building.isPoweredByBuildingId === null) gl.uniform1f(programInfo.uniformLocations.opacity, game.powerPulse.opacity);
            else gl.uniform1f(programInfo.uniformLocations.opacity, 1.0);
            const model = game.powerlineModels[building.position.z][building.position.x] !== null ? game.powerlineModels[building.position.z][building.position.x] : (0, $b3c8824b30c2bc14$export$b973f82fe12e3bcf)(building)(resources);
            model.renderingModels.forEach((chunk)=>{
                const numberOfVoxelsInChunk = chunk.vertexCount / 36;
                const vertexCount = voxelOffset + numberOfVoxelsInChunk < building.numberOfVoxelsToDisplay ? chunk.vertexCount : (building.numberOfVoxelsToDisplay - voxelOffset) * 36;
                (0, $b125b9470601071f$export$f5a01205d395aca)(gl, chunk, programInfo);
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, chunk.indices);
                const type = gl.UNSIGNED_SHORT;
                const offset = 0;
                // The below will draw transparent buildings as a placeholder while they are, errr, building
                //if (vertexCount / 36 < building.model.voxelCount) {
                //  gl.uniform1f(programInfo.uniformLocations.opacity, 0.02)
                //  gl.drawElements(gl.TRIANGLES, chunk.vertexCount, type, offset)
                //}
                voxelOffset += numberOfVoxelsInChunk;
                if (vertexCount <= 0) return;
                gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
            });
        });
    };
    const renderObjectPicker = (projectionMatrix, game)=>{
        gl.useProgram(pickerProgramInfo.program);
        game.simulation.buildings.forEach((building)=>{
            let worldMatrix = (0, $26675c4f95835ef1$exports).create();
            (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, pickerProgramInfo, {
                projectionMatrix: projectionMatrix,
                modelViewMatrix: worldMatrix
            });
            const model = (0, $b3c8824b30c2bc14$export$b973f82fe12e3bcf)(building)(resources);
            model.renderingModels.forEach((chunk)=>{
                (0, $b125b9470601071f$export$f5a01205d395aca)(gl, chunk, pickerProgramInfo);
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, chunk.indices);
                const vertexCount = chunk.vertexCount;
                const type = gl.UNSIGNED_SHORT;
                const offset = 0;
                gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
            });
        });
    };
    return {
        dispose: dispose,
        render: render,
        renderObjectPicker: renderObjectPicker
    };
}




//let timeUntilNextVoxel = 1.0 / timings.buildSpeedVoxelsPerSecond
let $152362672951d95a$var$timeSinceLastConstruction = 0.0;
function $152362672951d95a$export$320aacbc688d11a1(simulation, resources, timeDelta) {
    $152362672951d95a$var$timeSinceLastConstruction += timeDelta;
    const voxelsToDraw = Math.floor($152362672951d95a$var$timeSinceLastConstruction * (0, $9ecda7333d28e490$export$1ffe7377828dbf0a).buildSpeedVoxelsPerSecond);
    if (voxelsToDraw > 0) {
        $152362672951d95a$var$timeSinceLastConstruction = 0;
        simulation.buildings.forEach((building)=>{
            const model = (0, $b3c8824b30c2bc14$export$b973f82fe12e3bcf)(building)(resources);
            if (building.numberOfVoxelsToDisplay < model.voxelCount) building.numberOfVoxelsToDisplay = Math.min(building.numberOfVoxelsToDisplay + voxelsToDraw, model.voxelCount);
        });
    }
}





function $057998c676b3b3cd$export$2afb1b9103ad2cdb(difficultyLevel, simulation) {
    const normalisedResidentialPopulation = simulation.population.residential / 8;
    const previousTotalPopulation = simulation.population.total;
    simulation.population.total = normalisedResidentialPopulation + simulation.population.industrial + simulation.population.commercial;
    const previousValves = simulation.valveHistory[1];
    const employment = normalisedResidentialPopulation > 0 ? (previousValves.commercial + previousValves.industrial) / normalisedResidentialPopulation : 1;
    const migration = normalisedResidentialPopulation * (employment - 1);
    const births = normalisedResidentialPopulation * 0.02;
    const projectedResidentialPopulation = normalisedResidentialPopulation + migration + births;
    const laborBase = Math.max(Math.min(1.3, previousValves.commercial + previousValves.industrial > 0 ? previousValves.residential / (previousValves.commercial + previousValves.residential) : 1), 0);
    const internalMarket = (normalisedResidentialPopulation + simulation.population.commercial + simulation.population.industrial) / 3.7;
    const projectedCommercialPopulation = internalMarket * laborBase;
    const difficultyMultiplier = difficultyLevel === (0, $bd101182371a0deb$export$dcb506b218208434).Easy ? 1.2 : difficultyLevel === (0, $bd101182371a0deb$export$dcb506b218208434).Medium ? 1.0 : 0.98;
    const projectedIndustrialPopulation = simulation.population.industrial * laborBase * difficultyMultiplier;
    let rRatio = Math.min(normalisedResidentialPopulation > 0 ? projectedResidentialPopulation / normalisedResidentialPopulation : 1.3, 2);
    let cRatio = Math.min(simulation.population.commercial > 0 ? projectedCommercialPopulation / simulation.population.commercial : projectedCommercialPopulation, 2);
    let iRatio = Math.min(simulation.population.industrial > 0 ? projectedIndustrialPopulation / simulation.population.industrial : projectedIndustrialPopulation, 2);
    const taxLevel = Math.min(simulation.taxLevel + difficultyLevel, 20);
    rRatio = (rRatio - 1) * 600 + simulation.taxTable[taxLevel];
    cRatio = (cRatio - 1) * 600 + simulation.taxTable[taxLevel];
    iRatio = (iRatio - 1) * 600 + simulation.taxTable[taxLevel];
    if (rRatio > 0) {
        if (simulation.valves.residential < simulation.valveMaximums.residential) simulation.valves.residential += rRatio;
    }
    if (rRatio < 0) {
        if (simulation.valves.residential > -simulation.valveMaximums.residential) simulation.valves.residential += rRatio;
    }
    if (cRatio > 0) {
        if (simulation.valves.commercial < 1500) simulation.valves.commercial += cRatio;
    }
    if (cRatio < 0) {
        if (simulation.valves.commercial > -1500) simulation.valves.commercial += cRatio;
    }
    if (iRatio > 0) {
        if (simulation.valves.industrial < 1500) simulation.valves.industrial += iRatio;
    }
    if (iRatio < 0) {
        if (simulation.valves.industrial > -1500) simulation.valves.industrial += iRatio;
    }
    simulation.valves.residential = Math.max(Math.min(simulation.valves.residential, simulation.valveMaximums.residential), -simulation.valveMaximums.residential);
    simulation.valves.commercial = Math.max(Math.min(simulation.valves.commercial, simulation.valveMaximums.commercial), -simulation.valveMaximums.commercial);
    simulation.valves.industrial = Math.max(Math.min(simulation.valves.industrial, simulation.valveMaximums.industrial), -simulation.valveMaximums.industrial);
/*
  need to figure out how rescap works but not needed yet
  if ((ResCap) && (RValve > 0)) RValve = 0;	      Stad, Prt, Airprt
  if ((ComCap) && (CValve > 0)) CValve = 0;
  if ((IndCap) && (IValve > 0)) IValve = 0;
  ValveFlag = 1;
   */ }



function $87ce012e5f8a0009$export$1055328824c72529(simulation) {
    simulation.population = {
        ...(0, $b0f378f81618fc12$export$31292c3816ebd5b3)(),
        total: 0
    };
}


const $03a83c2a3e066496$var$gameYear = 336 // we just use an even set of month lengths that is divisable by 7 days
;
const $03a83c2a3e066496$var$gameMonth = $03a83c2a3e066496$var$gameYear / 12.0;
const $03a83c2a3e066496$var$gameWeek = $03a83c2a3e066496$var$gameMonth / 4.0;
const $03a83c2a3e066496$var$gameDay = $03a83c2a3e066496$var$gameWeek / 7.0;
const $03a83c2a3e066496$var$normalSpeedDayPerSecond = 1.0;
function $03a83c2a3e066496$export$b21aaedc1714f14d(simulation, timeDelta) {
    const previousDay = Math.floor(simulation.time.clock);
    simulation.time.clock += timeDelta * $03a83c2a3e066496$var$normalSpeedDayPerSecond;
    const isNewDay = Math.floor(simulation.time.clock) > previousDay;
    const isNewWeek = isNewDay ? Math.floor(simulation.time.clock) % $03a83c2a3e066496$var$gameWeek == 0 : false;
    const isNewMonth = isNewDay ? Math.floor(simulation.time.clock) % $03a83c2a3e066496$var$gameMonth == 0 : false;
    return {
        isNewDay: isNewDay,
        isNewWeek: isNewWeek,
        isNewMonth: isNewMonth
    };
}
function $03a83c2a3e066496$export$31803937850fb2da(simulation) {
    return 1900 + Math.floor(simulation.time.clock / $03a83c2a3e066496$var$gameYear);
}
function $03a83c2a3e066496$export$af5de1609f06c8e6(simulation) {
    return Math.floor(simulation.time.clock / $03a83c2a3e066496$var$gameMonth);
}


class $2b4fed7b72f1f70f$export$694e0d28c7ffc90c {
    push(item) {
        this.items.push(item);
    }
    peek() {
        return this.items[this.items.length - 1];
    }
    pop() {
        return this.items.pop();
    }
    get size() {
        return this.items.length;
    }
    constructor(){
        this.items = [];
    }
}



const $9fe7815de781c8d4$var$clearPoweredStatus = (landscape)=>{
    landscape.tileInfo.forEach((row)=>row.forEach((ti)=>{
            ti.wasPoweredByBuildingId = ti.isPoweredByBuildingId;
            ti.isPoweredByBuildingId = null;
            if (ti.building !== null) ti.building.isPoweredByBuildingId = null;
        }));
};
const $9fe7815de781c8d4$var$getPowerStations = (buildings)=>Array.from(buildings).filter(([buildingId, building])=>building.blueprint.powerGenerated > 0).map(([_, building])=>building);
const $9fe7815de781c8d4$var$isTileConductive = (landscape, x, z)=>{
    const ti = landscape.tileInfo[z][x];
    if (ti.elevatedZone === (0, $342158d303fb2c9a$export$2483f397fd596eb8).PowerLine) return true;
    switch(ti.zone){
        case (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).Road:
        case (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).None:
            return false;
        default:
            return ti.building !== null;
    }
};
// Walking the connected points on the power grid from a start point (a power station) can be thought of as flood fill
// only the boundaries are defined by a color like in an art program but instead by non-conductive zones.
// I'm using the scan line fill algorithm here.
// There is some nuance in this because we have two things going on:
//  1. Are tiles powered? Tiles are always 1x1
//  2. Are buildings powered? Buildings are of arbitrary sizes and powering a building means all the tiles under it
//     are powered
// We could just use buildings (as a tile can only be powered if it has a building on it - a power line is a building)
// but walking the set of buildings to determine if they are powered is awkward....
// So the complexity is we need to be able to "walk" through buildings in the flood fill.
// Another complexity is that if a tile is already powered by another station then we can't "fill" it and so we
// have to track what tiles have been visited (filled) by the current walk or we'll end up filling forever
const $9fe7815de781c8d4$var$walkPowerGrid = (landscape, powerStation)=>{
    let consumedPower = 0;
    const stack = new (0, $2b4fed7b72f1f70f$export$694e0d28c7ffc90c)();
    stack.push(powerStation.position);
    const tileVisited = Array.from({
        length: landscape.size
    }, ()=>new Array(landscape.size).fill(false));
    const canMoveToTile = (x, z)=>$9fe7815de781c8d4$var$isTileConductive(landscape, x, z) && !tileVisited[z][x];
    const onLastRow = (p)=>p.z === landscape.size - 1;
    const onFirstRow = (p)=>p.z === 0;
    const setPowered = (x, z)=>{
        const ti = landscape.tileInfo[z][x];
        const powerRequirements = ti.building?.blueprint.powerConsumed ?? 0;
        const canPower = powerRequirements + consumedPower <= powerStation.blueprint.powerGenerated;
        if (canPower) {
            if (ti.isPoweredByBuildingId === null) {
                consumedPower += powerRequirements;
                ti.isPoweredByBuildingId = powerStation.buildingId;
            }
            if (ti.building !== null && ti.building.isPoweredByBuildingId === null) ti.building.isPoweredByBuildingId = powerStation.buildingId;
        }
        return true;
    };
    while(stack.size > 0 && consumedPower < powerStation.blueprint.powerGenerated){
        const currentPosition = stack.pop();
        let startX = currentPosition.x;
        while(startX >= 0 && canMoveToTile(startX, currentPosition.z))startX--;
        startX++;
        let spanAbove = false;
        let spanBelow = false;
        while(startX < landscape.size && canMoveToTile(startX, currentPosition.z) && consumedPower < powerStation.blueprint.powerGenerated){
            tileVisited[currentPosition.z][startX] = true;
            setPowered(startX, currentPosition.z);
            if (!spanBelow && !onLastRow(currentPosition) && canMoveToTile(startX, currentPosition.z + 1)) {
                stack.push({
                    x: startX,
                    z: currentPosition.z + 1
                });
                spanBelow = true;
            } else if (spanBelow && !onLastRow(currentPosition) && !canMoveToTile(startX, currentPosition.z + 1)) spanBelow = false;
            if (!spanAbove && !onFirstRow(currentPosition) && canMoveToTile(startX, currentPosition.z - 1)) {
                stack.push({
                    x: startX,
                    z: currentPosition.z - 1
                });
                spanAbove = true;
            } else if (spanAbove && !onFirstRow(currentPosition) && !canMoveToTile(startX, currentPosition.z - 1)) spanAbove = false;
            startX++;
        }
    }
    return consumedPower;
};
function $9fe7815de781c8d4$export$8c98d6adc81aaf44(simulation) {
    $9fe7815de781c8d4$var$clearPoweredStatus(simulation.landscape);
    const powerStations = $9fe7815de781c8d4$var$getPowerStations(simulation.buildings);
    const totalPowerAvailable = powerStations.reduce((v, ps)=>v + ps.blueprint.powerGenerated, 0);
    const remainingPower = powerStations.reduce((remaining, powerStation)=>remaining - $9fe7815de781c8d4$var$walkPowerGrid(simulation.landscape, powerStation), totalPowerAvailable);
}


function $609edab1befc16c3$export$1e61084297db69ac(difficultyLevel, simulation, timeDelta) {
    const { isNewDay: isNewDay, isNewWeek: isNewWeek, isNewMonth: isNewMonth } = (0, $03a83c2a3e066496$export$b21aaedc1714f14d)(simulation, timeDelta);
    if (isNewDay) (0, $9fe7815de781c8d4$export$8c98d6adc81aaf44)(simulation);
    if (isNewWeek) console.log("W");
    // In the original game a month lasts around 8 seconds at normal speed and the valves update
    // roughly every 2 seconds
    (0, $057998c676b3b3cd$export$2afb1b9103ad2cdb)(difficultyLevel, simulation);
    (0, $87ce012e5f8a0009$export$1055328824c72529)(simulation);
}



const $7160910d6ffb32a6$var$radiansPerSecond = (0, $78ae820aa9ececfa$exports).toRadian(90);
function $7160910d6ffb32a6$var$updatePowerRendering(gl, game, timeDelta) {
    game.powerPulse.level += timeDelta * $7160910d6ffb32a6$var$radiansPerSecond;
    if (game.powerPulse.level > Math.PI * 2) game.powerPulse.level -= Math.PI * 2;
    game.powerPulse.opacity = (Math.sin(game.powerPulse.level) + 1) / 2 * 0.4 + 0.6;
    const landscape = game.simulation.landscape;
    let minZ = landscape.size;
    let minX = landscape.size;
    let maxZ = -1;
    let maxX = -1;
    for(let z = 0; z < landscape.size - 1; z++)for(let x = 0; x < landscape.size - 1; x++){
        const ti = landscape.tileInfo[z][x];
        if (ti.wasPoweredByBuildingId !== ti.isPoweredByBuildingId) {
            minZ = Math.min(z, minZ);
            minX = Math.min(x, minX);
            maxZ = Math.max(z, maxZ);
            maxX = Math.max(x, maxX);
        }
    }
    if (maxZ !== -1) (0, $aeab7555fdde6942$export$efede7f0dce421e8)(gl, game, {
        start: {
            x: minX,
            y: minZ
        },
        end: {
            x: maxX,
            y: maxZ
        }
    });
}
function $7160910d6ffb32a6$export$6cf89f8ea7b894c7(gl, resources, game, timeDelta) {
    (0, $609edab1befc16c3$export$1e61084297db69ac)(game.difficultyLevel, game.simulation, timeDelta);
    $7160910d6ffb32a6$var$updatePowerRendering(gl, game, timeDelta);
    (0, $d98d276fb2a2b90f$export$fd37dabcec2bc46f)(game, timeDelta);
    (0, $152362672951d95a$export$320aacbc688d11a1)(game.simulation, resources, timeDelta);
}







function $9d43aa835adcf834$var$initShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.water);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            vertexNormal: gl.getAttribLocation(shaderProgram, "aVertexNormal"),
            vertexColor: gl.getAttribLocation(shaderProgram, "aVertexColor"),
            objectInfo: gl.getAttribLocation(shaderProgram, "aObjectInfo")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix"),
            normalMatrix: gl.getUniformLocation(shaderProgram, "uNormalMatrix"),
            lightWorldPosition: gl.getUniformLocation(shaderProgram, "uLightWorldPosition"),
            opacity: gl.getUniformLocation(shaderProgram, "uOpacity"),
            zoom: gl.getUniformLocation(shaderProgram, "uZoom"),
            tileSize: gl.getUniformLocation(shaderProgram, "uTileSize"),
            voxelsPerTile: gl.getUniformLocation(shaderProgram, "uVoxelsPerTile"),
            waveOffset: gl.getUniformLocation(shaderProgram, "uWaveOffset")
        }
    };
}
function $9d43aa835adcf834$var$initPickerShaderProgram(gl, resources) {
    const shaderProgram = (0, $8ed303d5d07f367a$export$f7c2b6763dc47773)(gl, resources.shaderSource.objectPicking);
    if (!shaderProgram) return null;
    return {
        program: shaderProgram,
        attribLocations: {
            vertexPosition: gl.getAttribLocation(shaderProgram, "aVertexPosition"),
            objectIdColor: gl.getAttribLocation(shaderProgram, "aVertexColor")
        },
        uniformLocations: {
            projectionMatrix: gl.getUniformLocation(shaderProgram, "uProjectionMatrix"),
            modelViewMatrix: gl.getUniformLocation(shaderProgram, "uModelViewMatrix")
        }
    };
}
function $9d43aa835adcf834$export$514161a0d30b024(gl, resources) {
    const programInfo = $9d43aa835adcf834$var$initShaderProgram(gl, resources);
    const pickerProgramInfo = $9d43aa835adcf834$var$initPickerShaderProgram(gl, resources);
    const dispose = ()=>{};
    let time = 0;
    const render = (projectionMatrix, game, timeDelta)=>{
        time += timeDelta ?? 0;
        gl.useProgram(programInfo.program);
        const lightPosition = game.buildingLight.direction;
        let worldMatrix = (0, $26675c4f95835ef1$exports).create();
        const normalMatrix = (0, $26675c4f95835ef1$exports).create();
        (0, $26675c4f95835ef1$exports).invert(normalMatrix, worldMatrix);
        (0, $26675c4f95835ef1$exports).transpose(normalMatrix, normalMatrix);
        (0, $b125b9470601071f$export$9ed6815acb35f982)(gl, programInfo, {
            projectionMatrix: projectionMatrix,
            modelViewMatrix: worldMatrix,
            normalMatrix: normalMatrix,
            lightWorldPosition: lightPosition
        });
        gl.uniform1f(programInfo.uniformLocations.opacity, 1.0);
        gl.uniform1f(programInfo.uniformLocations.zoom, game.view.zoom);
        gl.uniform1f(programInfo.uniformLocations.tileSize, (0, $9ecda7333d28e490$export$c647cb0ee6e282fe).tile);
        gl.uniform1f(programInfo.uniformLocations.voxelsPerTile, 4.0);
        gl.uniform1f(programInfo.uniformLocations.waveOffset, time * 1.5 % 8);
        game.landscape.water.chunks.forEach((chunk)=>{
            const vertexCount = chunk.model.vertexCount;
            (0, $b125b9470601071f$export$f5a01205d395aca)(gl, chunk.model, programInfo);
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, chunk.model.indices);
            const type = gl.UNSIGNED_SHORT;
            const offset = 0;
            gl.drawElements(gl.TRIANGLES, vertexCount, type, offset);
        });
    };
    const renderObjectPicker = (projectionMatrix, game)=>{};
    return {
        dispose: dispose,
        render: render,
        renderObjectPicker: renderObjectPicker
    };
}




var $2725bdcb11510985$exports = {};
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $cmoHh = parcelRequire("cmoHh");

var $euRi5 = parcelRequire("euRi5");

var $hDsEw = parcelRequire("hDsEw");

var $3J2Zm = parcelRequire("3J2Zm");

var $6Px8M = parcelRequire("6Px8M");

var $lDm0S = parcelRequire("lDm0S");
var $d7e73366feb50558$exports = {};

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = "random", startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, "global" in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == "string" ? obj : obj + "\0";
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + "", smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (0, $d7e73366feb50558$exports) {
        $d7e73366feb50558$exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("kjyEk"));
        } catch (ex) {}
    } else if (typeof define == "function" && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math["seed" + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== "undefined" ? self : $d7e73366feb50558$exports, [], Math // math: package containing random, pow, and seedrandom
);


$d7e73366feb50558$exports.alea = $cmoHh;
$d7e73366feb50558$exports.xor128 = $euRi5;
$d7e73366feb50558$exports.xorwow = $hDsEw;
$d7e73366feb50558$exports.xorshift7 = $3J2Zm;
$d7e73366feb50558$exports.xor4096 = $6Px8M;
$d7e73366feb50558$exports.tychei = $lDm0S;
$2725bdcb11510985$exports = $d7e73366feb50558$exports;


const $3331afb51b5d992a$var$rnd = $2725bdcb11510985$exports() // seedrandom("hello.")
;
function $3331afb51b5d992a$export$4385e60b38654f68() {
    return $3331afb51b5d992a$var$rnd();
}
const $3331afb51b5d992a$var$flatter = false;
function $3331afb51b5d992a$export$27e4be73b865d901(size) {
    if (!$3331afb51b5d992a$var$isPowerOfTwo(size)) throw Error("Map sizes must be a power of two: 16, 32, 64, etc.");
    size++;
    let rows = $3331afb51b5d992a$var$getLevelTerrain(size);
    //rows = generateHills(rows, 0, size, 0, size) // whole map
    rows = $3331afb51b5d992a$var$generateHills(rows, 0, Math.ceil(size / 4), 0, Math.ceil(size / 4));
    rows = $3331afb51b5d992a$var$generateHills(rows, Math.ceil(size / 8), Math.ceil(size / 4) + Math.ceil(size / 8), Math.ceil(size / 8), Math.ceil(size / 4) + Math.ceil(size / 8));
    for(let i = 0; i < (0, $9ecda7333d28e490$export$871de8747c9eaa88).smoothingIterations; i++)rows = $3331afb51b5d992a$var$smooth(rows);
    const tileInfos = [];
    const heights = rows.map((row)=>row.map((h)=>h * (0, $9ecda7333d28e490$export$871de8747c9eaa88).unitRenderHeight));
    for(let y = 0; y < size - 1; y++){
        const row = [];
        for(let x = 0; x < size - 1; x++){
            const isFlat = heights[y][x] == heights[y][x + 1] && heights[y][x] == heights[y + 1][x] && heights[y][x] == heights[y + 1][x + 1];
            row.push({
                terrain: x >= 126 && x <= 132 && y >= 124 && y <= 132 ? (0, $342158d303fb2c9a$export$9b9b94eedad86502).Water : (0, $342158d303fb2c9a$export$9b9b94eedad86502).Plain,
                //terrain: x >= 10 && x <= 132 && y >= 10 && y <= 132 ? TerrainTypeEnum.Water : TerrainTypeEnum.Plain,
                //terrain: TerrainTypeEnum.Plain,
                zone: (0, $342158d303fb2c9a$export$d6725ccf2a601a8d).None,
                elevatedZone: (0, $342158d303fb2c9a$export$2483f397fd596eb8).None,
                isFlat: isFlat,
                textureIndex: null,
                isPoweredByBuildingId: null,
                wasPoweredByBuildingId: null,
                building: null,
                accruingGrowthScore: 0,
                baselineGrowthScore: 0
            });
        }
        tileInfos.push(row);
    }
    return {
        tileInfo: tileInfos,
        size: size,
        heights: heights
    };
}
function $3331afb51b5d992a$var$generateHills(rows, fromX, toX, fromY, toY) {
    const randomStartingHeight = ()=>0 // getHeight(0, map.maxHeight)
    ;
    //rows[0][0] = randomHeight()
    //rows[0][size - 1] = randomHeight()
    //rows[size - 1][0] = randomHeight()
    //rows[size - 1][size - 1] = randomHeight()
    // set the corners
    if (rows[fromX][fromY] === 0) rows[fromX][fromY] = randomStartingHeight();
    if (rows[fromX][toY - 1] === 0) rows[fromX][toY - 1] = randomStartingHeight();
    if (rows[toX - 1][fromY] === 0) rows[toX - 1][fromY] = randomStartingHeight();
    if (rows[toX - 1][toY - 1] === 0) rows[toX - 1][toY - 1] = randomStartingHeight();
    $3331afb51b5d992a$var$recursivelyFill(rows, fromX, toX - 1, fromY, toY - 1);
    return rows;
}
function $3331afb51b5d992a$var$smooth(heightMap) {
    const width = heightMap.length;
    const height = heightMap[0].length;
    const smoothedMap = Array.from(Array(width), ()=>Array(height).fill(0));
    for(let x = 1; x < width - 1; x++)for(let y = 1; y < height - 1; y++){
        let sum = 0;
        for(let offsetX = -1; offsetX <= 1; offsetX++)for(let offsetY = -1; offsetY <= 1; offsetY++)sum += heightMap[x + offsetX][y + offsetY];
        // Average of the current cell and its neighbors
        // floor will leave more flat areas
        // round will tend towards more up and down
        smoothedMap[x][y] = Math.floor(sum / 9);
    }
    return smoothedMap;
}
function $3331afb51b5d992a$var$recursivelyFill(rows, fromX, toX, fromY, toY) {
    $3331afb51b5d992a$var$diamondStep(rows, fromX, toX, fromY, toY);
    $3331afb51b5d992a$var$squareStep(rows, fromX, toX, fromY, toY);
    const xLen = (toX - fromX) / 2;
    const yLen = (toY - fromY) / 2;
    if (xLen === 1 || yLen === 1) return;
    for(let newY = fromY; newY < toY; newY += yLen)for(let newX = fromX; newX < toX; newX += xLen)$3331afb51b5d992a$var$recursivelyFill(rows, newX, newX + xLen, newY, newY + yLen);
}
function $3331afb51b5d992a$var$getHeight(minimumHeight, maximumHeight) {
    return $3331afb51b5d992a$var$flatter ? Math.round($3331afb51b5d992a$export$4385e60b38654f68() / 2 * (maximumHeight - minimumHeight) + minimumHeight) : Math.round($3331afb51b5d992a$export$4385e60b38654f68() * (maximumHeight - minimumHeight) + minimumHeight);
}
function $3331afb51b5d992a$var$diamondStep(rows, fromX, toX, fromY, toY) {
    const neighbours = [
        rows[fromY][fromX],
        rows[fromY][toX],
        rows[toY][fromX],
        rows[toY][toX]
    ];
    const centerX = (toX - fromX) / 2 + fromX;
    const centerY = (toY - fromY) / 2 + fromY;
    let lowestNeighbour = Math.min(...neighbours);
    let highestNeighbour = Math.max(...neighbours);
    let cost = centerY - fromY;
    let leftDistance = toX - fromX;
    let leftX = centerX - leftDistance;
    if (leftX > 0) {
        let leftStep = rows[centerY][leftX];
        if (leftStep < lowestNeighbour) {
            lowestNeighbour = leftStep;
            cost = leftDistance;
        }
        if (leftStep > highestNeighbour) {
            highestNeighbour = leftStep;
            cost = leftDistance;
        }
    }
    const topDistance = toY - fromY;
    let topY = centerY - topDistance;
    if (topY > 0) {
        let topStep = rows[topY][centerX];
        if (topStep < lowestNeighbour) {
            lowestNeighbour = topStep;
            cost = topDistance;
        } else if (topStep > highestNeighbour) {
            highestNeighbour = topStep;
            cost = topDistance;
        }
    }
    const maximumHeight = lowestNeighbour + cost;
    const minimumHeight = highestNeighbour - cost;
    const newValue = $3331afb51b5d992a$var$getHeight(minimumHeight, maximumHeight);
    rows[centerY][centerX] = Math.min((0, $9ecda7333d28e490$export$871de8747c9eaa88).maxHeight, Math.max(0, newValue));
}
function $3331afb51b5d992a$var$squareStep(rows, fromX, toX, fromY, toY) {
    const distance = (toX - fromX) / 2;
    const centerX = (toX - fromX) / 2 + fromX;
    const centerY = (toY - fromY) / 2 + fromY;
    function getNewSquareValue(v1, v2, v3) {
        const lowestNeighbour = Math.min(v1, v2, v3);
        const highestNeighbour = Math.max(v1, v2, v3);
        const maximumHeight = Math.min((0, $9ecda7333d28e490$export$871de8747c9eaa88).maxHeight, lowestNeighbour + distance) // maximum is 1 unit per tile increase from lowest neighbour
        ;
        const minimumHeight = Math.max(0, highestNeighbour - distance) // minimum is 1 unit per tile down from hieghest newighbour
        ;
        return $3331afb51b5d992a$var$getHeight(minimumHeight, maximumHeight);
    }
    const centerValue = rows[centerY][centerX];
    const topLeftValue = rows[fromY][fromX];
    const topRightValue = rows[fromY][toX];
    const bottomLeftValue = rows[toY][fromX];
    const bottomRightValue = rows[toY][toX];
    const topValue = getNewSquareValue(topLeftValue, topRightValue, centerValue);
    const leftValue = getNewSquareValue(topLeftValue, bottomLeftValue, centerValue);
    const bottomValue = getNewSquareValue(bottomLeftValue, bottomRightValue, centerValue);
    const rightValue = getNewSquareValue(topRightValue, bottomRightValue, centerValue);
    rows[fromY][centerX] = topValue;
    rows[toY][centerX] = bottomValue;
    rows[centerY][fromX] = leftValue;
    rows[centerY][toX] = rightValue;
}
function $3331afb51b5d992a$var$getLevelTerrain(size) {
    const rows = [];
    for(let y = 0; y < size; y++){
        const row = [];
        for(let x = 0; x < size; x++)row.push(0);
        rows.push(row);
    }
    return rows;
}
function $3331afb51b5d992a$var$isPowerOfTwo(n) {
    return n > 0 && (n & n - 1) === 0;
}


function $3a67941509983683$export$b5ae43e0dad5dc51(gl, resources) {
    let tileRenderer = (0, $3b85c34af31bdb96$export$b4d03d0dcd77df78)(gl, resources);
    let buildingRenderer = (0, $35956835e794db6c$export$692860202374aaa8)(gl, resources);
    let waterRenderer = (0, $9d43aa835adcf834$export$514161a0d30b024)(gl, resources);
    let objectPickerRenderer = (0, $bdba9a3cd2da2555$export$382274dfff412583)(gl, resources, (projectionMatrix, game)=>{
        tileRenderer.renderObjectPicker(projectionMatrix, game);
        gui.renderObjectPicker();
    });
    let rootRenderer = (0, $4201279bb1ce70f6$export$230dc02396b6bf57)(gl, resources, (projectionMatrix, game, timeDelta)=>{
        tileRenderer.render(projectionMatrix, game);
        waterRenderer.render(projectionMatrix, game, timeDelta);
        buildingRenderer.render(projectionMatrix, game);
    });
    const simulationLandscape = (0, $3331afb51b5d992a$export$27e4be73b865d901)(256);
    const rendererLandscape = (0, $aeab7555fdde6942$export$124d1786ae41597c)(gl, simulationLandscape);
    const game = (0, $bd101182371a0deb$export$b112baf41a575b61)(simulationLandscape, rendererLandscape);
    for(let bi = 0; bi < 1; bi++);
    let gui = (0, $76b671ed1fa99c76$export$c0571035d9f2a28d)(gl, resources, gl.canvas.width, gl.canvas.height, ()=>(0, $27d32ecc35619740$export$39b88487f54d0231)(game), (name)=>resources.guiTextures[name], game.simulation.landscape.size * game.simulation.landscape.size + 1);
    // we use different light directions to get the effect we want
    game.light.direction = (0, $ab7f6dc0910e1ef7$exports).fromValues(-1, -0.5, -0.5) // this is a direction if we use a directional light
    ;
    game.buildingLight.direction = (0, $ab7f6dc0910e1ef7$exports).fromValues(-1, -1.5, -0.5);
    (0, $42e66745a803db06$export$6ff9e6a1f2205960)(game.controlState.current);
    (0, $b1f5dc8e9ea362b8$export$10a20274f2224dff)(game.controlState.current);
    let isFirst = true;
    let then = 0;
    let deltaTime = 0;
    return {
        resize: ()=>{
            rootRenderer.dispose();
            tileRenderer.dispose();
            waterRenderer.dispose();
            buildingRenderer.dispose();
            objectPickerRenderer.dispose();
            gui.dispose();
            tileRenderer = (0, $3b85c34af31bdb96$export$b4d03d0dcd77df78)(gl, resources);
            buildingRenderer = (0, $35956835e794db6c$export$692860202374aaa8)(gl, resources);
            waterRenderer = (0, $9d43aa835adcf834$export$514161a0d30b024)(gl, resources);
            rootRenderer = (0, $4201279bb1ce70f6$export$230dc02396b6bf57)(gl, resources, (projectionMatrix, game, timeDelta)=>{
                tileRenderer.render(projectionMatrix, game);
                waterRenderer.render(projectionMatrix, game, timeDelta);
                buildingRenderer.render(projectionMatrix, game);
            });
            gui = (0, $76b671ed1fa99c76$export$c0571035d9f2a28d)(gl, resources, gl.canvas.width, gl.canvas.height, ()=>(0, $27d32ecc35619740$export$39b88487f54d0231)(game), (name)=>resources.guiTextures[name], game.simulation.landscape.size * game.simulation.landscape.size + 1);
            objectPickerRenderer = (0, $bdba9a3cd2da2555$export$382274dfff412583)(gl, resources, (projectionMatrix, game)=>{
                tileRenderer.renderObjectPicker(projectionMatrix, game);
                gui.renderObjectPicker();
            });
        },
        update: (now)=>{
            if (isFirst) {
                resources.soundEffects.bootUp();
                then = now * 0.001;
                isFirst = false;
                return;
            }
            now *= 0.001 // convert to seconds
            ;
            deltaTime = now - then;
            then = now;
            (0, $7160910d6ffb32a6$export$6cf89f8ea7b894c7)(gl, resources, game, deltaTime);
            const guiHandledInteraction = gui.applyControlState(game.controlState.current, deltaTime, objectPickerRenderer.getObjectId());
            $3a67941509983683$var$applyRotation(game, deltaTime);
            rootRenderer.render(game, deltaTime, (0, $4201279bb1ce70f6$export$266137087bc184a6).None);
            gui.render();
            objectPickerRenderer.render(game, deltaTime);
            if (!guiHandledInteraction) {
                if (game.controlState.current.mouseButtons.left) {
                    game.selectedObjectId = objectPickerRenderer.getObjectId();
                    const toolMode = (0, $062f33e36c4b51df$export$774dc1e17bc20c30)(game.gui.currentTool);
                    if (toolMode !== (0, $bd101182371a0deb$export$ddbdda658d7cd694).None) {
                        const p = (0, $96fe3a99b59d4e0f$export$79fe3c21609d3982)(game.selectedObjectId, game.simulation.landscape.size);
                        if (game.gui.selection === null) switch(toolMode){
                            case (0, $bd101182371a0deb$export$ddbdda658d7cd694).Prefab:
                                const blueprint = (0, $b3c8824b30c2bc14$export$ef976d59635a0da0)(game.gui.currentTool);
                                if (blueprint) game.gui.selection = {
                                    start: {
                                        ...p
                                    },
                                    end: {
                                        x: p.x + blueprint.footprint.width - 1,
                                        y: p.y + blueprint.footprint.height - 1
                                    }
                                };
                                break;
                            default:
                                game.gui.selection = {
                                    start: {
                                        ...p
                                    },
                                    end: {
                                        ...p
                                    }
                                };
                        }
                        else switch(toolMode){
                            case (0, $bd101182371a0deb$export$ddbdda658d7cd694).Prefab:
                                const w = game.gui.selection.end.x - game.gui.selection.start.x;
                                const h = game.gui.selection.end.y - game.gui.selection.start.y;
                                game.gui.selection.start = {
                                    ...p
                                };
                                game.gui.selection.end.x = p.x + w;
                                game.gui.selection.end.y = p.y + h;
                                break;
                            case (0, $bd101182371a0deb$export$ddbdda658d7cd694).Range:
                                if ((0, $062f33e36c4b51df$export$e0afb1a06840e23d)(game.gui.currentTool)) {
                                    if (game.gui.selection.end.x !== game.gui.selection.start.x) game.gui.selection.end.x = p.x;
                                    else if (game.gui.selection.end.y !== game.gui.selection.start.y) game.gui.selection.end.y = p.y;
                                    else if (p.x !== game.gui.selection.start.x && p.y !== game.gui.selection.start.y) game.gui.selection.end.x = p.x;
                                    else game.gui.selection.end = {
                                        ...p
                                    };
                                } else game.gui.selection.end = {
                                    ...p
                                };
                                break;
                            case (0, $bd101182371a0deb$export$ddbdda658d7cd694).Single:
                                game.gui.selection = {
                                    start: {
                                        ...p
                                    },
                                    end: {
                                        ...p
                                    }
                                };
                                break;
                        }
                    }
                }
                if (!game.controlState.current.mouseButtons.left && game.controlState.previous.mouseButtons.left) {
                    (0, $df80fab6633169c0$export$fe5065f49728f769)(gl, game, resources);
                    if ((0, $062f33e36c4b51df$export$33310c7323b98d23)(game.gui.currentTool)) game.gui.selection = null;
                }
            }
            (0, $d98d276fb2a2b90f$export$c02e7eb66ba9b6a7)(game);
            return null;
        }
    };
}
function $3a67941509983683$var$rotateCameraAroundY(game, toApply) {
    const centerToEye = (0, $ab7f6dc0910e1ef7$exports).create();
    (0, $ab7f6dc0910e1ef7$exports).subtract(centerToEye, game.view.position, game.view.lookAt);
    let rotationMatrix = (0, $26675c4f95835ef1$exports).create();
    (0, $26675c4f95835ef1$exports).rotateY(rotationMatrix, rotationMatrix, (0, $78ae820aa9ececfa$exports).toRadian(toApply));
    let rotatedCenterToEye = (0, $ab7f6dc0910e1ef7$exports).create();
    (0, $ab7f6dc0910e1ef7$exports).transformMat4(rotatedCenterToEye, centerToEye, rotationMatrix);
    let newEye = (0, $ab7f6dc0910e1ef7$exports).create();
    (0, $ab7f6dc0910e1ef7$exports).add(newEye, game.view.lookAt, rotatedCenterToEye);
    game.view.position = newEye;
}
function $3a67941509983683$var$applyRotation(game, deltaTime) {
    const rotationSpeedDegreesPerSecond = 180;
    if (game.view.targetRotation !== null) {
        let toApply = rotationSpeedDegreesPerSecond * deltaTime;
        if (game.view.targetRotation > game.view.rotation) {
            if (game.view.rotation + toApply >= game.view.targetRotation) {
                toApply = game.view.targetRotation - game.view.rotation;
                game.view.targetRotation = null;
            }
            game.view.rotation += toApply;
            $3a67941509983683$var$rotateCameraAroundY(game, toApply);
        } else if (game.view.targetRotation < game.view.rotation) {
            let toApply = rotationSpeedDegreesPerSecond * deltaTime;
            if (game.view.rotation - toApply <= game.view.targetRotation) {
                toApply = game.view.rotation - game.view.targetRotation;
                game.view.targetRotation = null;
            }
            game.view.rotation -= toApply;
            $3a67941509983683$var$rotateCameraAroundY(game, -toApply);
        } else game.view.targetRotation = null;
    }
}


Number.prototype.isBitSet = function(bit) {
    return (this & 1 << bit) > 0;
};
Number.prototype.getBitRange = function(startIndex, size) {
    return this >> startIndex & (1 << size) - 1;
};
Number.prototype.flipBitRange = function(startIndex, size) {
    return this >> startIndex & (1 << size) - 1 ^ (1 << size) - 1;
};
Number.prototype.setBitRange = function(startIndex, size, value) {
    const mask = (1 << size) - 1;
    return this & ~(mask << startIndex) | (value & mask) << startIndex;
};
Number.prototype.clearBitRange = function(startIndex, size) {
    const mask = (1 << size) - 1;
    return this & ~(mask << startIndex);
};
String.prototype.capitalize = function() {
    const lower = this.toLowerCase();
    return `${this.charAt(0).toUpperCase()}${lower.slice(1)}`;
};


async function $d697ff602b899504$var$mount(viewCanvas) {
    function setSize() {
        viewCanvas.width = viewCanvas.clientWidth;
        viewCanvas.height = viewCanvas.clientHeight;
    }
    const urlSearchParams = new URLSearchParams(window.location.search);
    const gl = viewCanvas.getContext("webgl2", {
        antialias: true
    });
    if (gl === null) {
        console.error("Your browser doesn't support WebGL 2");
        return;
    }
    const resources = await (0, $899aa7500e099a06$export$d3d08d944062d7e)(gl);
    setSize();
    let scene = (0, $3a67941509983683$export$b5ae43e0dad5dc51)(gl, resources);
    let resizeDebounce = undefined;
    window.addEventListener("resize", (ev)=>{
        clearTimeout(resizeDebounce);
        resizeDebounce = setTimeout(()=>{
            setSize();
            scene.resize();
        }, 100);
    });
    function render(now) {
        scene = scene.update(now) ?? scene;
        requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
}
(async ()=>await $d697ff602b899504$var$mount(document.getElementById("canvas")))();


//# sourceMappingURL=index.27625231.js.map
